<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader :loading="!flagNav" transition="scale-transition" max-height="64" type="table-heading">
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ $t('mobileConfigurations') }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>
      <v-card class="bs" style="margin-top: 1rem">
        <div>
          <!-- Configuration Tabs -->
          <div class="configuration-tabs-bar px-4">
            <v-tabs v-model="activeTab" bg-color="transparent" color="black" class="configuration-tabs">
              <v-tab>{{ $t('mainConfiguration') }}</v-tab>
              <v-tab>{{ $t('suggestionFeature') }}</v-tab>
              <v-tab>{{ $t('suggestionQuestion') }}</v-tab>
              <v-tab>{{ $t('genieAICharacter') }}</v-tab>
              <v-tab>{{ $t('geniePrefix') }}</v-tab>
              <v-tab>{{ $t('wakeWord') }}</v-tab>
            </v-tabs>
            <v-btn
              color="#4E3982"
              variant="outlined"
              class="history-log-button text-none"
              prepend-icon="mdi-history"
              :disabled="!configurationId"
              @click="openHistoryLog"
            >
              History Log
            </v-btn>
          </div>

          <v-window v-model="activeTab" :transition="false" :reverse-transition="false">
            <!-- Main Configuration Tab -->
            <v-window-item>
              <v-row style="padding: 25px" class="preview-split-row">
                <!-- Configuration Form -->
                <v-col cols="12" md="7" class="split-form-col">
                  <!-- Loading Skeleton for Main Configuration -->
                  <v-skeleton-loader v-if="loading" type="card" class="mb-4"></v-skeleton-loader>
                  <v-skeleton-loader v-if="loading" type="card" class="mb-4"></v-skeleton-loader>
                  <v-skeleton-loader v-if="loading" type="card" class="mb-4"></v-skeleton-loader>
                  <v-skeleton-loader v-if="loading" type="actions" class="mb-4"></v-skeleton-loader>

                  <!-- Configuration Content (only show when not loading) -->
                  <div v-else>
                    <!-- Language Configuration -->
                    <div class="mb-4">
                      <div class="d-flex justify-space-between align-center">
                        <h3 class="language-config-title">{{ $t('languageConfiguration') }}</h3>
                        <div style="flex-grow: 1" class="gradient-bar ml-2"></div>
                      </div>
                      <p class="language-config-subtitle">{{ $t('selectLanguageToInteract') }}</p>

                      <div class="language-switches">
                        <div class="language-option">
                          <v-switch inset v-model="config.languages.thai" :label="$t('thai')" color="#4E3982" hide-details :disabled="!canEdit"></v-switch>
                        </div>
                        <div class="language-option">
                          <v-switch inset v-model="config.languages.english" :label="$t('english')" color="#4E3982" hide-details :disabled="!canEdit"></v-switch>
                        </div>
                        <div class="language-option">
                          <v-switch inset v-model="config.languages.chinese" :label="$t('chinese')" color="#4E3982" hide-details :disabled="!canEdit"></v-switch>
                        </div>
                      </div>
                    </div>

                    <!-- Always Human Mode -->
                    <div class="mb-4">
                      <div class="d-flex justify-space-between align-center">
                        <h3 class="language-config-title">{{ $t('alwaysHumanModeConfiguration') }}</h3>

                        <div style="flex-grow: 1" class="gradient-bar ml-2"></div>
                      </div>
                      <p class="language-config-subtitle">{{ $t('alwaysHumanModeConfigurationDesc') }}</p>

                      <div class="language-switches">
                        <div class="language-option">
                          <v-switch inset v-model="config.humanMode" :label="$t('enable')" color="#4E3982" hide-details :disabled="!canEdit"></v-switch>
                        </div>
                      </div>
                    </div>

                    <!-- Voice Function Configuration -->
                    <div class="mb-4">
                      <div class="d-flex justify-space-between align-center">
                        <h3 class="language-config-title">{{ $t('voiceFunctionConfiguration') }}</h3>
                        <div style="flex-grow: 1" class="gradient-bar ml-2"></div>
                      </div>
                      <p class="language-config-subtitle">{{ $t('enableDisableVoiceFunction') }}</p>

                      <div class="language-switches">
                        <div class="language-option">
                          <v-switch inset v-model="config.voice.enabled" :label="$t('enableVoice')" color="#4E3982" hide-details :disabled="!canEdit"></v-switch>
                        </div>

                        <div v-if="config.voice.enabled">
                          <div class="language-option">
                            <v-radio-group v-model="config.voice.type" row hide-details :disabled="!canEdit">
                              <v-radio value="tts" label="TTS" color="#4E3982"></v-radio>
                              <v-radio value="realTime" :label="$t('realTime')" color="#4E3982"></v-radio>
                            </v-radio-group>
                          </div>

                          <div class="voice-system-prompt-section mt-3 ml-4" v-if="config.voice.textToSpeechType !== 'gemini'">
                            <label class="voice-prompt-label">{{ $t('voiceSystemPrompt') || 'Voice System Prompt' }}</label>
                            <v-textarea
                              v-model="config.voice.systemPrompt"
                              :placeholder="$t('inputVoiceSystemPrompt') || 'Input system prompt'"
                              variant="plain"
                              density="compact"
                              rows="4"
                              :maxlength="10000"
                              hide-details="false"
                              class="voice-prompt-textarea"
                              :disabled="!canEdit"
                            ></v-textarea>
                            <div style="display: flex; justify-content: flex-end; width: 100%">
                              <span style="color: gray">{{ config.voice.systemPrompt.length }}/10000</span>
                            </div>
                          </div>
                          <div class="voice-system-prompt-section mt-3 ml-4" v-else>
                            <label class="voice-prompt-label">{{ $t('geminiVoiceSystemPrompt') || 'Gemini Voice System Prompt' }}</label>
                            <v-textarea
                              v-model="config.voice.geminiSystemPrompt"
                              :placeholder="$t('inputGeminiVoiceSystemPrompt') || 'Input system prompt'"
                              variant="plain"
                              density="compact"
                              rows="4"
                              :maxlength="10000"
                              hide-details="false"
                              class="voice-prompt-textarea"
                              :disabled="!canEdit"
                            ></v-textarea>
                            <div style="display: flex; justify-content: flex-end; width: 100%">
                              <span style="color: gray">{{ config.voice.geminiSystemPrompt.length }}/10000</span>
                            </div>
                          </div>

                          <!-- Speech to Text / Text to Speech Configuration -->
                          <v-row class="mt-3 ml-4" no-gutters>
                            <v-col cols="6" class="d-flex align-center">
                              <label class="voice-prompt-label mr-2">Speech to Text</label>
                              <v-radio-group v-model="config.voice.speechToTextType" row hide-details :disabled="!canEdit" class="mt-0">
                                <v-radio value="device" label="Device" color="#4E3982"></v-radio>
                                <v-radio value="azure" label="Azure Speech" color="#4E3982"></v-radio>
                                <!-- App asks POST /api/v1/LHB/GetGoogleSTTV2TokenLHB for an access token, settings in Setup → Speech to Text -->
                                <v-radio value="googleV2" label="Google STT V2" color="#4E3982"></v-radio>
                              </v-radio-group>
                            </v-col>
                            <v-col cols="6" class="d-flex align-center">
                              <label class="voice-prompt-label mr-2">Text to Speech</label>
                              <v-radio-group v-model="config.voice.textToSpeechType" row hide-details :disabled="!canEdit" class="mt-0">
                                <v-radio value="default" label="Default" color="#4E3982"></v-radio>
                                <v-radio value="gemini" label="Gemini" color="#4E3982"></v-radio>
                              </v-radio-group>
                            </v-col>
                          </v-row>

                          <!-- Voice Config Selection -->
                          <v-row class="mt-3 ml-4" no-gutters>
                            <v-col cols="12">
                              <v-select
                                v-model="config.voice.voiceConfigurationId"
                                :items="voiceConfigOptions"
                                :item-title="voiceConfigItemTitle"
                                item-value="id"
                                label="Voice Config"
                                variant="outlined"
                                density="comfortable"
                                clearable
                                hide-details
                                class="modern-input"
                                style="max-width: 400px"
                                :disabled="!canEdit"
                              ></v-select>
                              <div class="mt-1" style="font-size: 13px; color: gray">
                                <span v-if="voiceConfigOptions.length">Which voice settings bundle this mode uses. Leave empty to use none.</span>
                                <span v-else>No voice configuration exists yet — create one in LH Bank Configuration › Voice Configs.</span>
                              </div>
                            </v-col>
                          </v-row>

                          <!-- End-of-speech Detection Configuration -->
                          <div class="language-option mt-3 ml-4">
                            <label class="voice-prompt-label">End-of-speech Detection (milliseconds)</label>
                            <v-text-field
                              v-model.number="config.voice.endOfSpeechDetection"
                              type="number"
                              placeholder="Enter timeout in milliseconds"
                              variant="outlined"
                              density="compact"
                              :rules="endOfSpeechDetectionRules"
                              class="modern-input"
                              style="max-width: 300px"
                              min="0"
                              @keypress="allowOnlyPositiveNumbers"
                              :disabled="!canEdit"
                            ></v-text-field>
                          </div>

                          <!-- TTS Configuration Fields (Hidden — set v-if to true to re-enable) -->
                          <template v-if="false">
                          <!-- Reformat For TTS Prompt -->
                          <div class="voice-system-prompt-section mt-3 ml-4">
                            <label class="voice-prompt-label">Reformat For TTS Prompt</label>
                            <v-textarea
                              v-model="config.voice.reformatForTTSPrompt"
                              placeholder="Enter prompt for reformatting text for TTS (spoken language)"
                              variant="plain"
                              density="compact"
                              rows="6"
                              :maxlength="10000"
                              hide-details="false"
                              class="voice-prompt-textarea"
                            ></v-textarea>
                            <div style="display: flex; justify-content: flex-end; width: 100%">
                              <span style="color: gray">{{ (config.voice.reformatForTTSPrompt || '').length }}/10000</span>
                            </div>
                          </div>

                          <!-- Format For TTS Engine Prompt -->
                          <div class="voice-system-prompt-section mt-3 ml-4">
                            <label class="voice-prompt-label">Format For TTS Engine Prompt (SSML)</label>
                            <v-textarea
                              v-model="config.voice.formatForTTSEnginePrompt"
                              placeholder="Enter prompt for formatting text with SSML for TTS engine"
                              variant="plain"
                              density="compact"
                              rows="6"
                              :maxlength="10000"
                              hide-details="false"
                              class="voice-prompt-textarea"
                            ></v-textarea>
                            <div style="display: flex; justify-content: flex-end; width: 100%">
                              <span style="color: gray">{{ (config.voice.formatForTTSEnginePrompt || '').length }}/10000</span>
                            </div>
                          </div>

                          <!-- TTS Model Configuration -->
                          <div class="language-option mt-3 ml-4">
                            <label class="voice-prompt-label">TTS Model</label>
                            <v-text-field
                              v-model="config.voice.ttsModel"
                              placeholder="e.g., gpt-5-chat, gpt-4o"
                              variant="outlined"
                              density="compact"
                              class="modern-input"
                              style="max-width: 300px"
                              hide-details
                            ></v-text-field>
                          </div>

                          <!-- TTS API Version Configuration -->
                          <div class="language-option mt-3 ml-4">
                            <label class="voice-prompt-label">TTS API Version</label>
                            <v-text-field
                              v-model="config.voice.ttsApiVersion"
                              placeholder="e.g., 2025-01-01-preview"
                              variant="outlined"
                              density="compact"
                              class="modern-input"
                              style="max-width: 300px"
                              hide-details
                            ></v-text-field>
                          </div>
                          </template>

                          <!-- Cache Settings Section -->
                          <div class="cache-config-section mt-4 ml-4">
                            <h6 class="cache-section-label mb-3">Response Cache</h6>
                            
                            <!-- Enable Cache Switch -->
                            <div class="switch-option-compact mb-4">
                              <div class="d-flex align-center justify-space-between py-2 px-3 rounded-lg"
                                  :class="{ 'switch-active-bg': config.enableCache }">
                                <div class="d-flex align-center">
                                  <v-avatar size="28"
                                      :color="config.enableCache ? 'warning' : 'grey-lighten-1'"
                                      class="me-3">
                                    <v-icon
                                        :color="config.enableCache ? 'white' : 'grey-darken-1'"
                                        size="16">mdi-lightning-bolt</v-icon>
                                  </v-avatar>
                                  <div>
                                    <div class="switch-title">Enable Cache</div>
                                    <div class="switch-description">Cache responses to reduce LLM calls</div>
                                  </div>
                                </div>
                                <v-switch v-model="config.enableCache"
                                    color="warning" hide-details density="compact" inset :disabled="!canEdit" />
                              </div>
                            </div>

                            <!-- Cache TTL Input -->
                            <v-row v-if="config.enableCache">
                              <v-col cols="12">
                                <v-text-field v-model.number="config.cacheTTLMinutes"
                                    label="Cache TTL (minutes)" type="number" min="1" max="10080"
                                    variant="outlined" density="comfortable" hide-details="auto"
                                    prepend-inner-icon="mdi-timer-outline"
                                    @keypress="allowOnlyPositiveNumbers"
                                    class="cache-config-input"
                                    hint="How long to keep cached responses (1-10080 min)"
                                    persistent-hint
                                    :disabled="!canEdit"
                                    style="max-width: 400px" />
                              </v-col>
                            </v-row>

                            <!-- Cache Scope Select -->
                            <v-row v-if="config.enableCache" class="mt-2">
                              <v-col cols="12">
                                <v-select v-model="config.cacheScope"
                                    :items="cacheScopeOptions"
                                    item-title="label"
                                    item-value="value"
                                    label="Cache Scope"
                                    variant="outlined" density="comfortable" hide-details="auto"
                                    prepend-inner-icon="mdi-account-group-outline"
                                    class="cache-config-input"
                                    hint="Who can use cached responses"
                                    persistent-hint
                                    :disabled="!canEdit"
                                    style="max-width: 400px" />
                              </v-col>
                            </v-row>
                          </div>

                          <!-- Semantic Cache Section -->
                          <div class="cache-config-section mt-4 ml-4" v-if="config.enableCache">
                            <h6 class="cache-section-label mb-3">Semantic Cache</h6>
                            
                            <!-- Enable Semantic Cache Switch -->
                            <div class="switch-option-compact mb-4">
                              <div class="d-flex align-center justify-space-between py-2 px-3 rounded-lg"
                                  :class="{ 'switch-active-bg': config.enableSemanticCache }">
                                <div class="d-flex align-center">
                                  <v-avatar size="28"
                                      :color="config.enableSemanticCache ? 'deep-purple' : 'grey-lighten-1'"
                                      class="me-3">
                                    <v-icon
                                        :color="config.enableSemanticCache ? 'white' : 'grey-darken-1'"
                                        size="16">mdi-brain</v-icon>
                                  </v-avatar>
                                  <div>
                                    <div class="switch-title">Semantic Match</div>
                                    <div class="switch-description">Match similar questions using AI</div>
                                  </div>
                                </div>
                                <v-switch v-model="config.enableSemanticCache"
                                    color="deep-purple" hide-details density="compact" inset :disabled="!canEdit" />
                              </div>
                            </div>

                            <!-- Similarity Threshold Slider -->
                            <v-row v-if="config.enableSemanticCache">
                              <v-col cols="12" style="max-width: 400px">
                                <div class="slider-label mb-2">
                                  <span>Similarity Threshold</span>
                                  <span class="text-deep-purple font-weight-bold">{{ ((config.similarityThreshold || 0.95) * 100).toFixed(0) }}%</span>
                                </div>
                                <v-slider
                                    v-model="config.similarityThreshold"
                                    min="0.50"
                                    max="1.00"
                                    step="0.01"
                                    color="deep-purple"
                                    track-color="grey-lighten-2"
                                    thumb-label
                                    hide-details
                                    :disabled="!canEdit">
                                  <template v-slot:thumb-label="{ modelValue }">
                                    {{ (modelValue * 100).toFixed(0) }}%
                                  </template>
                                </v-slider>
                                <div class="text-caption text-grey mt-1">
                                  Higher = more strict (exact match), Lower = more flexible
                                </div>
                              </v-col>
                            </v-row>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Copy Message Function Configuration -->
                    <div class="mb-4">
                      <div class="d-flex justify-space-between align-center">
                        <h3 class="language-config-title">{{ $t('copyMessageFunctionConfiguration') }}</h3>

                        <div style="flex-grow: 1" class="gradient-bar ml-2"></div>
                      </div>
                      <p class="language-config-subtitle">{{ $t('enableDisableCopyMessage') }}</p>

                      <div class="language-switches">
                        <div class="language-option">
                          <v-switch inset v-model="config.copyMessage.enabled" :label="$t('enable')" color="#4E3982" hide-details :disabled="!canEdit"></v-switch>
                        </div>
                      </div>
                    </div>

                    <!-- Text-to-Speech Function Configuration -->
                    <div class="mb-4">
                      <div class="d-flex justify-space-between align-center">
                        <h3 class="language-config-title">{{ $t('ttsFunctionConfiguration') }}</h3>

                        <div style="flex-grow: 1" class="gradient-bar ml-2"></div>
                      </div>
                      <p class="language-config-subtitle">{{ $t('ttsFunctionConfigurationDesc') }}</p>

                      <div class="language-switches">
                        <div class="language-option">
                          <v-switch inset v-model="config.ttsEnabled" :label="$t('enable')" color="#4E3982" hide-details :disabled="!canEdit"></v-switch>
                        </div>
                      </div>
                    </div>

                    <!-- Logging Function Configuration -->
                    <div class="mb-4">
                      <div class="d-flex justify-space-between align-center">
                        <h3 class="language-config-title">{{ $t('loggingFunctionConfiguration') }}</h3>

                        <div style="flex-grow: 1" class="gradient-bar ml-2"></div>
                      </div>
                      <p class="language-config-subtitle">{{ $t('enableDisableLogging') }}</p>

                      <div class="language-switches">
                        <div class="language-option">
                          <v-switch inset v-model="config.logging.enabled" :label="$t('enable')" color="#4E3982" hide-details :disabled="!canEdit"></v-switch>
                        </div>
                      </div>
                    </div>

                    <!-- Post Message Configuration -->
                    <div class="mb-4">
                      <div class="d-flex justify-space-between align-center">
                        <h3 class="language-config-title">{{ $t('postMessageConfiguration') }}</h3>

                        <div style="flex-grow: 1" class="gradient-bar ml-2"></div>
                      </div>
                      <p class="language-config-subtitle">{{ $t('enableDisablePostMessage') }}</p>

                      <div class="language-switches">
                        <div class="language-option">
                          <v-switch inset v-model="config.postMessage.enabled" :label="$t('enable')" color="#4E3982" hide-details :disabled="!canEdit"></v-switch>
                        </div>
                        <v-row>
                          <v-col cols="2" class="postMsg">
                            <span style="font-size: 18px">Thai (default)</span>
                          </v-col>
                          <v-col cols="10" class="postMsg">
                            <v-text-field
                              v-model="postMessageText"
                              :disabled="!config.postMessage.enabled || !canEdit"
                              placeholder="Input post message in Thai"
                              hide-details
                              variant="outlined"
                              rounded
                              class="search-field ml-3 mr-3"
                              :maxlength="500"
                              counter="500"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="2" class="postMsg">
                            <span style="font-size: 18px">English</span>
                          </v-col>
                          <v-col cols="10" class="postMsg">
                            <v-text-field
                              v-model="postMessageTextEN"
                              :disabled="!config.postMessage.enabled || !canEdit"
                              placeholder="Input post message in English"
                              hide-details
                              variant="outlined"
                              rounded
                              class="search-field ml-3 mr-3"
                              :maxlength="500"
                              counter="500"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="2" class="postMsg">
                            <span style="font-size: 18px">Chinese</span>
                          </v-col>
                          <v-col cols="10" class="postMsg">
                            <v-text-field
                              v-model="postMessageTextCN"
                              :disabled="!config.postMessage.enabled || !canEdit"
                              placeholder="Input post message in Chinese"
                              hide-details
                              variant="outlined"
                              rounded
                              class="search-field ml-3 mr-3"
                              :maxlength="500"
                              counter="500"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="2" class="postMsg">
                            <span style="font-size: 18px">{{ $t('postMessageColor') }}</span>
                          </v-col>
                          <v-col cols="10" class="postMsg">
                            <PostMessageColorField
                              v-model="postMessageColor"
                              :disabled="!config.postMessage.enabled || !canEdit"
                              :fallback-color="postMessageDefaultColor"
                            />
                          </v-col>
                        </v-row>
                      </div>
                    </div>

                    <!-- AI Model Configuration -->
                    <div class="mb-4">
                      <div class="d-flex justify-space-between align-center">
                        <h3 class="language-config-title">AI Model Configuration</h3>
                        <div style="flex-grow: 1" class="gradient-bar ml-2"></div>
                      </div>
                      <p class="language-config-subtitle">Select AI model to use in mobile application</p>

                      <div class="language-switches">
                        <v-autocomplete
                          v-model="selectedModel"
                          :items="uniqueAiModelOptions"
                          item-title="searchableText"
                          item-value="value"
                          label="Select AI Model"
                          variant="outlined"
                          density="compact"
                          hide-details="auto"
                          class="modern-input mb-3"
                          clearable
                          :disabled="!canEdit"
                          :custom-filter="
                            (value, query, item) => {
                              if (!query) return true;
                              const searchQuery = query.toLowerCase();
                              const itemValue = item?.raw?.value?.toString().toLowerCase() || '';
                              const itemName = item?.raw?.name?.toLowerCase() || '';
                              return itemValue.includes(searchQuery) || itemName.includes(searchQuery);
                            }
                          "
                        >
                          <template v-slot:item="{ props, item }">
                            <v-list-item v-bind="props" class="model-option" :title="item.raw.value + ': ' + item.raw.name">
                              <template v-slot:prepend>
                                <div class="model-icon-small mr-2" style="background-color: #3b82f6">
                                  <v-icon size="14" color="white">{{ item.raw.icon }}</v-icon>
                                </div>
                              </template>
                            </v-list-item>
                          </template>
                          <template v-slot:selection="{ item }">
                            <span>{{ item.raw.value }}: {{ item.raw.name }}</span>
                          </template>
                        </v-autocomplete>
                      </div>
                    </div>

                    <!-- Tax Planning AI Model Configuration -->
                    <div class="mb-4">
                      <div class="d-flex justify-space-between align-center">
                        <h3 class="language-config-title">Tax Planning AI Model Configuration</h3>
                        <div style="flex-grow: 1" class="gradient-bar ml-2"></div>
                      </div>
                      <p class="language-config-subtitle">Select AI model to use for Tax Planning mode</p>

                      <div class="language-switches">
                        <v-autocomplete
                          v-model="taxPlanningSelectedModel"
                          :items="uniqueAiModelOptions"
                          item-title="searchableText"
                          item-value="value"
                          label="Select Tax Planning AI Model"
                          variant="outlined"
                          density="compact"
                          hide-details="auto"
                          class="modern-input mb-3"
                          clearable
                          :disabled="!canEdit"
                          :custom-filter="
                            (value, query, item) => {
                              if (!query) return true;
                              const searchQuery = query.toLowerCase();
                              const itemValue = item?.raw?.value?.toString().toLowerCase() || '';
                              const itemName = item?.raw?.name?.toLowerCase() || '';
                              return itemValue.includes(searchQuery) || itemName.includes(searchQuery);
                            }
                          "
                        >
                          <template v-slot:item="{ props, item }">
                            <v-list-item v-bind="props" class="model-option" :title="item.raw.value + ': ' + item.raw.name">
                              <template v-slot:prepend>
                                <div class="model-icon-small mr-2" style="background-color: #3b82f6">
                                  <v-icon size="14" color="white">{{ item.raw.icon }}</v-icon>
                                </div>
                              </template>
                            </v-list-item>
                          </template>
                          <template v-slot:selection="{ item }">
                            <span>{{ item.raw.value }}: {{ item.raw.name }}</span>
                          </template>
                        </v-autocomplete>
                      </div>
                    </div>

                    <!-- App Title Configuration -->
                    <div class="mb-4">
                      <div class="d-flex justify-space-between align-center">
                        <h3 class="language-config-title">App Title</h3>
                        <div style="flex-grow: 1" class="gradient-bar ml-2"></div>
                      </div>
                      <p class="language-config-subtitle">Enter the app title shown in mobile header</p>

                      <div class="language-switches">
                        <v-text-field
                          v-model="appTitle"
                          placeholder="e.g., Genie"
                          variant="outlined"
                          density="compact"
                          :maxlength="100"
                          counter
                          hide-details="auto"
                          class="modern-input"
                          :disabled="!canEdit"
                        ></v-text-field>
                      </div>
                    </div>

                    <!-- Mobile Information Configuration -->
                    <div class="mb-4">
                      <div class="d-flex justify-space-between align-center">
                        <h3 class="language-config-title">Mobile Information</h3>
                        <div style="flex-grow: 1" class="gradient-bar ml-2"></div>
                      </div>
                      <p class="language-config-subtitle">Enter additional information for mobile application</p>

                      <div class="language-switches">
                        <label class="field-label">Header (Optional)</label>
                        <v-text-field
                          v-model="mobileInformationHeader"
                          placeholder="Enter section header (optional)"
                          variant="outlined"
                          density="compact"
                          :maxlength="50"
                          counter
                          hide-details="auto"
                          class="modern-input mb-3"
                          :disabled="!canEdit"
                        ></v-text-field>

                        <label class="field-label">Information (Thai)</label>
                        <v-textarea
                          v-model="mobileInformation"
                          placeholder="Enter mobile information in Thai"
                          variant="outlined"
                          density="compact"
                          rows="10"
                          :maxlength="4000"
                          counter
                          class="modern-input mb-3"
                          :disabled="!canEdit"
                        ></v-textarea>

                        <label class="field-label">Information (English)</label>
                        <v-textarea
                          v-model="mobileInformationEN"
                          placeholder="Enter mobile information in English"
                          variant="outlined"
                          density="compact"
                          rows="10"
                          :maxlength="4000"
                          counter
                          class="modern-input"
                          :disabled="!canEdit"
                        ></v-textarea>
                      </div>
                    </div>

                    <!-- API Timeout Configuration -->
                    <div class="mb-4">
                      <div class="d-flex justify-space-between align-center">
                        <h3 class="language-config-title">API Timeout Configuration</h3>
                        <div style="flex-grow: 1" class="gradient-bar ml-2"></div>
                      </div>
                      <p class="language-config-subtitle">Configure timeout duration and message for API responses</p>

                      <div class="language-switches">
                        <label class="field-label">Timeout Duration (seconds)</label>
                        <v-text-field
                          v-model.number="timeoutDuration"
                          type="number"
                          placeholder="Enter timeout duration in seconds (e.g., 30)"
                          variant="outlined"
                          density="compact"
                          min="1"
                          class="modern-input mb-3"
                          :disabled="!canEdit"
                        ></v-text-field>

                        <v-row>
                          <v-col cols="12">
                            <label class="field-label">Timeout Message (Thai)</label>
                            <v-textarea
                              v-model="timeoutMessage"
                              placeholder="Enter timeout message in Thai"
                              variant="outlined"
                              density="compact"
                              rows="3"
                              :maxlength="500"
                              counter
                              hide-details="auto"
                              class="modern-input"
                              :disabled="!canEdit"
                            ></v-textarea>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="12">
                            <label class="field-label">Timeout Message (English)</label>
                            <v-textarea
                              v-model="timeoutMessageEN"
                              placeholder="Enter timeout message in English"
                              variant="outlined"
                              density="compact"
                              rows="3"
                              :maxlength="500"
                              counter
                              hide-details="auto"
                              class="modern-input"
                              :disabled="!canEdit"
                            ></v-textarea>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="12">
                            <label class="field-label">Timeout Message (Chinese)</label>
                            <v-textarea
                              v-model="timeoutMessageCN"
                              placeholder="Enter timeout message in Chinese"
                              variant="outlined"
                              density="compact"
                              rows="3"
                              :maxlength="500"
                              counter
                              hide-details="auto"
                              class="modern-input"
                              :disabled="!canEdit"
                            ></v-textarea>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </div>
                </v-col>

                <!-- Mobile Preview -->
                <v-col cols="12" md="5" class="split-preview-col">
                  <div class="mobile-preview-sticky">
                    <div style="background-color: #f3f3f3; border-radius: 14px; padding: 24px 0" class="d-flex justify-center align-center">
                      <v-skeleton-loader v-if="loading" type="image" width="268" height="582" class="mobile-skeleton"></v-skeleton-loader>
                      <div v-else class="mobile-preview-simulator py-2 px-4 white--text d-flex flex-column">
                        <div class="px-4 d-flex justify-space-between align-center grow-0">
                          <span>9:41</span>
                          <div>
                            <v-icon color="white" size="small" class="mr-2">mdi-wifi</v-icon>
                            <v-icon color="white" size="small" class="mr-2" style="rotate: 90deg">mdi-battery-90</v-icon>
                          </div>
                        </div>

                        <!-- App Header with Title and Info Icon -->
                        <div v-if="appTitle || mobileInformationHeader || mobileInformation" class="app-header-section px-4 pt-4 pb-3">
                          <div class="d-flex align-center justify-center">
                            <span style="font-size: 18px; font-weight: bold; color: white">{{ appTitle || 'App Name' }}</span>
                            <v-tooltip bottom max-width="250" v-if="mobileInformationHeader || mobileInformation">
                              <template v-slot:activator="{ props }">
                                <v-icon v-bind="props" color="white" size="18" class="ml-2" style="cursor: pointer; opacity: 0.9"> mdi-information-outline </v-icon>
                              </template>
                              <div style="padding: 8px">
                                <div v-if="mobileInformationHeader" style="font-weight: bold; margin-bottom: 6px; font-size: 13px">
                                  {{ mobileInformationHeader }}
                                </div>
                                <div v-if="mobileInformation" style="white-space: pre-wrap; font-size: 12px; line-height: 1.4">
                                  {{ mobileInformation }}
                                </div>
                              </div>
                            </v-tooltip>
                          </div>
                        </div>

                        <div class="grow pt-6 mt-4">
                          <div class="d-flex ml-auto text-white" style="width: 80%">
                            <p class="pa-3 rounded ml-auto" style="background-color: #262d47; font-size: 10px">ฉันต้องการอายัดบัตรเครดิต</p>
                          </div>
                          <div class="d-flex mt-2" style="width: 80%">
                            <v-img src="/lhb/listen.svg" width="26" height="26"></v-img>
                            <div class="pa-2 rounded text-white" style="background-color: #3e4661; font-size: 10px">
                              <p>ได้เลย, คุณสามารถ ไปที่บัตรเครดิต &gt; เลือกจัดการบัตร &gt; อายัดบัตรเครดิต</p>
                              <p>คุณต้องการทำรายการอื่นอีกไหมคะ?</p>
                              <div style="width: 100%; height: 1px; background-color: #f8f8f8; opacity: 0.5"></div>
                              <div class="d-flex mt-3 mb-1">
                                <img src="/lhb/heart.svg" width="14" class="mr-2" alt="some icon" />
                                <img v-if="config.ttsEnabled" src="/lhb/volume.svg" width="14" class="mr-2" alt="some icon" />
                                <img v-if="config.copyMessage.enabled" src="/lhb/copy.svg" width="10" class="mr-2" alt="some icon" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="grow-0">
                          <div class="d-flex justify-start align-center px-2 available-language-text-container" style="gap: 4px; font-size: 10px; color: #a4a4a4">
                            <span> รองรับภาษา: </span>
                            <template v-for="(lang, index) in enabledLanguages" :key="lang.key">
                              <span class="available-language-text">{{ lang.text }}</span>
                              <span v-if="index < enabledLanguages.length - 1">,</span>
                            </template>
                          </div>
                          <v-img :src="config.voice.enabled ? '/lhb/chat.png' : '/lhb/chat-no-mic.png'" contain></v-img>
                          <p class="my-2" v-if="config.postMessage.enabled" style="font-size: 7px; text-align: center" :style="{ color: postMessagePreviewColor }">{{ postMessageText }}</p>
                          <!-- AI อาจตอบคลาดเคลื่อนได้ หากพบข้อผิดพลาด กรุณาแจ้งให้เราทราบ -->
                        </div>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-window-item>

            <!-- Suggestion Feature Tab -->
            <v-window-item>
              <v-row style="padding: 25px" class="preview-split-row">
                <v-col cols="12" md="7" class="split-form-col">
                  <!-- Loading Skeleton for Suggestion Features -->
                  <div v-if="loading">
                    <v-skeleton-loader type="heading" class="mb-4"></v-skeleton-loader>
                    <v-skeleton-loader type="card" class="mb-4"></v-skeleton-loader>
                    <v-skeleton-loader type="card" class="mb-4"></v-skeleton-loader>
                    <v-skeleton-loader type="card" class="mb-4"></v-skeleton-loader>
                    <v-skeleton-loader type="card" class="mb-4"></v-skeleton-loader>
                  </div>

                  <!-- Suggestion Configuration Content (only show when not loading) -->
                  <div v-else class="mb-4">
                    <!-- Suggest Bar — ข้อความหัวแถบที่โชว์เหนือปุ่ม suggestion บนมือถือ · เว้นว่าง = ไม่แสดงแถบ -->
                    <div class="mb-4">
                      <div class="d-flex justify-space-between align-center">
                        <h3 class="language-config-title">{{ $t('suggestBar') }}</h3>
                        <div style="flex-grow: 1" class="gradient-bar ml-2"></div>
                      </div>
                      <p class="language-config-subtitle">{{ $t('suggestBarDescription') }}</p>
                      <v-row>
                        <v-col cols="4">
                          <div class="d-flex align-center mb-2"><span style="font-size: 16px; font-weight: 500">In Thai</span></div>
                          <input v-model="suggestBarText" placeholder="Suggest bar text" class="custom-input" maxlength="500" :disabled="!canEdit" />
                        </v-col>
                        <v-col cols="4">
                          <div class="d-flex align-center mb-2"><span style="font-size: 16px; font-weight: 500">In English</span></div>
                          <input v-model="suggestBarTextEN" placeholder="Suggest bar text" class="custom-input" maxlength="500" :disabled="!canEdit" />
                        </v-col>
                        <v-col cols="4">
                          <div class="d-flex align-center mb-2"><span style="font-size: 16px; font-weight: 500">In Chinese</span></div>
                          <input v-model="suggestBarTextCN" placeholder="Suggest bar text" class="custom-input" maxlength="500" :disabled="!canEdit" />
                        </v-col>
                      </v-row>
                    </div>

                    <div class="d-flex start align-center mb-3">
                      <h3 class="language-config-title mr-3">{{ $t('suggestionFeature') }}</h3>
                      <v-switch inset class="ma-0 ml-3" v-model="suggestionConfig.enabled" :label="$t('enable')" color="#4E3982" hide-details :disabled="!canEdit"></v-switch>
                    </div>

                    <div v-if="suggestionConfig.enabled" class="suggestion-form">
                      <v-row>
                        <v-col cols="6">
                          <!-- Add New Feature Button -->
                          <div class="mb-3">
                            <v-btn color="#4E3982" variant="outlined" style="height: 40px; border-radius: 12px; text-transform: none" @click="addNewFeature" :disabled="!canAdd">
                              <v-icon start size="small">mdi-plus</v-icon>
                              Add more feature
                            </v-btn>
                            <span class="ml-2 text-caption">{{ suggestionConfig.features.length }} Feature(s)</span>
                          </div>
                        </v-col>
                        <v-col cols="6" class="d-flex justify-end align-center">
                          <p class="language-config-subtitle" style="font-size: 16px">*Only 4 features will be shown at a time.</p>
                        </v-col>
                      </v-row>

                      <!-- Dynamic Features -->
                      <div v-for="(feature, index) in suggestionConfig.features" :key="index" class="feature-section mb-4 pa-4" style="border: 1px solid #e0e0e0; border-radius: 8px">
                        <div class="d-flex align-center mb-2">
                          <h4>Feature {{ index + 1 }}</h4>
                          <div style="flex-grow: 1; background-color: #000000; opacity: 20%; height: 1px" class="mx-2"></div>

                          <!-- Remove Feature Button -->
                          <v-btn v-if="suggestionConfig.features.length > 1" icon size="small" variant="plain" color="error" @click="removeFeature(feature, index)" class="mr-2">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>

                          <!-- Collapse/Expand Button -->
                          <v-btn icon size="small" variant="plain" @click="feature.collapsed = !feature.collapsed">
                            <v-icon size="28">{{ feature.collapsed ? 'mdi-menu-down' : 'mdi-menu-up' }}</v-icon>
                          </v-btn>
                        </div>

                        <div v-if="!feature.collapsed">
                          <!-- Language Messages -->
                          <div class="mb-3">
                            <v-row>
                              <v-col cols="2">
                                <div class="mb-2" style="display: flex; justify-content: center">
                                  <!-- Dynamic Image with Placeholder -->
                                  <div class="SuggestFeatureIcon">
                                    <v-img
                                      v-if="getFeatureImageUrl(feature, index)"
                                      :src="getFeatureImageUrl(feature, index)"
                                      width="80"
                                      height="80"
                                      class="mx-auto"
                                      style="border-radius: 8px"
                                      @error="onImageError(feature, index)"
                                      @click="canEdit ? openImageUpload(index) : null"
                                      :style="!canEdit ? 'cursor: not-allowed; opacity: 0.6' : 'cursor: pointer'"
                                    >
                                      <template v-slot:placeholder>
                                        <v-row class="fill-height ma-0" align="center" justify="center">
                                          <v-progress-circular indeterminate color="grey-lighten-5"></v-progress-circular>
                                        </v-row>
                                      </template>
                                      <template v-slot:error>
                                        <v-row class="fill-height ma-0" align="center" justify="center">
                                          <v-icon color="grey-lighten-3" size="32">mdi-image-broken-variant</v-icon>
                                        </v-row>
                                      </template>
                                    </v-img>
                                    <!-- Plain square box placeholder when no image -->
                                    <div
                                      v-else
                                      style="
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        width: 80px;
                                        height: 80px;
                                        background-color: transparent;
                                        border: 2px dashed #ccc;
                                        border-radius: 8px;
                                      "
                                    >
                                      <v-icon color="#eee" size="32">mdi-image-plus</v-icon>
                                    </div>
                                  </div>
                                </div>
                              </v-col>
                              <v-col cols="10">
                                <v-row>
                                  <v-col cols="4">
                                    <div class="d-flex align-center mb-2">
                                      <span style="font-size: 16px; font-weight: 500">In Thai</span>
                                    </div>
                                    <input v-model="feature.messages.thai" placeholder="Message" class="custom-input" :disabled="!canEdit" />
                                  </v-col>
                                  <v-col cols="4">
                                    <div class="d-flex align-center mb-2">
                                      <span style="font-size: 16px; font-weight: 500">In English</span>
                                    </div>
                                    <input v-model="feature.messages.english" placeholder="Message" class="custom-input" :disabled="!canEdit" />
                                  </v-col>
                                  <v-col cols="4">
                                    <div class="d-flex align-center mb-2">
                                      <span style="font-size: 16px; font-weight: 500">In Chinese</span>
                                    </div>
                                    <input v-model="feature.messages.chinese" placeholder="Message" class="custom-input" :disabled="!canEdit" />
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </div>

                          <!-- Model Name -->
                          <!-- <div class="mb-3">
                            <label class="form-label">Model name</label>
                            <v-select v-model="feature.modelName" :items="['1', '2', '3', '4', '5']" variant="outlined" density="compact" hide-details></v-select>
                          </div> -->

                          <!-- Target Group and Priority -->
                          <v-row class="mb-3">
                            <v-col cols="6">
                              <label class="form-label">Target Group</label>
                              <div>
                                <v-radio-group v-model="feature.targetGroup" inline hide-details :disabled="!canEdit">
                                  <v-radio value="all" label="All" color="#4E3982" style="margin-right: 35px"></v-radio>
                                  <v-radio value="persona" label="Persona" color="#4E3982" style="margin-right: 35px"></v-radio>
                                  <v-radio value="cif-list" label="Cif List" color="#4E3982"></v-radio>
                                </v-radio-group>
                                <div v-if="feature.targetGroup === 'cif-list'" class="mt-2">
                                  <v-btn variant="outlined" size="small" color="#4E3982" style="margin-right: 8px" @click="triggerFeatureCifUpload(index)" :disabled="!canEdit">
                                    <v-icon size="16" class="mr-1">mdi-upload</v-icon>
                                    Upload File
                                  </v-btn>
                                  <v-btn variant="outlined" size="small" color="#4E3982" @click="downloadCifTemplate">
                                    <v-icon size="16" class="mr-1">mdi-download</v-icon>
                                    Download Template
                                  </v-btn>
                                </div>
                              </div>
                            </v-col>
                            <v-col cols="6">
                              <label class="form-label">Priority</label>
                              <input
                                v-model="feature.priority"
                                placeholder="Number (0 is most important)"
                                class="custom-input"
                                @input="validatePriority($event, feature)"
                                type="text"
                                pattern="[0-9]*"
                                :disabled="!canEdit"
                              />
                            </v-col>
                          </v-row>

                          <!-- CIF Files Display -->
                          <div v-if="feature.targetGroup === 'cif-list' && feature.cifFiles && feature.cifFiles.length > 0" class="mb-3">
                            <v-card variant="outlined" class="pa-3">
                              <div class="d-flex align-center justify-space-between mb-2">
                                <div>
                                  <v-icon class="mr-2" color="primary" size="20">mdi-file-table</v-icon>
                                  <span style="font-size: 14px; font-weight: 500">Uploaded CIF Files ({{ feature.cifFiles.length }}) - Total CIF Codes: {{ getTotalFeatureCifCodes(feature) }}</span>
                                </div>
                              </div>
                              <v-table density="compact" class="modern-table">
                                <thead>
                                  <tr>
                                    <th class="text-left">File Name</th>
                                    <th class="text-center" style="width: 100px">CIF Count</th>
                                    <th class="text-center" style="width: 120px">Upload Date</th>
                                    <th class="text-center" style="width: 180px">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(file, fileIndex) in feature.cifFiles" :key="fileIndex">
                                    <td class="py-2">
                                      <div class="d-flex align-center">
                                        <v-icon class="mr-2" color="success" size="16">mdi-file-document</v-icon>
                                        <div>
                                          <div style="font-size: 13px">{{ file.fileName }}</div>
                                          <div style="font-size: 11px; color: #666">{{ formatFileSize(file.fileSize) }}</div>
                                        </div>
                                      </div>
                                    </td>
                                    <td class="text-center py-2">
                                      <v-chip size="x-small" color="primary" variant="outlined">
                                        {{ file.cifList ? file.cifList.length : 0 }}
                                      </v-chip>
                                    </td>
                                    <td class="text-center py-2" style="font-size: 11px">
                                      {{ formatUploadDate(file.uploadDate) }}
                                    </td>
                                    <td class="text-center py-2">
                                      <v-btn variant="outlined" color="primary" size="x-small" class="mr-1" @click="downloadFeatureCifFile(file)">
                                        <v-icon size="14">mdi-download</v-icon>
                                      </v-btn>
                                      <v-btn variant="outlined" color="error" size="x-small" @click="removeFeatureCifFile(index, fileIndex)">
                                        <v-icon size="14">mdi-delete</v-icon>
                                      </v-btn>
                                    </td>
                                  </tr>
                                </tbody>
                              </v-table>
                              <div v-if="feature.cifFiles.length > 1" class="d-flex justify-end mt-2">
                                <v-btn variant="outlined" color="error" size="x-small" @click="clearAllFeatureCifFiles(index)">
                                  <v-icon size="14" class="mr-1">mdi-delete-sweep</v-icon>
                                  Clear All
                                </v-btn>
                              </div>
                            </v-card>
                          </div>

                          <!-- Segment and Wealth Membership show when targetGroup is 'persona') -->
                          <v-row v-if="feature.targetGroup === 'persona'" class="mb-3">
                            <v-col cols="6">
                              <label class="form-label">Segment</label>
                              <v-select
                                v-model="feature.segment"
                                :items="segmentOptions"
                                item-title="name"
                                item-value="valueString"
                                variant="solo"
                                density="compact"
                                multiple
                                chips
                                class="custom-select"
                                hide-details
                                flat
                                :disabled="!canEdit"
                              >
                              </v-select>
                            </v-col>
                            <v-col cols="6">
                              <label class="form-label">Wealth Membership</label>
                              <v-select
                                v-model="feature.wealthMembership"
                                :items="wealthMembershipOptions"
                                item-title="name"
                                item-value="valueString"
                                variant="solo"
                                density="compact"
                                multiple
                                chips
                                class="custom-select"
                                hide-details
                                flat
                                :disabled="!canEdit"
                              ></v-select>
                            </v-col>
                          </v-row>

                          <!-- Action -->
                          <v-row class="mb-3">
                            <v-col cols="6">
                              <label class="form-label">{{ $t('action') }}</label>
                              <v-select
                                :model-value="feature.action"
                                @update:model-value="(val) => handleActionSelect(feature, val)"
                                :items="actionSelectItems"
                                item-title="name"
                                item-value="name"
                                variant="solo"
                                density="compact"
                                class="custom-select"
                                hide-details
                                flat
                                clearable
                                :disabled="!canEdit"
                              >
                                <template v-slot:item="{ props, item }">
                                  <template v-if="item.raw.__isAddAction">
                                    <v-divider class="my-1"></v-divider>
                                    <v-list-item v-bind="props" prepend-icon="mdi-plus-circle-outline" :title="$t('addAction')"></v-list-item>
                                  </template>
                                  <v-list-item v-else v-bind="props"></v-list-item>
                                </template>
                              </v-select>
                            </v-col>
                          </v-row>

                          <!-- Effective Dates -->
                          <v-row class="mb-3">
                            <v-col cols="6">
                              <label class="form-label">Effective Start Date</label>
                              <input v-model="feature.effectiveStartDate" type="datetime-local" step="60" class="custom-input" :disabled="!canEdit" />
                            </v-col>
                            <v-col cols="6">
                              <label class="form-label">Effective End Date</label>
                              <input
                                v-model="feature.effectiveEndDate"
                                type="datetime-local"
                                step="60"
                                class="custom-input"
                                :class="{ 'input-error': !validateDateRange(feature.effectiveStartDate, feature.effectiveEndDate) }"
                                :disabled="!canEdit"
                              />
                              <div v-if="!validateDateRange(feature.effectiveStartDate, feature.effectiveEndDate)" class="error-message">End Date must be on or after Start Date</div>
                            </v-col>
                          </v-row>

                          <!-- Upload and Enable -->
                          <div class="d-flex align-center justify-start">
                            <v-btn color="#4E3982" size="small" style="border-radius: 12px; height: 40px; padding: 0 25px; margin-right: 25px" @click="openImageUpload(index)" :disabled="!canEdit">
                              <v-icon start size="small">mdi-upload</v-icon>
                              Upload
                            </v-btn>
                            <v-switch inset class="ma-0 ml-3" v-model="feature.featureEnabled" label="Enable" color="#4E3982" hide-details :disabled="!canEdit"></v-switch>
                            <v-switch inset class="ma-0 ml-3" v-model="feature.taxPlanningEnabled" :label="$t('forTaxPlanningMode')" color="#4E3982" hide-details :disabled="!canEdit"></v-switch>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" md="5" class="split-preview-col">
                  <div class="mobile-preview-sticky">
                    <div style="background-color: #f3f3f3; border-radius: 14px; padding: 24px 0" class="d-flex justify-center align-center">
                      <v-skeleton-loader v-if="loading" type="image" width="268" height="582" class="mobile-skeleton"></v-skeleton-loader>
                      <div v-else :class="config.voice.enabled ? 'sug-simulator-bg' : 'sug-simulator-bg-without-mic'" class="sug-simulator py-4 px-3 d-flex flex-column">
                        <div style="flex: 1"></div>
                        <div class="mb-4">
                          <div v-if="suggestBarText || suggestBarTextEN" class="mb-2" style="font-size: 12px; font-weight: 500; color: #ffffff">
                            {{ suggestBarText || suggestBarTextEN }}
                          </div>
                          <div class="d-flex flex-wrap justify-space-between" style="gap: 8px">
                            <!-- Show actual enabled features from API -->
                            <template v-for="(feature, index) in suggestionConfig.features.slice(0, 4)" :key="`feat-${index}`">
                              <div v-if="feature && feature.featureEnabled" class="feature-card d-flex flex-column align-center">
                                <v-img
                                  v-if="getFeatureImageUrl(feature, index)"
                                  :src="getFeatureImageUrl(feature, index)"
                                  width="46"
                                  height="46"
                                  class="mb-1 rounded"
                                  @error="onImageError(feature, index)"
                                >
                                  <template v-slot:placeholder>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                      <v-progress-circular indeterminate color="grey-lighten-5" size="20"></v-progress-circular>
                                    </v-row>
                                  </template>
                                  <template v-slot:error>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                      <v-icon color="grey-lighten-3" size="16">mdi-image-broken-variant</v-icon>
                                    </v-row>
                                  </template>
                                </v-img>
                                <!-- Plain square box placeholder when no image -->
                                <div v-else class="mb-1" style="width: 44px; height: 44px; background-color: #f5f5f5; border: 1px solid #ccc; border-radius: 4px"></div>
                                <span style="color: white; font-size: 8px; text-align: center; line-height: 1; font-weight: bold">
                                  {{ feature.messages?.thai || feature.messages?.english || `Feature${index + 1}` }}
                                </span>
                              </div>
                            </template>
                          </div>
                        </div>

                        <!-- Suggestion Questions (2x2 grid) - Show real data -->
                        <div class="mb-4">
                          <div class="d-flex flex-column" style="gap: 6px">
                            <!-- First row -->
                            <div class="d-flex justify-space-between" style="gap: 10px">
                              <template v-for="(question, index) in suggestionQuestionConfig.questions.slice(0, 2)" :key="`feat-question-${index}`">
                                <div
                                  v-if="question && question.questionEnabled"
                                  class="pa-2 d-flex align-center justify-center"
                                  style="background: rgba(122, 122, 122, 0.1); backdrop-filter: blur(2px); border-radius: 16px; width: 100%; height: 28px; cursor: pointer; border: 1px solid #fff"
                                >
                                  <span style="font-size: 8px; color: white; text-align: center; font-weight: bold">
                                    {{ question.messages?.thai || question.messages?.english || `Question ${index + 1}` }}
                                  </span>
                                </div>
                              </template>
                            </div>
                            <!-- Second row -->
                            <div class="d-flex justify-space-between" style="gap: 10px">
                              <template v-for="(question, index) in suggestionQuestionConfig.questions.slice(2, 4)" :key="`feat-question-${index + 2}`">
                                <div
                                  v-if="question && question.questionEnabled"
                                  class="pa-2 d-flex align-center justify-center"
                                  style="background: rgba(122, 122, 122, 0.1); backdrop-filter: blur(2px); border-radius: 16px; width: 100%; height: 28px; cursor: pointer; border: 1px solid #fff"
                                >
                                  <span style="font-size: 8px; color: white; text-align: center; font-weight: bold">
                                    {{ question.messages?.thai || question.messages?.english || `Question ${index + 3}` }}
                                  </span>
                                </div>
                              </template>
                            </div>
                          </div>
                        </div>

                        <!-- Spacer to push flags to bottom -->

                        <!-- Language Flags -->

                        <div class="grow-0">
                          <div class="d-flex justify-start align-center px-2 available-language-text-container" style="gap: 4px; font-size: 10px; color: #a4a4a4">
                            <span> รองรับภาษา: </span>
                            <template v-for="(lang, index) in enabledLanguages" :key="lang.key">
                              <span class="available-language-text">{{ lang.text }}</span>
                              <span v-if="index < enabledLanguages.length - 1">,</span>
                            </template>
                          </div>
                          <v-img :src="config.voice.enabled ? '/lhb/chat.png' : '/lhb/chat-no-mic.png'" contain></v-img>
                          <p class="my-2" v-if="config.postMessage.enabled" style="font-size: 7px; text-align: center" :style="{ color: postMessagePreviewColor }">{{ postMessageText }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-window-item>

            <!-- Suggestion Question Tab -->
            <v-window-item>
              <v-row style="padding: 25px" class="preview-split-row">
                <v-col cols="12" md="7" class="split-form-col">
                  <!-- Loading Skeleton for Suggestion Questions -->
                  <div v-if="loading">
                    <v-skeleton-loader type="heading" class="mb-4"></v-skeleton-loader>
                    <v-skeleton-loader type="card" class="mb-4"></v-skeleton-loader>
                    <v-skeleton-loader type="card" class="mb-4"></v-skeleton-loader>
                    <v-skeleton-loader type="card" class="mb-4"></v-skeleton-loader>
                    <v-skeleton-loader type="card" class="mb-4"></v-skeleton-loader>
                  </div>

                  <!-- Suggestion Question Configuration Content (only show when not loading) -->
                  <div v-else class="mb-4">
                    <div class="d-flex start align-center mb-3">
                      <h3 class="language-config-title mr-3">{{ $t('suggestionQuestion') }}</h3>
                      <v-switch inset class="ma-0 ml-3" v-model="suggestionQuestionConfig.enabled" :label="$t('enable')" color="#4E3982" hide-details :disabled="!canEdit"></v-switch>
                    </div>
                    <div v-if="suggestionQuestionConfig.enabled" class="suggestion-form">
                      <v-row>
                        <v-col cols="6">
                          <!-- Add New Question Button -->
                          <div class="mb-3">
                            <v-btn style="height: 40px; border-radius: 12px; text-transform: none" color="#4E3982" variant="outlined" @click="addNewQuestion" :disabled="!canAdd">
                              <v-icon start size="small">mdi-plus</v-icon>
                              Add new question
                            </v-btn>
                            <span class="ml-2 text-caption">{{ suggestionQuestionConfig.questions.length }} Question(s)</span>
                          </div>
                        </v-col>
                        <v-col cols="6" class="d-flex justify-end align-center">
                          <p class="language-config-subtitle" style="font-size: 16px">*Only 4 questions will be shown at a time.</p>
                        </v-col>
                      </v-row>

                      <!-- Dynamic Questions -->
                      <div v-for="(question, index) in suggestionQuestionConfig.questions" :key="index" class="feature-section mb-4 pa-4" style="border: 1px solid #e0e0e0; border-radius: 8px">
                        <div class="d-flex align-center mb-2">
                          <h4>Question {{ index + 1 }}</h4>
                          <div style="flex-grow: 1; background-color: #000000; opacity: 20%; height: 1px" class="mx-2"></div>

                          <!-- Remove Question Button -->
                          <v-btn v-if="suggestionQuestionConfig.questions.length > 1" icon size="small" variant="plain" color="error" @click="removeQuestion(index)" class="mr-2">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>

                          <!-- Collapse/Expand Button -->
                          <v-btn icon size="small" variant="plain" @click="question.collapsed = !question.collapsed">
                            <v-icon size="28">{{ question.collapsed ? 'mdi-menu-down' : 'mdi-menu-up' }}</v-icon>
                          </v-btn>
                        </div>

                        <div v-if="!question.collapsed">
                          <!-- Language Messages -->
                          <div class="mb-3">
                            <v-row>
                              <v-col cols="12">
                                <div class="d-flex align-center mb-2">
                                  <span style="font-size: 16px; font-weight: 500">In Thai</span>
                                </div>
                                <input v-model="question.messages.thai" placeholder="Message" class="custom-input" :disabled="!canEdit" />
                              </v-col>
                              <v-col cols="12">
                                <div class="d-flex align-center mb-2">
                                  <span style="font-size: 16px; font-weight: 500">In English</span>
                                </div>
                                <input v-model="question.messages.english" placeholder="Message" class="custom-input" :disabled="!canEdit" />
                              </v-col>
                              <v-col cols="12">
                                <div class="d-flex align-center mb-2">
                                  <span style="font-size: 16px; font-weight: 500">In Chinese</span>
                                </div>
                                <input v-model="question.messages.chinese" placeholder="Message" class="custom-input" :disabled="!canEdit" />
                              </v-col>
                            </v-row>
                          </div>

                          <!-- Target Group and Priority -->
                          <v-row class="mb-3">
                            <v-col cols="6">
                              <label class="form-label">Target Group</label>
                              <div>
                                <v-radio-group v-model="question.targetGroup" inline hide-details :disabled="!canEdit">
                                  <v-radio value="all" label="All" color="#4E3982" style="margin-right: 35px"></v-radio>
                                  <v-radio value="persona" label="Persona" color="#4E3982" style="margin-right: 35px"></v-radio>
                                  <v-radio value="cif-list" label="Cif List" color="#4E3982"></v-radio>
                                </v-radio-group>
                                <div v-if="question.targetGroup === 'cif-list'" class="mt-2">
                                  <v-btn variant="outlined" size="small" color="#4E3982" style="margin-right: 8px" @click="triggerQuestionCifUpload(index)" :disabled="!canEdit">
                                    <v-icon size="16" class="mr-1">mdi-upload</v-icon>
                                    Upload File
                                  </v-btn>
                                  <v-btn variant="outlined" size="small" color="#4E3982" @click="downloadCifTemplate">
                                    <v-icon size="16" class="mr-1">mdi-download</v-icon>
                                    Download Template
                                  </v-btn>
                                </div>
                              </div>
                            </v-col>
                            <v-col cols="6">
                              <label class="form-label">Priority</label>
                              <input
                                v-model="question.priority"
                                placeholder="Number (0 is most important)"
                                class="custom-input"
                                @input="validatePriority($event, question)"
                                type="text"
                                pattern="[0-9]*"
                                :disabled="!canEdit"
                              />
                            </v-col>
                          </v-row>

                          <!-- CIF Files Display for Questions -->
                          <div v-if="question.targetGroup === 'cif-list' && question.cifFiles && question.cifFiles.length > 0" class="mb-3">
                            <v-card variant="outlined" class="pa-3">
                              <div class="d-flex align-center justify-space-between mb-2">
                                <div>
                                  <v-icon class="mr-2" color="primary" size="20">mdi-file-table</v-icon>
                                  <span style="font-size: 14px; font-weight: 500">Uploaded CIF Files ({{ question.cifFiles.length }}) - Total CIF Codes: {{ getTotalQuestionCifCodes(question) }}</span>
                                </div>
                              </div>
                              <v-table density="compact" class="modern-table">
                                <thead>
                                  <tr>
                                    <th class="text-left">File Name</th>
                                    <th class="text-center" style="width: 100px">CIF Count</th>
                                    <th class="text-center" style="width: 120px">Upload Date</th>
                                    <th class="text-center" style="width: 180px">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(file, fileIndex) in question.cifFiles" :key="fileIndex">
                                    <td class="py-2">
                                      <div class="d-flex align-center">
                                        <v-icon class="mr-2" color="success" size="16">mdi-file-document</v-icon>
                                        <div>
                                          <div style="font-size: 13px">{{ file.fileName }}</div>
                                          <div style="font-size: 11px; color: #666">{{ formatFileSize(file.fileSize) }}</div>
                                        </div>
                                      </div>
                                    </td>
                                    <td class="text-center py-2">
                                      <v-chip size="x-small" color="primary" variant="outlined">
                                        {{ file.cifList ? file.cifList.length : 0 }}
                                      </v-chip>
                                    </td>
                                    <td class="text-center py-2" style="font-size: 11px">
                                      {{ formatUploadDate(file.uploadDate) }}
                                    </td>
                                    <td class="text-center py-2">
                                      <v-btn variant="outlined" color="primary" size="x-small" class="mr-1" @click="downloadQuestionCifFile(file)">
                                        <v-icon size="14">mdi-download</v-icon>
                                      </v-btn>
                                      <v-btn variant="outlined" color="error" size="x-small" @click="removeQuestionCifFile(index, fileIndex)">
                                        <v-icon size="14">mdi-delete</v-icon>
                                      </v-btn>
                                    </td>
                                  </tr>
                                </tbody>
                              </v-table>
                              <div v-if="question.cifFiles.length > 1" class="d-flex justify-end mt-2">
                                <v-btn variant="outlined" color="error" size="x-small" @click="clearAllQuestionCifFiles(index)">
                                  <v-icon size="14" class="mr-1">mdi-delete-sweep</v-icon>
                                  Clear All
                                </v-btn>
                              </div>
                            </v-card>
                          </div>

                          <!-- Segment and Wealth Membership (Only show when targetGroup is 'persona') -->
                          <v-row v-if="question.targetGroup === 'persona'" class="mb-3">
                            <v-col cols="6">
                              <label class="form-label">Segment</label>
                              <v-select
                                v-model="question.segment"
                                :items="segmentOptions"
                                item-title="name"
                                item-value="valueString"
                                variant="solo"
                                density="compact"
                                multiple
                                chips
                                class="custom-select"
                                hide-details
                                flat
                                :disabled="!canEdit"
                              ></v-select>
                            </v-col>
                            <v-col cols="6">
                              <label class="form-label">Wealth Membership</label>
                              <v-select
                                v-model="question.wealthMembership"
                                :items="wealthMembershipOptions"
                                item-title="name"
                                item-value="valueString"
                                variant="solo"
                                density="compact"
                                multiple
                                chips
                                class="custom-select"
                                hide-details
                                flat
                                :disabled="!canEdit"
                              ></v-select>
                            </v-col>
                          </v-row>

                          <!-- Effective Dates -->
                          <v-row class="mb-3">
                            <v-col cols="6">
                              <label class="form-label">Effective Start Date</label>
                              <input v-model="question.effectiveStartDate" type="datetime-local" step="60" class="custom-input" :disabled="!canEdit" />
                            </v-col>
                            <v-col cols="6">
                              <label class="form-label">Effective End Date</label>
                              <input
                                v-model="question.effectiveEndDate"
                                type="datetime-local"
                                step="60"
                                class="custom-input"
                                :class="{ 'input-error': !validateDateRange(question.effectiveStartDate, question.effectiveEndDate) }"
                                :disabled="!canEdit"
                              />
                              <div v-if="!validateDateRange(question.effectiveStartDate, question.effectiveEndDate)" class="error-message">End Date must be on or after Start Date</div>
                            </v-col>
                          </v-row>

                          <!-- Enable -->
                          <div class="d-flex align-center justify-end">
                            <v-switch inset class="ma-0" v-model="question.questionEnabled" label="Enable" color="#4E3982" hide-details :disabled="!canEdit"></v-switch>
                            <v-switch inset class="ma-0 ml-3" v-model="question.taxPlanningEnabled" :label="$t('forTaxPlanningMode')" color="#4E3982" hide-details :disabled="!canEdit"></v-switch>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" md="5" class="split-preview-col">
                  <div class="mobile-preview-sticky">
                    <div style="background-color: #f3f3f3; border-radius: 14px; padding: 24px 0" class="d-flex justify-center align-center">
                      <v-skeleton-loader v-if="loading" type="image" width="268" height="582" class="mobile-skeleton"></v-skeleton-loader>
                      <div v-else :class="config.voice.enabled ? 'sug-simulator-bg' : 'sug-simulator-bg-without-mic'" class="sug-simulator py-4 px-3 d-flex flex-column">
                        <div style="flex: 1"></div>
                        <div class="mb-4">
                          <div v-if="suggestBarText || suggestBarTextEN" class="mb-2" style="font-size: 12px; font-weight: 500; color: #ffffff">
                            {{ suggestBarText || suggestBarTextEN }}
                          </div>
                          <div class="d-flex flex-wrap justify-space-between" style="gap: 8px">
                            <!-- Show actual enabled features from API -->
                            <template v-for="(feature, index) in suggestionConfig.features" :key="`feat-${index}`">
                              <div v-if="feature && feature.featureEnabled" class="feature-card d-flex flex-column align-center">
                                <v-img
                                  v-if="getFeatureImageUrl(feature, index)"
                                  :src="getFeatureImageUrl(feature, index)"
                                  width="46"
                                  height="46"
                                  class="mb-1 rounded"
                                  @error="onImageError(feature, index)"
                                >
                                  <template v-slot:placeholder>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                      <v-progress-circular indeterminate color="grey-lighten-5" size="20"></v-progress-circular>
                                    </v-row>
                                  </template>
                                  <template v-slot:error>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                      <v-icon color="grey-lighten-3" size="16">mdi-image-broken-variant</v-icon>
                                    </v-row>
                                  </template>
                                </v-img>
                                <!-- Plain square box placeholder when no image -->
                                <div v-else class="mb-1" style="width: 44px; height: 44px; background-color: #f5f5f5; border: 1px solid #ccc; border-radius: 4px"></div>
                                <span style="color: white; font-size: 8px; text-align: center; line-height: 1; font-weight: bold">
                                  {{ feature.messages?.thai || feature.messages?.english || `Feature${index + 1}` }}
                                </span>
                              </div>
                            </template>
                          </div>
                        </div>

                        <!-- Suggestion Questions (2x2 grid) - Show real data -->
                        <div class="mb-4">
                          <div class="d-flex flex-column" style="gap: 6px">
                            <!-- First row -->
                            <div class="d-flex justify-space-between" style="gap: 10px">
                              <template v-for="(question, index) in suggestionQuestionConfig.questions.slice(0, 2)" :key="`feat-question-${index}`">
                                <div
                                  v-if="question && question.questionEnabled"
                                  class="pa-2 d-flex align-center justify-center"
                                  style="background: rgba(122, 122, 122, 0.1); backdrop-filter: blur(2px); border-radius: 16px; width: 100%; height: 28px; cursor: pointer; border: 1px solid #fff"
                                >
                                  <span style="font-size: 8px; color: white; text-align: center; font-weight: bold">
                                    {{ question.messages?.thai || question.messages?.english || `Question ${index + 1}` }}
                                  </span>
                                </div>
                              </template>
                            </div>
                            <!-- Second row -->
                            <div class="d-flex justify-space-between" style="gap: 10px">
                              <template v-for="(question, index) in suggestionQuestionConfig.questions.slice(2, 4)" :key="`feat-question-${index + 2}`">
                                <div
                                  v-if="question && question.questionEnabled"
                                  class="pa-2 d-flex align-center justify-center"
                                  style="background: rgba(122, 122, 122, 0.1); backdrop-filter: blur(2px); border-radius: 16px; width: 100%; height: 28px; cursor: pointer; border: 1px solid #fff"
                                >
                                  <span style="font-size: 8px; color: white; text-align: center; font-weight: bold">
                                    {{ question.messages?.thai || question.messages?.english || `Question ${index + 3}` }}
                                  </span>
                                </div>
                              </template>
                            </div>
                          </div>
                        </div>

                        <!-- Spacer to push flags to bottom -->

                        <!-- Language Flags -->

                        <div class="grow-0">
                          <div class="d-flex justify-start align-center px-2 available-language-text-container" style="gap: 4px; font-size: 10px; color: #a4a4a4">
                            <span> รองรับภาษา: </span>
                            <template v-for="(lang, index) in enabledLanguages" :key="lang.key">
                              <span class="available-language-text">{{ lang.text }}</span>
                              <span v-if="index < enabledLanguages.length - 1">,</span>
                            </template>
                          </div>
                          <v-img :src="config.voice.enabled ? '/lhb/chat.png' : '/lhb/chat-no-mic.png'" contain></v-img>
                          <p class="my-2" v-if="config.postMessage.enabled" style="font-size: 7px; text-align: center" :style="{ color: postMessagePreviewColor }">{{ postMessageText }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-window-item>

            <!-- Genie AI Character Tab -->
            <v-window-item>
              <v-row style="padding: 25px" class="preview-split-row">
                <v-col cols="12" md="7" class="split-form-col">
                  <!-- Loading Skeleton for Genie AI Characters -->
                  <div v-if="loading">
                    <v-skeleton-loader type="heading" class="mb-4"></v-skeleton-loader>
                    <v-skeleton-loader type="card" class="mb-4"></v-skeleton-loader>
                    <v-skeleton-loader type="card" class="mb-4"></v-skeleton-loader>
                  </div>

                  <!-- Genie AI Character Content -->
                  <div v-else class="mb-4">
                    <div class="d-flex start align-center mb-3">
                      <h3 class="language-config-title mr-3">Genie AI Character</h3>
                    </div>

                    <div class="suggestion-form">
                      <v-row>
                        <v-col cols="6">
                          <div class="mb-3">
                            <v-btn color="#4E3982" variant="outlined" style="height: 40px; border-radius: 12px; text-transform: none" @click="addNewGenieCharacter" :disabled="!canAdd">
                              <v-icon start size="small">mdi-plus</v-icon>
                              Add Character
                            </v-btn>
                            <span class="ml-2 text-caption">{{ genieCharacters.length }} Character(s)</span>
                          </div>
                        </v-col>
                      </v-row>

                      <!-- Dynamic Characters -->
                      <div v-for="({ character, index }) in paginatedGenieCharacters" :key="index" class="feature-section mb-4 pa-4" style="border: 1px solid #e0e0e0; border-radius: 8px">
                        <div class="d-flex align-center mb-2">
                          <h4>Character {{ index + 1 }}</h4>
                          <div style="flex-grow: 1; background-color: #000000; opacity: 20%; height: 1px" class="mx-2"></div>

                          <!-- Preview Button -->
                          <v-btn icon size="small" variant="plain" color="#4E3982" @click="previewGenieCharacter(index)" class="mr-1" :title="'Preview this character'">
                            <v-icon>mdi-eye</v-icon>
                          </v-btn>

                          <!-- Remove Character Button -->
                          <v-btn v-if="genieCharacters.length > 1" icon size="small" variant="plain" color="error" @click="removeGenieCharacter(index)" class="mr-2">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>

                          <!-- Collapse/Expand Button -->
                          <v-btn icon size="small" variant="plain" @click="character.collapsed = !character.collapsed">
                            <v-icon size="28">{{ character.collapsed ? 'mdi-menu-down' : 'mdi-menu-up' }}</v-icon>
                          </v-btn>
                        </div>

                        <div v-if="!character.collapsed">
                          <!-- Character Name -->
                          <div class="mb-3">
                            <label class="form-label">Character Name <span style="color: red">*</span></label>
                            <input v-model="character.characterName" placeholder="Enter character name" class="custom-input" :disabled="!canEdit" />
                          </div>

                          <!-- Icon Uploads - 4 icons in a row -->
                          <div class="mb-3">
                            <label class="form-label">Character Icons <span style="color: red">*</span></label>
                            <div class="text-caption text-grey mb-1">Any image type, max 10MB per file. GIF format is validated before upload.</div>
                            <v-row>
                              <!-- Proactive Icon -->
                              <v-col cols="3">
                                <div class="text-center mb-1" style="font-size: 12px; font-weight: 500; color: #666">Proactive</div>
                                <div class="genie-icon-upload-box" @click="canEdit ? triggerGenieIconUpload(index, 'proactive') : null" :style="!canEdit ? 'opacity: 0.6; cursor: not-allowed; pointer-events: none' : ''">
                                  <v-img v-if="character.iconProactiveUrl" :src="character.iconProactiveUrl" width="100%" height="100%" cover style="border-radius: 8px">
                                    <template v-slot:error>
                                      <div class="d-flex align-center justify-center fill-height">
                                        <v-icon color="grey" size="28">mdi-image-broken-variant</v-icon>
                                      </div>
                                    </template>
                                  </v-img>
                                  <div v-else class="genie-icon-placeholder">
                                    <v-icon color="#ccc" size="28">mdi-image-plus</v-icon>
                                    <span style="font-size: 10px; color: #999; margin-top: 4px">Upload</span>
                                  </div>
                                </div>
                              </v-col>

                              <!-- Chat First Icon -->
                              <v-col cols="3">
                                <div class="text-center mb-1" style="font-size: 12px; font-weight: 500; color: #666">Chat First</div>
                                <div class="genie-icon-upload-box" @click="canEdit ? triggerGenieIconUpload(index, 'chatFirst') : null" :style="!canEdit ? 'opacity: 0.6; cursor: not-allowed; pointer-events: none' : ''">
                                  <v-img v-if="character.iconChatFirstUrl" :src="character.iconChatFirstUrl" width="100%" height="100%" cover style="border-radius: 8px">
                                    <template v-slot:error>
                                      <div class="d-flex align-center justify-center fill-height">
                                        <v-icon color="grey" size="28">mdi-image-broken-variant</v-icon>
                                      </div>
                                    </template>
                                  </v-img>
                                  <div v-else class="genie-icon-placeholder">
                                    <v-icon color="#ccc" size="28">mdi-image-plus</v-icon>
                                    <span style="font-size: 10px; color: #999; margin-top: 4px">Upload</span>
                                  </div>
                                </div>
                              </v-col>

                              <!-- Chat Icon -->
                              <v-col cols="3">
                                <div class="text-center mb-1" style="font-size: 12px; font-weight: 500; color: #666">Chat</div>
                                <div class="genie-icon-upload-box" @click="canEdit ? triggerGenieIconUpload(index, 'chat') : null" :style="!canEdit ? 'opacity: 0.6; cursor: not-allowed; pointer-events: none' : ''">
                                  <v-img v-if="character.iconChatUrl" :src="character.iconChatUrl" width="100%" height="100%" cover style="border-radius: 8px">
                                    <template v-slot:error>
                                      <div class="d-flex align-center justify-center fill-height">
                                        <v-icon color="grey" size="28">mdi-image-broken-variant</v-icon>
                                      </div>
                                    </template>
                                  </v-img>
                                  <div v-else class="genie-icon-placeholder">
                                    <v-icon color="#ccc" size="28">mdi-image-plus</v-icon>
                                    <span style="font-size: 10px; color: #999; margin-top: 4px">Upload</span>
                                  </div>
                                </div>
                              </v-col>

                              <!-- Voice Page Icon -->
                              <v-col cols="3">
                                <div class="text-center mb-1" style="font-size: 12px; font-weight: 500; color: #666">Voice Page</div>
                                <div class="genie-icon-upload-box" @click="canEdit ? triggerGenieIconUpload(index, 'voicePage') : null" :style="!canEdit ? 'opacity: 0.6; cursor: not-allowed; pointer-events: none' : ''">
                                  <v-img v-if="character.iconVoicePageUrl" :src="character.iconVoicePageUrl" width="100%" height="100%" cover style="border-radius: 8px">
                                    <template v-slot:error>
                                      <div class="d-flex align-center justify-center fill-height">
                                        <v-icon color="grey" size="28">mdi-image-broken-variant</v-icon>
                                      </div>
                                    </template>
                                  </v-img>
                                  <div v-else class="genie-icon-placeholder">
                                    <v-icon color="#ccc" size="28">mdi-image-plus</v-icon>
                                    <span style="font-size: 10px; color: #999; margin-top: 4px">Upload</span>
                                  </div>
                                </div>
                              </v-col>
                            </v-row>
                          </div>

                          <div v-if="character.iconValidationTouched && getMissingGenieIconLabels(character).length" class="error-message" role="alert">
                            Character Icons are required: {{ getMissingGenieIconLabels(character).join(', ') }}
                          </div>

                          <!-- Effective Dates -->
                          <v-row class="mb-3">
                            <v-col cols="6">
                              <label class="form-label">Effective Start Date <span style="color: red">*</span></label>
                              <input v-model="character.effectiveStartDate" type="datetime-local" step="60" class="custom-input" :class="{ 'input-error': !character.effectiveStartDate }" :disabled="!canEdit" />
                              <div v-if="!character.effectiveStartDate" class="error-message">Effective Start Date is required</div>
                            </v-col>
                            <v-col cols="6">
                              <label class="form-label">Effective End Date</label>
                              <input
                                v-model="character.effectiveEndDate"
                                type="datetime-local"
                                step="60"
                                class="custom-input"
                                :class="{ 'input-error': !validateDateRange(character.effectiveStartDate, character.effectiveEndDate) }"
                                :disabled="!canEdit"
                              />
                              <div v-if="!validateDateRange(character.effectiveStartDate, character.effectiveEndDate)" class="error-message">End Date must be on or after Start Date</div>
                            </v-col>
                          </v-row>

                          <!-- Active Switch -->
                          <div class="d-flex align-center justify-end">
                            <v-switch inset class="ma-0" v-model="character.isActive" label="Active" color="#4E3982" hide-details :disabled="!canEdit"></v-switch>
                            <v-switch inset class="ma-0 ml-3" v-model="character.showInProactiveMode" :label="$t('showInProactiveMode')" color="#4E3982" hide-details :disabled="!canEdit"></v-switch>
                            <v-switch inset class="ma-0 ml-3" v-model="character.taxPlanningEnabled" :label="$t('forTaxPlanningMode')" color="#4E3982" hide-details :disabled="!canEdit"></v-switch>
                          </div>
                        </div>
                      </div>

                      <div class="d-flex align-center justify-end mt-2" style="gap: 12px">
                        <div class="text-caption text-medium-emphasis">Items per page:</div>
                        <div style="max-width: 90px">
                          <v-select
                            v-model="genieCharactersPerPage"
                            :items="genieCharactersPerPageOptions"
                            density="compact"
                            variant="outlined"
                            hide-details
                          ></v-select>
                        </div>
                        <v-pagination
                          v-model="genieCharactersPage"
                          :length="genieCharactersTotalPages"
                          :total-visible="4"
                          density="compact"
                        ></v-pagination>
                      </div>
                    </div>
                  </div>
                </v-col>

                <!-- Preview Column -->
                <v-col cols="12" md="5" class="split-preview-col">
                  <div class="mobile-preview-sticky">
                    <!-- Manual preview notice -->

                    <div style="background-color: #f3f3f3; border-radius: 14px; padding: 24px 0" class="d-flex justify-center align-center">
                      <v-skeleton-loader v-if="loading" type="image" width="268" height="582" class="mobile-skeleton"></v-skeleton-loader>
                      <div v-else class="mobile-preview-simulator py-2 px-4 white--text d-flex flex-column">
                        <div class="px-4 d-flex justify-space-between align-center grow-0">
                          <span>9:41</span>
                          <div>
                            <v-icon color="white" size="small" class="mr-2">mdi-wifi</v-icon>
                            <v-icon color="white" size="small" class="mr-2" style="rotate: 90deg">mdi-battery-90</v-icon>
                          </div>
                        </div>

                        <div class="grow pt-6 mt-4">
                          <div class="d-flex ml-auto text-white" style="width: 80%">
                            <p class="pa-3 rounded ml-auto" style="background-color: #262d47; font-size: 10px">ฉันต้องการอายัดบัตรเครดิต</p>
                          </div>
                          <div class="d-flex mt-2" style="width: 80%">
                            <div style="width: 26px; height: 26px; flex-shrink: 0">
                              <v-img
                                v-if="currentGeniePreviewIndex !== null && genieCharacters[currentGeniePreviewIndex]?.iconChatUrl"
                                :src="genieCharacters[currentGeniePreviewIndex].iconChatUrl"
                                width="26" height="26"
                              ></v-img>
                              <v-img v-else src="/lhb/listen.svg" width="26" height="26"></v-img>
                            </div>
                            <div class="pa-2 rounded text-white" style="background-color: #3e4661; font-size: 10px">
                              <p>ได้เลย, คุณสามารถ ไปที่บัตรเครดิต &gt; เลือกจัดการบัตร &gt; อายัดบัตรเครดิต</p>
                              <p>คุณต้องการทำรายการอื่นอีกไหมคะ?</p>
                              <div style="width: 100%; height: 1px; background-color: #f8f8f8; opacity: 0.5"></div>
                              <div class="d-flex mt-3 mb-1">
                                <img src="/lhb/heart.svg" width="14" class="mr-2" alt="some icon" />
                                <img v-if="config.ttsEnabled" src="/lhb/volume.svg" width="14" class="mr-2" alt="some icon" />
                                <img v-if="config.copyMessage.enabled" src="/lhb/copy.svg" width="10" class="mr-2" alt="some icon" />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="grow-0">
                          <div class="d-flex justify-start align-center px-2 available-language-text-container" style="gap: 4px; font-size: 10px; color: #a4a4a4">
                            <span> รองรับภาษา: </span>
                            <template v-for="(lang, index) in enabledLanguages" :key="lang.key">
                              <span class="available-language-text">{{ lang.text }}</span>
                              <span v-if="index < enabledLanguages.length - 1">,</span>
                            </template>
                          </div>
                          <v-img :src="config.voice.enabled ? '/lhb/chat.png' : '/lhb/chat-no-mic.png'" contain></v-img>
                          <p class="my-2" v-if="config.postMessage.enabled" style="font-size: 7px; text-align: center" :style="{ color: postMessagePreviewColor }">{{ postMessageText }}</p>
                        </div>
                      </div>
                    </div>
                    <div v-if="geniePreviewIsManual" class="d-flex align-center justify-space-between mt-2 px-2 py-2" style="background-color: #ede9f7; border-radius: 10px; border: 1px solid #c9bbec">
                      <span style="font-size: 12px; color: #4E3982">
                        <v-icon size="14" color="#4E3982" class="mr-1">mdi-eye</v-icon>
                        Preview: <strong>{{ genieCharacters[geniePreviewIndex]?.characterName || `Character ${geniePreviewIndex + 1}` }}</strong>
                      </span>
                      <v-btn size="x-small" variant="outlined" color="#4E3982" style="border-radius: 8px; text-transform: none; font-size: 11px" @click="resetGeniePreview">
                        <v-icon size="12" class="mr-1">mdi-restore</v-icon>
                        {{ $t('reset') }}
                      </v-btn>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-window-item>

            <!-- Genie Prefix Tab -->
            <v-window-item>
              <v-row style="padding: 25px">
                <v-col cols="12">
                  <!-- Loading Skeleton for Genie Prefix -->
                  <div v-if="loading">
                    <v-skeleton-loader type="heading" class="mb-4"></v-skeleton-loader>
                    <v-skeleton-loader type="table" class="mb-4"></v-skeleton-loader>
                  </div>

                  <!-- Genie Prefix Patterns (Think Loader) -->
                  <div v-else class="mb-4">
                    <div class="d-flex align-center mb-3">
                      <h3 class="language-config-title mr-3">Think Loader Patterns</h3>
                      <span class="text-caption">{{ geniePrefixPatterns.length }} Pattern(s)</span>
                      <v-spacer></v-spacer>
                      <v-btn color="#4E3982" variant="outlined" style="height: 40px; border-radius: 12px; text-transform: none" @click="addGeniePrefixPattern" :disabled="!canAdd">
                        <v-icon start size="small">mdi-plus</v-icon>
                        Add Pattern
                      </v-btn>
                    </div>

                    <v-data-table
                      :headers="geniePrefixPatternHeaders"
                      :items="geniePrefixPatterns"
                      item-value="uid"
                      v-model:expanded="expandedGeniePrefixPatterns"
                      show-expand
                      :items-per-page="10"
                      density="comfortable"
                      no-data-text="No patterns yet — click Add Pattern to create one"
                    >
                      <template #[`item.patternNumber`]="{ item }">
                        {{ geniePrefixPatterns.indexOf(item) + 1 }}
                      </template>

                      <template #[`item.patternName`]="{ item }">
                        <input v-model="item.patternName" placeholder="Enter pattern name" class="custom-input" :disabled="!canEdit" />
                      </template>

                      <template #[`item.steps`]="{ item }">
                        <v-chip size="small" color="#4E3982" variant="tonal">{{ item.steps.length }} step(s)</v-chip>
                      </template>

                      <template #[`item.effectiveStartDate`]="{ item }">
                        <input v-model="item.effectiveStartDate" type="datetime-local" step="60" class="custom-input" :disabled="!canEdit" />
                      </template>

                      <template #[`item.effectiveEndDate`]="{ item }">
                        <input v-model="item.effectiveEndDate" type="datetime-local" step="60" class="custom-input" :class="{ 'input-error': !validateDateRange(item.effectiveStartDate, item.effectiveEndDate) }" :disabled="!canEdit" />
                      </template>

                      <template #[`item.isActive`]="{ item }">
                        <v-switch inset class="ma-0" v-model="item.isActive" color="#4E3982" hide-details :disabled="!canEdit"></v-switch>
                      </template>

                      <template #[`item.actions`]="{ item }">
                        <v-btn icon size="small" variant="plain" color="error" @click="removeGeniePrefixPattern(item)" :disabled="!canDelete">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>

                      <template #expanded-row="{ columns, item }">
                        <tr>
                          <td :colspan="columns.length" class="pa-4" style="background-color: #fbfaff">
                            <div class="d-flex align-center mb-2">
                              <h4>Steps</h4>
                              <v-spacer></v-spacer>
                              <v-btn size="small" color="#4E3982" variant="outlined" style="text-transform: none" @click="addGeniePrefixStep(item)" :disabled="!canEdit">
                                <v-icon start size="small">mdi-plus</v-icon>
                                Add Step
                              </v-btn>
                            </div>

                            <v-table density="compact" style="background: transparent">
                              <thead>
                                <tr>
                                  <th style="width: 55px">Step</th>
                                  <th style="width: 120px">Duration (sec)</th>
                                  <th>Thai <span style="color: red">*</span></th>
                                  <th>English <span style="color: red">*</span></th>
                                  <th>Chinese <span style="color: red">*</span></th>
                                  <th style="width: 120px"></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(step, sIdx) in item.steps" :key="step.uid">
                                  <td class="text-center" style="vertical-align: top; padding-top: 14px">{{ sIdx + 1 }}</td>
                                  <td style="vertical-align: top; padding-top: 10px">
                                    <input type="number" min="1" v-model.number="step.durationSec" class="custom-input" :disabled="!canEdit" />
                                  </td>

                                  <!-- Thai -->
                                  <td class="pa-2" style="min-width: 220px; vertical-align: top">
                                    <textarea v-model="step.textThai" placeholder="Text (required)" class="custom-input mb-1" :class="{ 'input-error': !step.textThai?.trim() }" rows="2" style="resize: none" :disabled="!canEdit"></textarea>

                                    <div class="text-caption text-medium-emphasis" style="margin-top: 4px">Default Voice <span style="color: red">*</span></div>
                                    <div v-if="step.mp3Thai.fileName" class="d-flex align-center" style="gap: 4px">
                                      <v-icon color="#4E3982" size="16">mdi-file-music</v-icon>
                                      <span class="genie-prefix-file-name-col" style="max-width: 110px">{{ step.mp3Thai.fileName }}</span>
                                      <v-btn icon size="x-small" variant="tonal" color="#4E3982" @click="playGeniePrefixStepMp3(item, sIdx, 'thai', 'default')" :title="geniePrefixVoicePlaying === `${item.uid}_${sIdx}_thai_default` ? 'Stop' : 'Play'">
                                        <v-icon size="14">{{ geniePrefixVoicePlaying === `${item.uid}_${sIdx}_thai_default` ? 'mdi-stop' : 'mdi-play' }}</v-icon>
                                      </v-btn>
                                      <v-btn icon size="x-small" variant="plain" color="error" @click="removeGeniePrefixStepMp3(item, sIdx, 'thai', 'default')" :disabled="!canEdit" title="Remove">
                                        <v-icon size="14">mdi-delete</v-icon>
                                      </v-btn>
                                    </div>
                                    <div v-else class="genie-step-upload-box" @click="canEdit ? triggerGeniePrefixStepMp3Upload(item, sIdx, 'thai', 'default') : null" :style="!canEdit ? 'opacity: 0.6; cursor: not-allowed; pointer-events: none' : ''">
                                      <v-icon color="#c62828" size="18">mdi-upload</v-icon>
                                      <span>Upload MP3 <span style="color: red">*</span></span>
                                    </div>

                                    <div class="text-caption text-medium-emphasis" style="margin-top: 6px">Gemini Voice</div>
                                    <div v-if="step.geminiMp3Thai.fileName" class="d-flex align-center" style="gap: 4px">
                                      <v-icon color="#4285F4" size="16">mdi-file-music</v-icon>
                                      <span class="genie-prefix-file-name-col" style="max-width: 110px">{{ step.geminiMp3Thai.fileName }}</span>
                                      <v-btn icon size="x-small" variant="tonal" color="#4285F4" @click="playGeniePrefixStepMp3(item, sIdx, 'thai', 'gemini')" :title="geniePrefixVoicePlaying === `${item.uid}_${sIdx}_thai_gemini` ? 'Stop' : 'Play'">
                                        <v-icon size="14">{{ geniePrefixVoicePlaying === `${item.uid}_${sIdx}_thai_gemini` ? 'mdi-stop' : 'mdi-play' }}</v-icon>
                                      </v-btn>
                                      <v-btn icon size="x-small" variant="plain" color="error" @click="removeGeniePrefixStepMp3(item, sIdx, 'thai', 'gemini')" :disabled="!canEdit" title="Remove">
                                        <v-icon size="14">mdi-delete</v-icon>
                                      </v-btn>
                                    </div>
                                    <div v-else class="genie-step-upload-box" @click="canEdit ? triggerGeniePrefixStepMp3Upload(item, sIdx, 'thai', 'gemini') : null" :style="!canEdit ? 'opacity: 0.6; cursor: not-allowed; pointer-events: none' : ''">
                                      <v-icon color="#4285F4" size="18">mdi-upload</v-icon>
                                      <span>Upload MP3</span>
                                    </div>
                                  </td>

                                  <!-- English -->
                                  <td class="pa-2" style="min-width: 220px; vertical-align: top">
                                    <textarea v-model="step.textEnglish" placeholder="Text (required)" class="custom-input mb-1" :class="{ 'input-error': !step.textEnglish?.trim() }" rows="2" style="resize: none" :disabled="!canEdit"></textarea>

                                    <div class="text-caption text-medium-emphasis" style="margin-top: 4px">Default Voice <span style="color: red">*</span></div>
                                    <div v-if="step.mp3English.fileName" class="d-flex align-center" style="gap: 4px">
                                      <v-icon color="#4E3982" size="16">mdi-file-music</v-icon>
                                      <span class="genie-prefix-file-name-col" style="max-width: 110px">{{ step.mp3English.fileName }}</span>
                                      <v-btn icon size="x-small" variant="tonal" color="#4E3982" @click="playGeniePrefixStepMp3(item, sIdx, 'english', 'default')" :title="geniePrefixVoicePlaying === `${item.uid}_${sIdx}_english_default` ? 'Stop' : 'Play'">
                                        <v-icon size="14">{{ geniePrefixVoicePlaying === `${item.uid}_${sIdx}_english_default` ? 'mdi-stop' : 'mdi-play' }}</v-icon>
                                      </v-btn>
                                      <v-btn icon size="x-small" variant="plain" color="error" @click="removeGeniePrefixStepMp3(item, sIdx, 'english', 'default')" :disabled="!canEdit" title="Remove">
                                        <v-icon size="14">mdi-delete</v-icon>
                                      </v-btn>
                                    </div>
                                    <div v-else class="genie-step-upload-box" @click="canEdit ? triggerGeniePrefixStepMp3Upload(item, sIdx, 'english', 'default') : null" :style="!canEdit ? 'opacity: 0.6; cursor: not-allowed; pointer-events: none' : ''">
                                      <v-icon color="#c62828" size="18">mdi-upload</v-icon>
                                      <span>Upload MP3 <span style="color: red">*</span></span>
                                    </div>

                                    <div class="text-caption text-medium-emphasis" style="margin-top: 6px">Gemini Voice</div>
                                    <div v-if="step.geminiMp3English.fileName" class="d-flex align-center" style="gap: 4px">
                                      <v-icon color="#4285F4" size="16">mdi-file-music</v-icon>
                                      <span class="genie-prefix-file-name-col" style="max-width: 110px">{{ step.geminiMp3English.fileName }}</span>
                                      <v-btn icon size="x-small" variant="tonal" color="#4285F4" @click="playGeniePrefixStepMp3(item, sIdx, 'english', 'gemini')" :title="geniePrefixVoicePlaying === `${item.uid}_${sIdx}_english_gemini` ? 'Stop' : 'Play'">
                                        <v-icon size="14">{{ geniePrefixVoicePlaying === `${item.uid}_${sIdx}_english_gemini` ? 'mdi-stop' : 'mdi-play' }}</v-icon>
                                      </v-btn>
                                      <v-btn icon size="x-small" variant="plain" color="error" @click="removeGeniePrefixStepMp3(item, sIdx, 'english', 'gemini')" :disabled="!canEdit" title="Remove">
                                        <v-icon size="14">mdi-delete</v-icon>
                                      </v-btn>
                                    </div>
                                    <div v-else class="genie-step-upload-box" @click="canEdit ? triggerGeniePrefixStepMp3Upload(item, sIdx, 'english', 'gemini') : null" :style="!canEdit ? 'opacity: 0.6; cursor: not-allowed; pointer-events: none' : ''">
                                      <v-icon color="#4285F4" size="18">mdi-upload</v-icon>
                                      <span>Upload MP3</span>
                                    </div>
                                  </td>

                                  <!-- Chinese (zh-TW) -->
                                  <td class="pa-2" style="min-width: 220px; vertical-align: top">
                                    <textarea v-model="step.textChinese" placeholder="Text (required)" class="custom-input mb-1" :class="{ 'input-error': !step.textChinese?.trim() }" rows="2" style="resize: none" :disabled="!canEdit"></textarea>

                                    <div class="text-caption text-medium-emphasis" style="margin-top: 4px">Default Voice <span style="color: red">*</span></div>
                                    <div v-if="step.mp3Chinese.fileName" class="d-flex align-center" style="gap: 4px">
                                      <v-icon color="#4E3982" size="16">mdi-file-music</v-icon>
                                      <span class="genie-prefix-file-name-col" style="max-width: 110px">{{ step.mp3Chinese.fileName }}</span>
                                      <v-btn icon size="x-small" variant="tonal" color="#4E3982" @click="playGeniePrefixStepMp3(item, sIdx, 'chinese', 'default')" :title="geniePrefixVoicePlaying === `${item.uid}_${sIdx}_chinese_default` ? 'Stop' : 'Play'">
                                        <v-icon size="14">{{ geniePrefixVoicePlaying === `${item.uid}_${sIdx}_chinese_default` ? 'mdi-stop' : 'mdi-play' }}</v-icon>
                                      </v-btn>
                                      <v-btn icon size="x-small" variant="plain" color="error" @click="removeGeniePrefixStepMp3(item, sIdx, 'chinese', 'default')" :disabled="!canEdit" title="Remove">
                                        <v-icon size="14">mdi-delete</v-icon>
                                      </v-btn>
                                    </div>
                                    <div v-else class="genie-step-upload-box" @click="canEdit ? triggerGeniePrefixStepMp3Upload(item, sIdx, 'chinese', 'default') : null" :style="!canEdit ? 'opacity: 0.6; cursor: not-allowed; pointer-events: none' : ''">
                                      <v-icon color="#c62828" size="18">mdi-upload</v-icon>
                                      <span>Upload MP3 <span style="color: red">*</span></span>
                                    </div>

                                    <div class="text-caption text-medium-emphasis" style="margin-top: 6px">Gemini Voice</div>
                                    <div v-if="step.geminiMp3Chinese.fileName" class="d-flex align-center" style="gap: 4px">
                                      <v-icon color="#4285F4" size="16">mdi-file-music</v-icon>
                                      <span class="genie-prefix-file-name-col" style="max-width: 110px">{{ step.geminiMp3Chinese.fileName }}</span>
                                      <v-btn icon size="x-small" variant="tonal" color="#4285F4" @click="playGeniePrefixStepMp3(item, sIdx, 'chinese', 'gemini')" :title="geniePrefixVoicePlaying === `${item.uid}_${sIdx}_chinese_gemini` ? 'Stop' : 'Play'">
                                        <v-icon size="14">{{ geniePrefixVoicePlaying === `${item.uid}_${sIdx}_chinese_gemini` ? 'mdi-stop' : 'mdi-play' }}</v-icon>
                                      </v-btn>
                                      <v-btn icon size="x-small" variant="plain" color="error" @click="removeGeniePrefixStepMp3(item, sIdx, 'chinese', 'gemini')" :disabled="!canEdit" title="Remove">
                                        <v-icon size="14">mdi-delete</v-icon>
                                      </v-btn>
                                    </div>
                                    <div v-else class="genie-step-upload-box" @click="canEdit ? triggerGeniePrefixStepMp3Upload(item, sIdx, 'chinese', 'gemini') : null" :style="!canEdit ? 'opacity: 0.6; cursor: not-allowed; pointer-events: none' : ''">
                                      <v-icon color="#4285F4" size="18">mdi-upload</v-icon>
                                      <span>Upload MP3</span>
                                    </div>
                                  </td>

                                  <td style="vertical-align: top; padding-top: 10px; white-space: nowrap">
                                    <v-btn icon size="x-small" variant="plain" @click="moveGeniePrefixStep(item, sIdx, -1)" :disabled="sIdx === 0 || !canEdit" title="Move up">
                                      <v-icon size="16">mdi-arrow-up</v-icon>
                                    </v-btn>
                                    <v-btn icon size="x-small" variant="plain" @click="moveGeniePrefixStep(item, sIdx, 1)" :disabled="sIdx === item.steps.length - 1 || !canEdit" title="Move down">
                                      <v-icon size="16">mdi-arrow-down</v-icon>
                                    </v-btn>
                                    <v-btn icon size="x-small" variant="plain" color="error" @click="removeGeniePrefixStep(item, sIdx)" :disabled="!canEdit" title="Remove step">
                                      <v-icon size="16">mdi-delete</v-icon>
                                    </v-btn>
                                  </td>
                                </tr>
                                <tr v-if="item.steps.length === 0">
                                  <td colspan="6" class="text-center text-caption py-4">No steps yet — click "Add Step".</td>
                                </tr>
                              </tbody>
                            </v-table>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </div>
                </v-col>
              </v-row>
            </v-window-item>

            <!-- Wake Word Tab (#786) — saves itself after each confirmed change; the Save button below does not send it -->
            <v-window-item>
              <v-row style="padding: 25px">
                <v-col cols="12">
                  <WakeWordTab
                    v-model="wakeWords"
                    :mobile-configuration-id="configurationId"
                    :loading="wakeWordsLoading"
                    :load-error="wakeWordsLoadError"
                    :can-edit="canEdit"
                    @retry="loadConfiguration"
                  />
                </v-col>
              </v-row>
            </v-window-item>

          </v-window>

          <!-- Save Button for All Configurations — hidden on the Wake word tab, which saves itself (#786) -->
          <div v-if="permissions.edit && activeTab !== WAKE_WORD_TAB_INDEX" class="mb-4 d-flex justify-end px-8" style="gap: 1rem">
            <v-btn style="height: 45px; width: 130px; border-radius: 12px" color="#4E3982" @click="saveConfiguration" :loading="loading" :disabled="loading">
              <v-icon start>mdi-content-save</v-icon>
              {{ $t('save') }}
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-container>

    <!-- Hidden File Input -->
    <input ref="imageInput" type="file" accept="image/*" style="display: none" aria-label="Feature image upload" @change="handleImageUpload" />

    <!-- Hidden Genie Icon File Input -->
    <input ref="genieIconInput" type="file" style="display: none" aria-label="Genie icon upload" @change="handleGenieIconUpload" />

    <!-- Hidden CIF File Inputs -->
    <input ref="featureCifInput" type="file" accept=".csv,.xlsx,.xls" style="display: none" @change="handleFeatureCifUpload" />
    <input ref="questionCifInput" type="file" accept=".csv,.xlsx,.xls" style="display: none" @change="handleQuestionCifUpload" />

    <!-- Hidden Genie Prefix Step MP3 File Input -->
    <input ref="geniePrefixStepMp3Input" type="file" accept=".mp3,audio/mpeg" style="display: none" @change="handleGeniePrefixStepMp3Upload" />

    <!-- Image Crop Dialog -->
    <v-dialog v-model="imageCropDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Crop Image</span>
        </v-card-title>
        <v-card-text>
          <div class="crop-container" style="max-width: 100%; max-height: 400px; overflow: hidden">
            <Cropper
              ref="cropper"
              :src="selectedImageFile"
              :stencil-props="{
                aspectRatio: 1,
                resizable: true,
                movable: true,
              }"
              :canvas="{
                maxWidth: 400,
                maxHeight: 400,
              }"
              class="cropper"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" variant="text" @click="closeCropDialog"> Cancel </v-btn>
          <v-btn color="#4E3982" variant="flat" @click="cropImage"> Crop & Upload </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Required Save Note Dialog -->
    <v-dialog v-model="historyNoteDialog" max-width="560px" persistent>
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon class="mr-2" color="#4E3982">mdi-note-edit-outline</v-icon>
          Save Note
        </v-card-title>
        <v-card-text>
          <p class="text-body-2 mb-4">
            Add a note for this configuration save.
          </p>
          <v-textarea
            v-model="historyNote"
            label="Note"
            placeholder="Describe why this configuration was changed"
            variant="outlined"
            rows="4"
            maxlength="2000"
            counter
            autofocus
            hide-details="auto"
            :error-messages="historyNoteError"
            @keydown.ctrl.enter="confirmHistoryNote"
            @keydown.meta.enter="confirmHistoryNote"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="cancelHistoryNote">Cancel</v-btn>
          <v-btn color="#4E3982" variant="flat" @click="confirmHistoryNote">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Read-only History Log Dialog -->
    <v-dialog v-model="historyDialog" max-width="1100px">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon class="mr-2" color="#4E3982">mdi-history</v-icon>
          <span>History Log</span>
          <v-spacer></v-spacer>
          <v-btn icon="mdi-close" variant="text" aria-label="Close history log" @click="historyDialog = false"></v-btn>
        </v-card-title>
        <v-card-text>
          <v-row class="history-filter-row" dense>
            <v-col cols="12" sm="6" md="2">
              <v-text-field
                v-model="historyStartDate"
                type="date"
                label="Start date"
                density="compact"
                variant="outlined"
                hide-details
                :max="historyEndDate"
                @update:model-value="onHistoryStartDateChange"
              />
            </v-col>
            <v-col cols="12" sm="6" md="2">
              <v-text-field
                v-model="historyEndDate"
                type="date"
                label="End date"
                density="compact"
                variant="outlined"
                hide-details
                :min="historyStartDate"
                @update:model-value="onHistoryEndDateChange"
              />
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-select
                v-model="historyTabFilter"
                :items="historyTabOptions"
                label="Tab"
                density="compact"
                variant="outlined"
                hide-details
                @update:model-value="applyHistoryFilters"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="historyUsernameFilter"
                label="Search username"
                prepend-inner-icon="mdi-account-search-outline"
                append-inner-icon="mdi-magnify"
                density="compact"
                variant="outlined"
                hide-details
                @click:append-inner="applyHistoryFilters"
                @keyup.enter="applyHistoryFilters"
              />
            </v-col>
            <v-col cols="auto" class="d-flex align-center">
              <v-btn variant="text" color="#4E3982" class="text-none" @click="resetHistoryFilters">
                Reset
              </v-btn>
            </v-col>
          </v-row>
          <v-data-table-server
            class="modern-table history-log-table"
            :headers="historyHeaders"
            :items="historyItems"
            :loading="historyLoading"
            :items-per-page="historyPageSize"
            :page="historyPage"
            :items-length="historyTotal"
            :items-per-page-options="[10]"
            @update:options="onHistoryTableOptions"
          >
            <template #item.username="{ item }">
              <span>{{ item.fullName || item.username || '-' }}</span>
            </template>
            <template #item.changedDateTime="{ item }">
              <span class="text-no-wrap">{{ formatHistoryDateTime(item.changedDateTime) }}</span>
            </template>
            <template #item.note="{ item }">
              <div class="history-note-cell">{{ item.note }}</div>
            </template>
            <template #item.changes="{ item }">
              <v-btn
                size="small"
                color="#4E3982"
                variant="text"
                class="text-none"
                :disabled="!item.changeCount"
                :aria-label="`View ${item.changeCount || 0} changes for ${item.tab || 'this history record'}`"
                @click="openHistoryDetail(item)"
              >
                View {{ item.changeCount || 0 }} {{ item.changeCount === 1 ? 'change' : 'changes' }}
              </v-btn>
            </template>
            <template #no-data>
              <div class="text-center pa-6 text-medium-emphasis">No history records found.</div>
            </template>
          </v-data-table-server>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Read-only field changes for one history row -->
    <v-dialog v-model="historyDetailDialog" max-width="1100px">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon class="mr-2" color="#4E3982">mdi-file-compare</v-icon>
          <span>Change Details</span>
          <v-spacer></v-spacer>
          <v-btn icon="mdi-close" variant="text" aria-label="Close change details" @click="historyDetailDialog = false"></v-btn>
        </v-card-title>
        <v-card-text>
          <div v-if="historyDetail" class="mb-4 text-body-2">
            <div><strong>Tab:</strong> {{ historyDetail.tab }}</div>
            <div><strong>Note:</strong> {{ historyDetail.note }}</div>
          </div>
          <div v-if="historyDetailLoading" class="d-flex justify-center pa-8">
            <v-progress-circular indeterminate color="#4E3982"></v-progress-circular>
          </div>
          <v-table v-else fixed-header height="480" class="history-changes-table">
            <thead>
              <tr>
                <th>Field</th>
                <th>Before</th>
                <th>After</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(change, index) in historyDetailChanges" :key="`${change.field}-${index}`">
                <td class="history-field-cell">{{ change.field }}</td>
                <td>
                  <v-btn
                    variant="text"
                    class="history-value-button text-none"
                    :aria-label="`View full previous value for ${change.field}`"
                    @click="openHistoryValue('Before: ' + change.field, change.oldValue)"
                  >
                    {{ getHistoryValuePreview(change.oldValue) }}
                  </v-btn>
                </td>
                <td>
                  <v-btn
                    variant="text"
                    class="history-value-button text-none"
                    :aria-label="`View full new value for ${change.field}`"
                    @click="openHistoryValue('After: ' + change.field, change.newValue)"
                  >
                    {{ getHistoryValuePreview(change.newValue) }}
                  </v-btn>
                </td>
              </tr>
              <tr v-if="!historyDetailChanges.length">
                <td colspan="3" class="text-center pa-6 text-medium-emphasis">No change details found.</td>
              </tr>
            </tbody>
          </v-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Full long before/after value -->
    <v-dialog v-model="historyValueDialog" max-width="920px">
      <v-card>
        <v-card-title class="d-flex align-center">
          <span>{{ historyValueTitle }}</span>
          <v-spacer></v-spacer>
          <v-btn icon="mdi-close" variant="text" aria-label="Close full value" @click="historyValueDialog = false"></v-btn>
        </v-card-title>
        <v-card-text>
          <pre class="history-full-value">{{ historyValueText }}</pre>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Manage Suggestion Actions (LH Bank scope: isTaxPlanningMode = false) -->
    <SuggestionActionManagerDialog
      v-model="showSuggestionActionManager"
      :is-tax-planning-mode="false"
      :can-edit="canEdit"
      @saved="GetSuggestionActions"
    />
  </div>
</template>

<script>
import { feature } from 'caniuse-lite';
import moment from 'moment';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import SuggestionActionManagerDialog from '@/components/SuggestionActionManagerDialog.vue';
import PostMessageColorField, { isValidPostMessageColor, resolvePostMessageColor } from '@/components/PostMessageColorField.vue';
import WakeWordTab from '@/components/MobileConfiguration/WakeWordTab.vue';
import { validateGenieIconFile } from '@/utils/genieIconValidation';

export default {
  name: 'MobileConfiguration',
  inject: ['flagNav', 'FontColorTitle', 'SubNavbarBackGround'],
  components: {
    Cropper,
    SuggestionActionManagerDialog,
    PostMessageColorField,
    WakeWordTab,
  },
  data() {
    return {
      loading: false,
      flagNav: true,
      today: null,
      featuresLoading: false,
      questionsLoading: false,
      activeTab: 0,
      configurationId: null, // Store the configuration ID for updates
      historyNoteDialog: false,
      historyNote: '',
      historyNoteError: '',
      historyNoteResolver: null,
      historyDialog: false,
      historyLoading: false,
      historyItems: [],
      historyPage: 1,
      historyPageSize: 10,
      historyTotal: 0,
      historyStartDate: moment().format('YYYY-MM-DD'),
      historyEndDate: moment().format('YYYY-MM-DD'),
      historyUsernameFilter: '',
      historyTabFilter: '',
      historyTabOptions: [
        { title: 'All tabs', value: '' },
        { title: 'Main Config', value: 'Main Config' },
        { title: 'Suggest Feature', value: 'Suggest Feature' },
        { title: 'Suggest Question', value: 'Suggest Question' },
        { title: 'Genie AI', value: 'Genie AI' },
        { title: 'Genie Prefix', value: 'Genie Prefix' },
        { title: 'Wake Word', value: 'Wake Word' },
      ],
      historyDetailDialog: false,
      historyDetailLoading: false,
      historyDetail: null,
      historyDetailChanges: [],
      historyValueDialog: false,
      historyValueTitle: '',
      historyValueText: '',
      historyBaseline: null,
      // #786 Wake word tab — the tab saves the list itself
      WAKE_WORD_TAB_INDEX: 5, // position of <v-tab>{{ $t('wakeWord') }}</v-tab> in the tab bar
      wakeWords: [],
      wakeWordsLoading: true,
      wakeWordsLoadError: false,
      historyHeaders: [
        { title: 'Username', key: 'username', sortable: false, width: '20%' },
        { title: 'Date Time', key: 'changedDateTime', sortable: false, width: '20%' },
        { title: 'Tab', key: 'tab', sortable: false, width: '16%' },
        { title: 'Note', key: 'note', sortable: false, width: '26%' },
        { title: 'Changes', key: 'changes', sortable: false, width: '18%' },
      ],
      postMessageText: 'AI อาจตอบคลาดเคลื่อนได้ หากพบข้อผิดพลาด กรุณาแจ้งให้เราทราบ',
      postMessageTextEN: '',
      postMessageTextCN: '',
      // Empty = mobile app uses its own default post message colour.
      postMessageColor: '',
      postMessageDefaultColor: '#BCBEC0',
      // Options from API (similar to ProactiveMessage)
      segmentOptions: [],
      wealthMembershipOptions: [],
      actionOptions: [],
      showSuggestionActionManager: false,
      ADD_ACTION_VALUE: '__ADD_ACTION__',
      targetGroupOptions: ['all', 'persona', 'cif-list'],
      cacheScopeOptions: [
        { label: 'Shared (All Users)', value: 'shared' },
        { label: 'User Level (Per User)', value: 'user' }
      ],

      // Model selection
      selectedModel: null,
      taxPlanningSelectedModel: null,
      aiModelOptions: [],
      uniqueAiModelOptions: [],

      // Mobile Information
      appTitle: '',
      mobileInformationHeader: '',
      mobileInformation: '',
      mobileInformationEN: '',

      // Timeout Configuration
      timeoutDuration: null,
      timeoutMessage: '',
      timeoutMessageEN: '',
      timeoutMessageCN: '',

      // Suggest Bar (heading shown above the suggestion buttons on mobile; blank = hidden)
      suggestBarText: '',
      suggestBarTextEN: '',
      suggestBarTextCN: '',

      // Voice settings bundles from LH Bank Configuration › Voice Configs
      voiceConfigOptions: [],

      config: {
        languages: {
          thai: true,
          english: true,
          chinese: false,
        },
        voice: {
          enabled: true,
          type: 'tts',
          systemPrompt: '',
          geminiSystemPrompt: '',
          speechToTextType: 'device',
          voiceConfigurationId: null,
          textToSpeechType: 'default',
          endOfSpeechDetection: null,
          reformatForTTSPrompt: '',
          formatForTTSEnginePrompt: '',
          ttsModel: 'gpt-5-chat',
          ttsApiVersion: '2025-01-01-preview',
        },
        copyMessage: {
          enabled: true,
        },
        logging: {
          enabled: false,
        },
        postMessage: {
          enabled: false,
        },
        // Cache Configuration
        enableCache: false,
        cacheTTLMinutes: 1440,
        cacheScope: 'shared',
        enableSemanticCache: false,
        similarityThreshold: 0.95,
      },
      suggestionConfig: {
        enabled: true,
        features: [], // Dynamic array of features from API
      },

      // Dialog states for image upload and cropping
      imageUploadDialog: false,
      imageCropDialog: false,
      selectedFeatureIndex: null,
      selectedImageFile: null,
      croppedImageBlob: null,
      suggestionQuestionConfig: {
        enabled: false,
        questions: [], // Dynamic array of questions from API
      },

      // Track deleted items to remove on save
      featuresToDelete: [], // Array of feature numbers to delete
      questionsToDelete: [], // Array of question numbers to delete
      genieCharactersToDelete: [], // Array of genie character IDs to delete

      // CIF File Upload Management
      currentFeatureIndexForCif: null, // Track which feature is uploading CIF
      currentQuestionIndexForCif: null, // Track which question is uploading CIF

      // Genie AI Character
      genieCharacters: [],
      genieCharactersPage: 1,
      genieCharactersPerPage: 5,
      genieCharactersPerPageOptions: [5, 10, 20],
      geniePreviewIndex: null, // Which character is being manually previewed
      geniePreviewIsManual: false, // true = user clicked preview; false = auto from conditions
      genieIconUploadTarget: null, // { index, field } for current icon upload

      // Genie Prefix Patterns (Think Loader)
      geniePrefixPatterns: [],
      expandedGeniePrefixPatterns: [], // Expanded pattern uids in the table
      geniePrefixPatternsToDelete: [], // Array of pattern IDs to delete on save
      geniePrefixStepMp3UploadTarget: null, // { pattern, stepIndex, language }
      geniePrefixVoicePlaying: null, // e.g. `${patternUid}_0_thai` when playing
      geniePrefixVoiceAudio: null, // Audio instance for voice playback
    };
  },
  computed: {
    postMessagePreviewColor() {
      return resolvePostMessageColor(this.postMessageColor, this.postMessageDefaultColor);
    },
    isViewOnly() {
      return this.$pagePermission && this.$pagePermission.isViewOnly('MobileConfigurations');
    },
    canAdd() {
      return !!(this.$pagePermission && this.$pagePermission.canAdd('MobileConfigurations'));
    },
    canEdit() {
      return !!(this.$pagePermission && this.$pagePermission.canEdit('MobileConfigurations'));
    },
    canDelete() {
      return !!(this.$pagePermission && this.$pagePermission.canDelete('MobileConfigurations'));
    },
    actionSelectItems() {
      if (!this.canEdit) return this.actionOptions;
      return [...this.actionOptions, { name: this.ADD_ACTION_VALUE, __isAddAction: true }];
    },
    // Display label of the voice settings bundle selected for this mode
    selectedVoiceConfigName() {
      const selectedId = this.config.voice.voiceConfigurationId;
      if (selectedId === null || selectedId === undefined) return '—';
      const matched = (this.voiceConfigOptions || []).find((option) => option.id === selectedId);
      return matched ? this.voiceConfigItemTitle(matched) : `#${selectedId}`;
    },
    permissions() {
      return {
        add: this.$pagePermission && this.$pagePermission.canAdd('MobileConfigurations'),
        edit: this.$pagePermission && this.$pagePermission.canEdit('MobileConfigurations'),
        delete: this.$pagePermission && this.$pagePermission.canDelete('MobileConfigurations'),
      }
    },
    hasEnabledFeatures() {
      return this.suggestionConfig.features.some((feature) => feature && feature.featureEnabled);
    },
    hasEnabledQuestions() {
      return this.suggestionQuestionConfig.questions.some((question) => question && question.questionEnabled);
    },
    enabledLanguages() {
      const languages = [];
      if (this.config.languages.thai) {
        languages.push({ key: 'thai', text: 'ไทย' });
      }
      if (this.config.languages.english) {
        languages.push({ key: 'english', text: 'ENG' });
      }
      if (this.config.languages.chinese) {
        languages.push({ key: 'chinese', text: '中文' });
      }
      return languages;
    },
    endOfSpeechDetectionRules() {
      return [
        (v) => v === null || v === '' || v === undefined || Number.isInteger(Number(v)) || 'Must be a whole number',
        (v) => v === null || v === '' || v === undefined || Number(v) >= 0 || 'Must be a positive number',
      ];
    },
    // Method to get feature image with fallback
    getFeatureImageUrl() {
      return (feature, index) => {
        if (feature && feature.imageUrl) {
          return feature.imageUrl;
        }
        // Return null to show placeholder square box instead of default images
        return null;
      };
    },
    activeGenieCharacterIndex() {
      const today = new Date(Date.now() + 7 * 60 * 60 * 1000).toISOString().slice(0, 10);
      const candidates = this.genieCharacters
        .map((c, idx) => ({ c, idx }))
        .filter(({ c }) => {
          if (!c.isActive) return false;
          const start = c.effectiveStartDate ? c.effectiveStartDate.slice(0, 10) : null;
          if (!start || start > today) return false;
          const end = c.effectiveEndDate ? c.effectiveEndDate.slice(0, 10) : null;
          return !end || end >= today;
        });
      if (candidates.length === 0) return null;
      candidates.sort((a, b) => (b.c.effectiveStartDate || '').localeCompare(a.c.effectiveStartDate || ''));
      return candidates[0].idx;
    },
    currentGeniePreviewIndex() {
      if (this.geniePreviewIsManual && this.geniePreviewIndex !== null) {
        return this.geniePreviewIndex;
      }
      return this.activeGenieCharacterIndex;
    },
    genieCharactersTotalPages() {
      return Math.max(1, Math.ceil(this.genieCharacters.length / this.genieCharactersPerPage));
    },
    paginatedGenieCharacters() {
      const start = (this.genieCharactersPage - 1) * this.genieCharactersPerPage;
      const end = start + this.genieCharactersPerPage;
      return this.genieCharacters.slice(start, end).map((character, localIndex) => ({
        character,
        index: start + localIndex,
      }));
    },
    hasInvalidGenieCharacterName() {
      return this.genieCharacters.some((character) => !character.characterName?.trim());
    },
    geniePrefixPatternHeaders() {
      return [
        { title: '#', key: 'patternNumber', sortable: false, width: 60 },
        { title: 'Pattern Name', key: 'patternName', sortable: false },
        { title: 'Steps', key: 'steps', sortable: false, width: 110 },
        { title: 'Effective Start', key: 'effectiveStartDate', sortable: false, width: 170 },
        { title: 'Effective End', key: 'effectiveEndDate', sortable: false, width: 170 },
        { title: 'Active', key: 'isActive', sortable: false, width: 90 },
        { title: '', key: 'actions', sortable: false, width: 60 },
      ];
    },
    isSaveDisabled() {
      return this.loading || this.hasInvalidGenieCharacterName;
    },
  },
  watch: {
    genieCharactersPerPage() {
      this.genieCharactersPage = 1;
    },
    genieCharacters() {
      if (this.genieCharactersPage > this.genieCharactersTotalPages) {
        this.genieCharactersPage = this.genieCharactersTotalPages;
      }
    },
  },
  methods: {
    // Allow only positive numbers (0-9) for input
    allowOnlyPositiveNumbers(event) {
      const charCode = event.which ? event.which : event.keyCode;
      // Allow only digits (0-9)
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
      }
    },

    // Allow only decimal numbers (0-9 and decimal point) for input
    allowOnlyDecimalNumbers(event) {
      const charCode = event.which ? event.which : event.keyCode;
      // Allow digits (0-9) and decimal point (.)
      if ((charCode < 48 || charCode > 57) && charCode !== 46) {
        event.preventDefault();
      }
      // Prevent multiple decimal points
      if (charCode === 46 && event.target.value.includes('.')) {
        event.preventDefault();
      }
    },

    // Validate End Date >= Start Date for a single item
    validateDateRange(startDate, endDate) {
      if (!startDate || !endDate) return true;
      return endDate >= startDate;
    },

    // Validate all suggestion features dates
    validateSuggestionFeatures() {
      const errors = [];
      this.suggestionConfig.features.forEach((feature, index) => {
        if (!this.validateDateRange(feature.effectiveStartDate, feature.effectiveEndDate)) {
          errors.push(`Feature ${index + 1}: End Date must be on or after Start Date`);
        }
      });
      return errors;
    },

    // Validate all suggestion questions dates
    validateSuggestionQuestions() {
      const errors = [];
      this.suggestionQuestionConfig.questions.forEach((question, index) => {
        if (!this.validateDateRange(question.effectiveStartDate, question.effectiveEndDate)) {
          errors.push(`Question ${index + 1}: End Date must be on or after Start Date`);
        }
      });
      return errors;
    },

    requestHistoryNote() {
      this.historyNote = '';
      this.historyNoteError = '';
      this.historyNoteDialog = true;

      return new Promise((resolve) => {
        this.historyNoteResolver = resolve;
      });
    },

    confirmHistoryNote() {
      const note = (this.historyNote || '').trim();
      if (!note) {
        this.historyNoteError = 'Note is required.';
        return;
      }

      const resolve = this.historyNoteResolver;
      this.historyNoteResolver = null;
      this.historyNoteDialog = false;
      this.historyNoteError = '';
      resolve?.(note);
    },

    cancelHistoryNote() {
      const resolve = this.historyNoteResolver;
      this.historyNoteResolver = null;
      this.historyNoteDialog = false;
      this.historyNoteError = '';
      resolve?.(null);
    },

    openHistoryLog() {
      if (!this.configurationId) return;

      this.historyDialog = true;
      this.resetHistoryFilters();
    },

    onHistoryStartDateChange() {
      if (this.historyStartDate && this.historyEndDate && this.historyStartDate > this.historyEndDate) {
        this.historyEndDate = this.historyStartDate;
      }
      this.applyHistoryFilters();
    },

    onHistoryEndDateChange() {
      if (this.historyStartDate && this.historyEndDate && this.historyEndDate < this.historyStartDate) {
        this.historyStartDate = this.historyEndDate;
      }
      this.applyHistoryFilters();
    },

    resetHistoryFilters() {
      const today = moment().format('YYYY-MM-DD');
      this.historyStartDate = today;
      this.historyEndDate = today;
      this.historyUsernameFilter = '';
      this.historyTabFilter = '';
      this.applyHistoryFilters();
    },

    applyHistoryFilters() {
      this.historyPage = 1;
      this.loadHistoryLog();
    },

    getHistoryFilter() {
      const localDayToUtc = (value, daysToAdd = 0) => {
        if (!value) return null;

        const date = moment(`${value}T00:00:00`).add(daysToAdd, 'day');
        return date.isValid() ? date.toISOString() : null;
      };

      return {
        startDateUtc: localDayToUtc(this.historyStartDate),
        endDateExclusiveUtc: localDayToUtc(this.historyEndDate, 1),
        username: this.historyUsernameFilter?.trim() || '',
        tab: this.historyTabFilter || '',
      };
    },

    onHistoryTableOptions(options) {
      const nextPage = options?.page || 1;
      const nextPageSize = options?.itemsPerPage || 10;
      const pageChanged = nextPage !== this.historyPage || nextPageSize !== this.historyPageSize;

      this.historyPage = nextPage;
      this.historyPageSize = nextPageSize;

      if (this.historyDialog && pageChanged) {
        this.loadHistoryLog();
      }
    },

    loadHistoryLog() {
      if (!this.configurationId || !this.historyDialog) return;

      this.historyLoading = true;
      this.$call.GetMobileConfigurationHistory(
        this.configurationId,
        this.historyPage,
        this.historyPageSize,
        this.getHistoryFilter(),
        (response) => {
          const status = response?.Status ?? response?.status;
          const data = response?.Data ?? response?.data;
          const items = data?.Items ?? data?.items ?? [];

          if (status === 'Successful' || status === 0) {
            this.historyItems = items.map((item) => this.normalizeHistoryItem(item));
            this.historyTotal = data?.TotalCount ?? data?.totalCount ?? 0;
          } else {
            this.historyItems = [];
            this.historyTotal = 0;
            this.$swal.fire({
              title: this.$t('error'),
              text: response?.Message || response?.message || 'Failed to load history log.',
              icon: 'error',
              confirmButtonText: this.$t('ok'),
            });
          }

          this.historyLoading = false;
        },
        (error) => {
          console.error('Failed to load mobile configuration history:', error);
          this.historyItems = [];
          this.historyTotal = 0;
          this.historyLoading = false;
          this.$swal.fire({
            title: this.$t('error'),
            text: 'Failed to load history log.',
            icon: 'error',
            confirmButtonText: this.$t('ok'),
          });
        }
      );
    },

    normalizeHistoryItem(item) {
      const username = item?.Username ?? item?.username ?? '';
      const firstName = item?.FirstName ?? item?.firstName ?? '';
      const lastName = item?.LastName ?? item?.lastName ?? '';
      const fullName = item?.FullName ?? item?.fullName ?? [firstName, lastName].filter(Boolean).join(' ');

      return {
        id: item?.ID ?? item?.id,
        username,
        fullName: fullName || username,
        changedDateTime: item?.ChangedDateTime ?? item?.changedDateTime,
        tab: item?.Tab ?? item?.tab ?? '',
        note: item?.Note ?? item?.note ?? '',
        changeCount: item?.ChangeCount ?? item?.changeCount ?? 0,
      };
    },

    formatHistoryDateTime(value) {
      if (!value) return '-';
      const date = moment(value);
      return date.isValid() ? date.format('DD/MM/YYYY HH:mm') : '-';
    },

    openHistoryDetail(item) {
      if (!this.configurationId || !item?.id || !item.changeCount) return;

      this.historyDetailDialog = true;
      this.historyDetailLoading = true;
      this.historyDetail = item;
      this.historyDetailChanges = [];

      this.$call.GetMobileConfigurationHistoryDetail(
        this.configurationId,
        item.id,
        (response) => {
          const status = response?.Status ?? response?.status;
          const data = response?.Data ?? response?.data;
          if (status === 'Successful' || status === 0) {
            this.historyDetail = this.normalizeHistoryItem(data);
            const changesJson = data?.ChangesJson ?? data?.changesJson ?? '[]';
            this.historyDetailChanges = this.parseHistoryChanges(changesJson);
          } else {
            this.$swal.fire({
              title: this.$t('error'),
              text: response?.Message || response?.message || 'Failed to load change details.',
              icon: 'error',
              confirmButtonText: this.$t('ok'),
            });
          }
          this.historyDetailLoading = false;
        },
        (error) => {
          console.error('Failed to load mobile configuration history detail:', error);
          this.historyDetailLoading = false;
          this.$swal.fire({
            title: this.$t('error'),
            text: 'Failed to load change details.',
            icon: 'error',
            confirmButtonText: this.$t('ok'),
          });
        }
      );
    },

    parseHistoryChanges(changesJson) {
      try {
        const changes = typeof changesJson === 'string' ? JSON.parse(changesJson) : changesJson;
        return Array.isArray(changes)
          ? changes.map((change) => ({
              field: change?.Field ?? change?.field ?? 'Unknown field',
              oldValue: change?.OldValue ?? change?.oldValue ?? null,
              newValue: change?.NewValue ?? change?.newValue ?? null,
            }))
          : [];
      } catch (error) {
        console.error('Failed to parse mobile configuration history changes:', error);
        return [];
      }
    },

    openHistoryValue(title, value) {
      this.historyValueTitle = title;
      this.historyValueText = this.formatHistoryValue(value);
      this.historyValueDialog = true;
    },

    formatHistoryValue(value) {
      if (value === null || value === undefined || value === '') return '—';
      if (typeof value === 'boolean') return value ? 'On' : 'Off';
      if (typeof value === 'string') return value;
      try {
        return JSON.stringify(value, null, 2);
      } catch (error) {
        return String(value);
      }
    },

    getHistoryValuePreview(value) {
      const displayValue = this.formatHistoryValue(value).replace(/\s+/g, ' ').trim();
      return displayValue.length > 140 ? `${displayValue.slice(0, 137)}...` : displayValue;
    },

    captureHistoryBaseline() {
      this.historyBaseline = this.buildHistorySnapshot();
    },

    buildHistorySnapshot() {
      return {
        'Main Config': this.buildMainConfigHistoryFields(),
        'Suggest Feature': this.buildSuggestionFeatureHistoryItems(),
        'Suggest Question': this.buildSuggestionQuestionHistoryItems(),
        'Genie AI': this.buildGenieCharacterHistoryItems(),
        'Genie Prefix': this.buildGeniePrefixHistoryItems(),
      };
    },

    buildMainConfigHistoryFields() {
      return {
        'Thai Language': this.config.languages.thai,
        'English Language': this.config.languages.english,
        'Chinese Language': this.config.languages.chinese,
        'Voice Enabled': this.config.voice.enabled,
        'Voice Type': this.config.voice.type,
        'Voice System Prompt': this.config.voice.systemPrompt,
        'Gemini Voice System Prompt': this.config.voice.geminiSystemPrompt,
        'Speech to Text Type': this.config.voice.speechToTextType,
        'Voice Config': this.selectedVoiceConfigName,
        'Text to Speech Type': this.config.voice.textToSpeechType,
        'End of Speech Detection': this.config.voice.endOfSpeechDetection,
        'Reformat for TTS Prompt': this.config.voice.reformatForTTSPrompt,
        'TTS Engine Format Prompt': this.config.voice.formatForTTSEnginePrompt,
        'TTS Model': this.config.voice.ttsModel,
        'TTS API Version': this.config.voice.ttsApiVersion,
        'Copy Message Enabled': this.config.copyMessage.enabled,
        'Suggestion Feature Enabled': this.suggestionConfig.enabled,
        'Suggestion Question Enabled': this.suggestionQuestionConfig.enabled,
        'Logging Enabled': this.config.logging.enabled,
        'Post Message Enabled': this.config.postMessage.enabled,
        'Post Message (Thai)': this.postMessageText,
        'Post Message (English)': this.postMessageTextEN,
        'Post Message (Chinese)': this.postMessageTextCN,
        'Post Message Color': this.postMessageColor || '',
        'Human Mode': this.config.humanMode,
        'TTS Enabled': this.config.ttsEnabled,
        'Selected Model': this.selectedModel,
        'Tax Planning Selected Model': this.taxPlanningSelectedModel,
        'App Title': this.appTitle,
        'Mobile Information Header': this.mobileInformationHeader,
        'Mobile Information': this.mobileInformation,
        'Mobile Information (English)': this.mobileInformationEN,
        'Timeout Duration': this.timeoutDuration,
        'Timeout Message (Thai)': this.timeoutMessage,
        'Timeout Message (English)': this.timeoutMessageEN,
        'Timeout Message (Chinese)': this.timeoutMessageCN,
        'Cache Enabled': this.config.enableCache,
        'Cache TTL Minutes': this.config.cacheTTLMinutes,
        'Cache Scope': this.config.cacheScope,
        'Semantic Cache Enabled': this.config.enableSemanticCache,
        'Similarity Threshold': this.config.similarityThreshold,
      };
    },

    buildSuggestionFeatureHistoryItems() {
      const suggestBarItem = {
        key: 'config:suggestBar',
        label: 'Suggest Bar',
        fields: {
          'Text (Thai)': this.suggestBarText || '',
          'Text (English)': this.suggestBarTextEN || '',
          'Text (Chinese)': this.suggestBarTextCN || '',
        },
      };

      const featureItems = (this.suggestionConfig.features || [])
        .filter((feature) => this.isHistoryFeatureMeaningful(feature))
        .map((feature, index) => ({
          key: this.historyItemKey(feature, 'featureId', index),
          label: `Feature ${index + 1}`,
          fields: {
            'Message (Thai)': feature.messages?.thai || '',
            'Message (English)': feature.messages?.english || '',
            'Message (Chinese)': feature.messages?.chinese || '',
            'Model Name': feature.modelName || '',
            Action: feature.action || '',
            'Target Group': feature.targetGroup || 'all',
            Priority: feature.priority ?? null,
            Segment: this.historyComparableValue([...(feature.segment || [])].sort()),
            'Wealth Membership': this.historyComparableValue([...(feature.wealthMembership || [])].sort()),
            'Effective Start Date': this.historyDateValue(feature.effectiveStartDate),
            'Effective End Date': this.historyDateValue(feature.effectiveEndDate),
            Enabled: !!feature.featureEnabled,
            'Tax Planning Enabled': !!feature.taxPlanningEnabled,
            Image: this.historyFileValue(feature.imageUrl),
            'CIF Files': this.historyCifFilesValue(feature.cifFiles),
          },
        }));

      return [suggestBarItem, ...featureItems];
    },

    buildSuggestionQuestionHistoryItems() {
      return (this.suggestionQuestionConfig.questions || [])
        .filter((question) => this.isHistoryQuestionMeaningful(question))
        .map((question, index) => ({
          key: this.historyItemKey(question, 'questionId', index),
          label: `Question ${index + 1}`,
          fields: {
            'Message (Thai)': question.messages?.thai || '',
            'Message (English)': question.messages?.english || '',
            'Message (Chinese)': question.messages?.chinese || '',
            'Target Group': question.targetGroup || 'all',
            Priority: question.priority ?? null,
            Segment: this.historyComparableValue([...(question.segment || [])].sort()),
            'Wealth Membership': this.historyComparableValue([...(question.wealthMembership || [])].sort()),
            'Effective Start Date': this.historyDateValue(question.effectiveStartDate),
            'Effective End Date': this.historyDateValue(question.effectiveEndDate),
            Enabled: !!question.questionEnabled,
            'Tax Planning Enabled': !!question.taxPlanningEnabled,
            'CIF Files': this.historyCifFilesValue(question.cifFiles),
          },
        }));
    },

    buildGenieCharacterHistoryItems() {
      return (this.genieCharacters || [])
        .filter((character) => this.isHistoryGenieCharacterMeaningful(character))
        .map((character, index) => ({
          key: this.historyItemKey(character, 'id', index),
          label: `Genie Character ${index + 1}`,
          fields: {
            'Character Name': character.characterName || '',
            'Effective Start Date': this.historyDateValue(character.effectiveStartDate),
            'Effective End Date': this.historyDateValue(character.effectiveEndDate),
            Active: character.isActive !== false,
            'Show In Proactive Mode': !!character.showInProactiveMode,
            'Tax Planning Enabled': !!character.taxPlanningEnabled,
            'Proactive Icon': this.historyFileValue(character.iconProactiveUrl, character.pendingFiles?.proactive),
            'Chat First Icon': this.historyFileValue(character.iconChatFirstUrl, character.pendingFiles?.chatFirst),
            'Chat Icon': this.historyFileValue(character.iconChatUrl, character.pendingFiles?.chat),
            'Voice Page Icon': this.historyFileValue(character.iconVoicePageUrl, character.pendingFiles?.voicePage),
          },
        }));
    },

    buildGeniePrefixHistoryItems() {
      return (this.geniePrefixPatterns || [])
        .filter((pattern) => pattern?.id || this.hasGeniePrefixPatternContent(pattern))
        .map((pattern, patternIndex) => ({
          key: this.historyItemKey(pattern, 'id', patternIndex, 'uid'),
          label: `Pattern ${patternIndex + 1}`,
          fields: {
            'Pattern Name': pattern.patternName || '',
            'Effective Start Date': this.historyDateValue(pattern.effectiveStartDate),
            'Effective End Date': this.historyDateValue(pattern.effectiveEndDate),
            Active: pattern.isActive !== false,
          },
          steps: (pattern.steps || [])
            .filter((step) => step?.id || this.isHistoryGeniePrefixStepMeaningful(step))
            .map((step, stepIndex) => ({
              key: this.historyItemKey(step, 'id', stepIndex, 'uid'),
              label: `Pattern ${patternIndex + 1} — Step ${stepIndex + 1}`,
              fields: {
                'Duration (seconds)': step.durationSec ?? 3,
                'Text (Thai)': step.textThai || '',
                'Text (English)': step.textEnglish || '',
                'Text (Chinese)': step.textChinese || '',
                'MP3 (Thai)': this.historyPrefixAudioValue(step.mp3Thai),
                'MP3 (English)': this.historyPrefixAudioValue(step.mp3English),
                'MP3 (Chinese)': this.historyPrefixAudioValue(step.mp3Chinese),
                'Gemini MP3 (Thai)': this.historyPrefixAudioValue(step.geminiMp3Thai),
                'Gemini MP3 (English)': this.historyPrefixAudioValue(step.geminiMp3English),
                'Gemini MP3 (Chinese)': this.historyPrefixAudioValue(step.geminiMp3Chinese),
              },
            })),
        }));
    },

    buildHistoryEntries() {
      if (!this.historyBaseline) return [];

      const current = this.buildHistorySnapshot();
      const entries = [
        {
          tab: 'Main Config',
          changes: this.diffHistoryFieldMaps(this.historyBaseline['Main Config'], current['Main Config']),
        },
        {
          tab: 'Suggest Feature',
          changes: this.diffHistoryItems(this.historyBaseline['Suggest Feature'], current['Suggest Feature']),
        },
        {
          tab: 'Suggest Question',
          changes: this.diffHistoryItems(this.historyBaseline['Suggest Question'], current['Suggest Question']),
        },
        {
          tab: 'Genie AI',
          changes: this.diffHistoryItems(this.historyBaseline['Genie AI'], current['Genie AI']),
        },
        {
          tab: 'Genie Prefix',
          changes: this.diffHistoryItems(this.historyBaseline['Genie Prefix'], current['Genie Prefix']),
        },
      ];

      return entries.filter((entry) => entry.changes.length > 0);
    },

    diffHistoryItems(previousItems = [], currentItems = []) {
      const previousByKey = new Map(previousItems.map((item) => [item.key, item]));
      const currentByKey = new Map(currentItems.map((item) => [item.key, item]));
      const keys = new Set([...previousByKey.keys(), ...currentByKey.keys()]);
      const changes = [];

      keys.forEach((key) => {
        const previous = previousByKey.get(key);
        const current = currentByKey.get(key);
        const label = current?.label || previous?.label || 'Configuration item';

        changes.push(...this.diffHistoryFieldMaps(previous?.fields || {}, current?.fields || {}, label));
        if (previous?.steps || current?.steps) {
          changes.push(...this.diffHistoryItems(previous?.steps || [], current?.steps || []));
        }
      });

      return changes;
    },

    diffHistoryFieldMaps(previousFields = {}, currentFields = {}, context = '') {
      const fieldNames = new Set([...Object.keys(previousFields), ...Object.keys(currentFields)]);
      const changes = [];

      fieldNames.forEach((field) => {
        const oldValue = previousFields[field] ?? null;
        const newValue = currentFields[field] ?? null;
        if (!this.historyValuesEqual(oldValue, newValue)) {
          changes.push({
            field: context ? `${context} — ${field}` : field,
            oldValue,
            newValue,
          });
        }
      });

      return changes;
    },

    historyValuesEqual(firstValue, secondValue) {
      return JSON.stringify(firstValue ?? null) === JSON.stringify(secondValue ?? null);
    },

    historyItemKey(item, idProperty, index, alternateKey = null) {
      const id = item?.[idProperty];
      if (id !== null && id !== undefined) return `id:${id}`;
      const alternateValue = alternateKey ? item?.[alternateKey] : null;
      if (alternateValue) return `local:${alternateValue}`;
      return `new:${index}`;
    },

    isHistoryFeatureMeaningful(feature) {
      return feature?.isNew
        || feature?.featureId !== null && feature?.featureId !== undefined
        || !!(
          feature?.messages?.thai || feature?.messages?.english || feature?.messages?.chinese || feature?.modelName || feature?.action
          || feature?.priority || feature?.effectiveStartDate || feature?.effectiveEndDate || feature?.featureEnabled
          || feature?.taxPlanningEnabled || feature?.imageUrl || feature?.cifFiles?.length || feature?.segment?.length || feature?.wealthMembership?.length
        );
    },

    isHistoryQuestionMeaningful(question) {
      return question?.isNew
        || question?.questionId !== null && question?.questionId !== undefined
        || !!(
          question?.messages?.thai || question?.messages?.english || question?.messages?.chinese || question?.priority
          || question?.effectiveStartDate || question?.effectiveEndDate || question?.questionEnabled || question?.taxPlanningEnabled
          || question?.cifFiles?.length || question?.segment?.length || question?.wealthMembership?.length
        );
    },

    isHistoryGenieCharacterMeaningful(character) {
      return character?.id !== null && character?.id !== undefined
        || !!(
          character?.characterName || character?.effectiveStartDate || character?.effectiveEndDate || character?.taxPlanningEnabled
          || character?.showInProactiveMode
          || character?.iconProactiveUrl || character?.iconChatFirstUrl || character?.iconChatUrl || character?.iconVoicePageUrl
        );
    },

    isHistoryGeniePrefixStepMeaningful(step) {
      return !!(
        step?.textThai || step?.textEnglish || step?.textChinese || step?.mp3Thai?.fileName || step?.mp3Thai?.url
        || step?.mp3English?.fileName || step?.mp3English?.url || step?.mp3Chinese?.fileName || step?.mp3Chinese?.url
        || step?.geminiMp3Thai?.fileName || step?.geminiMp3Thai?.url || step?.geminiMp3English?.fileName || step?.geminiMp3English?.url
        || step?.geminiMp3Chinese?.fileName || step?.geminiMp3Chinese?.url
      );
    },

    historyDateValue(value) {
      return value ? this.formatDateForAPI(value) || value : null;
    },

    historyFileValue(url, pendingFile = null) {
      if (pendingFile?.file?.name) return pendingFile.file.name;
      if (!url) return null;
      return String(url).startsWith('blob:') ? '[New uploaded file]' : url;
    },

    historyPrefixAudioValue(audio) {
      if (!audio) return null;
      if (audio.fileName) return audio.fileName;
      if (audio.file?.name) return audio.file.name;
      if (!audio.url) return null;
      return String(audio.url).startsWith('blob:') ? '[New uploaded file]' : audio.url;
    },

    historyCifFilesValue(files) {
      const safeFiles = (files || []).map((file) => ({
        fileName: file?.fileName || '',
        filePath: file?.filePath || '',
        cifList: [...(file?.cifList || [])].sort(),
      }));
      return this.historyComparableValue(safeFiles);
    },

    historyComparableValue(value) {
      if (value === null || value === undefined) return null;
      if (typeof value !== 'object') return value;
      try {
        return JSON.stringify(this.sortHistoryValue(value));
      } catch (error) {
        return String(value);
      }
    },

    sortHistoryValue(value) {
      if (Array.isArray(value)) return value.map((item) => this.sortHistoryValue(item));
      if (value && typeof value === 'object') {
        return Object.keys(value)
          .sort()
          .reduce((result, key) => {
            result[key] = this.sortHistoryValue(value[key]);
            return result;
          }, {});
      }
      return value;
    },

    saveMobileConfigurationHistory(historyEntries, note) {
      return new Promise((resolve, reject) => {
        this.$call.SaveMobileConfigurationHistory(
          {
            mobileConfigurationId: this.configurationId,
            note,
            entries: historyEntries,
          },
          (response) => {
            if (response && (response.Status === 'Successful' || response.status === 0)) {
              resolve(response);
            } else {
              reject(new Error(response?.Message || response?.message || 'Failed to save history log.'));
            }
          },
          (error) => reject(error)
        );
      });
    },

    ensureMobileConfigurationId() {
      if (this.configurationId !== null && this.configurationId !== undefined) {
        return Promise.resolve(this.configurationId);
      }

      return new Promise((resolve, reject) => {
        this.$call.GetMobileConfigurationByCompanyId(
          {
            companyId: 1,
            cifNo: '123456',
            language: 'TH',
            screen: 'HOME',
            segment: 'sa24',
            wealthMembership: 'WP',
            theme: 'dark',
          },
          (response) => {
            const data = response?.Data ?? response?.data;
            const id = data?.ID ?? data?.id;
            if ((response?.Status === 'Successful' || response?.status === 0) && id !== null && id !== undefined) {
              this.configurationId = id;
              resolve(id);
              return;
            }
            reject(new Error('Could not resolve the saved mobile configuration ID.'));
          },
          (error) => reject(error)
        );
      });
    },

    async saveConfiguration() {
      if (this.loading) return;

      // Validate before asking the user for the required history note.
      const featureErrors = this.suggestionConfig.enabled ? this.validateSuggestionFeatures() : [];
      const questionErrors = this.suggestionQuestionConfig.enabled ? this.validateSuggestionQuestions() : [];
      const genieErrors = this.validateGenieCharacters();
      const geniePrefixErrors = this.validateGeniePrefixPatterns();
      const postMessageColorErrors = isValidPostMessageColor(this.postMessageColor) ? [] : [this.$t('taxHistoryStyleColorInvalid')];
      const allErrors = [...featureErrors, ...questionErrors, ...genieErrors, ...geniePrefixErrors, ...postMessageColorErrors];

      if (allErrors.length > 0) {
        this.$swal.fire({
          title: 'Validation Error',
          html: allErrors.join('<br>'),
          icon: 'error',
          confirmButtonText: 'OK',
        });
        return;
      }

      const historyNote = await this.requestHistoryNote();
      if (!historyNote) return;

      const historyEntries = this.buildHistoryEntries();

      this.loading = true;
      try {
        // Prepare the main configuration request
        const mobileConfigRequest = {
          languageThaiEnabled: this.config.languages.thai,
          languageEnglishEnabled: this.config.languages.english,
          languageChineseEnabled: this.config.languages.chinese,
          voiceEnabled: this.config.voice.enabled,
          voiceType: this.config.voice.type,
          copyMessageEnabled: this.config.copyMessage.enabled,
          suggestionFeatureEnabled: this.suggestionConfig.enabled,
          suggestionQuestionEnabled: this.suggestionQuestionConfig.enabled,
          loggingEnabled: this.config.logging.enabled,
          postMessageEnabled: this.config.postMessage.enabled,
          postMessage: this.postMessageText,
          postMessageEN: this.postMessageTextEN,
          postMessageCN: this.postMessageTextCN,
          postMessageColor: (this.postMessageColor || '').trim() || null,
          voiceSystemPrompt: this.config.voice.systemPrompt,
          geminiVoiceSystemPrompt: this.config.voice.geminiSystemPrompt,
          speechToTextType: this.config.voice.speechToTextType || 'device',
          voiceConfigurationId: this.config.voice.voiceConfigurationId ?? null,
          textToSpeechType: this.config.voice.textToSpeechType || 'default',
          endOfSpeechDetection: this.config.voice.endOfSpeechDetection || null,
          reformatForTTSPrompt: this.config.voice.reformatForTTSPrompt || '',
          formatForTTSEnginePrompt: this.config.voice.formatForTTSEnginePrompt || '',
          ttsModel: this.config.voice.ttsModel || 'gpt-5-chat',
          ttsApiVersion: this.config.voice.ttsApiVersion || '2025-01-01-preview',
          humanMode: this.config.humanMode || false,
          ttsEnabled: this.config.ttsEnabled || false,
          selectedModel: this.selectedModel || null,
          taxPlanningSelectedModel: this.taxPlanningSelectedModel || null,
          appTitle: this.appTitle || '',
          mobileInformationHeader: this.mobileInformationHeader || '',
          mobileInformation: this.mobileInformation,
          mobileInformationEN: this.mobileInformationEN,
          timeoutDuration: this.timeoutDuration || null,
          timeoutMessage: this.timeoutMessage || '',
          timeoutMessageEN: this.timeoutMessageEN || '',
          timeoutMessageCN: this.timeoutMessageCN || '',
          suggestBarText: this.suggestBarText,
          suggestBarTextEN: this.suggestBarTextEN,
          suggestBarTextCN: this.suggestBarTextCN,
          // Cache Configuration
          enableCache: this.config.enableCache || false,
          cacheTTLMinutes: this.config.cacheTTLMinutes || 1440,
          cacheScope: this.config.cacheScope || 'shared',
          enableSemanticCache: this.config.enableSemanticCache || false,
          similarityThreshold: this.config.similarityThreshold || 0.95,
          // wakeWords not sent — the Wake word tab saves them itself (#786)
        };

        // Use Update if we have an ID (including 0), Create if we don't
        const hasId = this.configurationId !== null && this.configurationId !== undefined;
        const apiMethod = hasId ? 'UpdateMobileConfiguration' : 'CreateMobileConfiguration';
        if (hasId) {
          mobileConfigRequest.ID = this.configurationId;
        }

        // Verify the API method exists
        if (!this.$call[apiMethod]) {
          throw new Error(`API method ${apiMethod} not found in $call wrapper`);
        }

        // STEP 1: Save main configuration
        let mainConfigResponse = await new Promise((resolve, reject) => {
          this.$call[apiMethod](
            mobileConfigRequest,
            (response) => {
              if (response && (response.Status === 'Successful' || response.status === 0)) {
                // Store the ID if it was a create operation
                if (!this.configurationId && response.data && response.data.id) {
                  this.configurationId = response.data.id;
                }
                resolve(response);
              } else {
                reject(new Error(response?.Message || 'Save main configuration failed'));
              }
            },
            (error) => {
              console.error('Save main configuration error:', error);
              reject(error);
            }
          );
        });

        await this.ensureMobileConfigurationId();

        // STEP 2: Delete marked features
        if (this.featuresToDelete.length > 0) {
          this.featuresToDelete.forEach((e) => {
            const removeIdx = this.suggestionConfig.features.findIndex((f) => f && f.featureId === e);
            if (removeIdx !== -1) {
              this.suggestionConfig.features.splice(removeIdx, 1);
            }
          });
          await this.deleteMarkedFeatures();
        }

        // STEP 3: Delete marked questions
        if (this.questionsToDelete.length > 0) {
          this.questionsToDelete.forEach((e) => {
            const removeIdx = this.suggestionQuestionConfig.questions.findIndex((q) => q && q.questionId === e);
            if (removeIdx !== -1) {
              this.suggestionQuestionConfig.questions.splice(removeIdx, 1);
            }
          });
          await this.deleteMarkedQuestions();
        }

        // Get the configuration ID for saving features and questions
        const configId = this.configurationId;
        // STEP 4: Save suggestion features if enabled
        if (this.suggestionConfig.enabled && configId) {
          await this.saveSuggestionFeatures(configId);
        }

        // STEP 5: Save suggestion questions if enabled
        if (this.suggestionQuestionConfig.enabled && configId) {
          await this.saveSuggestionQuestions(configId);
        }

        // STEP 6: Delete marked genie characters
        if (this.genieCharactersToDelete.length > 0) {
          await this.deleteMarkedGenieCharacters();
        }

        // STEP 7: Save genie AI characters
        if (this.genieCharacters.length > 0 && configId) {
          await this.saveGenieCharacters(configId);
        }

        // STEP 8: Delete marked genie prefix patterns
        if (this.geniePrefixPatternsToDelete.length > 0) {
          await this.deleteMarkedGeniePrefixPatterns();
        }

        // STEP 9: Save genie prefix patterns
        if (this.geniePrefixPatterns.length > 0 && configId) {
          await this.saveGeniePrefixPatterns(configId);
        }

        if (historyEntries.length > 0) {
          try {
            await this.saveMobileConfigurationHistory(historyEntries, historyNote);
          } catch (historyError) {
            console.error('Save mobile configuration history error:', historyError);
            await this.loadConfiguration();
            this.$swal.fire({
              title: this.$t('error'),
              text: 'Configuration was saved, but History Log could not be saved.',
              icon: 'error',
              confirmButtonText: this.$t('ok'),
            });
            return;
          }
        }

        this.$swal.fire({
          title: this.$t('success'),
          text: this.$t('configurationSaved'),
          icon: 'success',
          confirmButtonText: this.$t('ok'),
        });
        await this.loadConfiguration(); // Reload to get updated data and refresh the history baseline
      } catch (error) {
        console.error('Save configuration error:', error);

        if (error.response?.status === 401) {
          this.$swal
            .fire({
              title: this.$t('error'),
              text: 'Authentication required. Please login again.',
              icon: 'error',
              confirmButtonText: this.$t('ok'),
            })
            .then(() => {
              // Redirect to home or refresh page
              window.location.href = '/';
            });
          return;
        }

        this.$swal.fire({
          title: this.$t('error'),
          text: error.response?.data?.Message || error.message || this.$t('saveFailed'),
          icon: 'error',
          confirmButtonText: this.$t('ok'),
        });
      } finally {
        this.loading = false;
      }
    },

    async deleteMarkedFeatures() {
      const deletePromises = this.featuresToDelete.map((featureId) => {
        return new Promise((resolve, reject) => {
          this.$call.DeleteSuggestionFeature(
            featureId,
            (response) => {
              if (response && (response.Status === 'Successful' || response.status === 0)) {
                resolve(response);
              } else {
                reject(new Error(response?.Message || `Failed to delete feature ${featureId}.`));
              }
            },
            (error) => {
              console.error(`Error deleting feature ${featureId}:`, error);
              reject(error);
            }
          );
        });
      });

      await Promise.all(deletePromises);
      this.featuresToDelete = [];
    },

    async deleteMarkedQuestions() {
      const deletePromises = this.questionsToDelete.map((questionId) => {
        return new Promise((resolve, reject) => {
          this.$call.DeleteSuggestionQuestion(
            questionId,
            (response) => {
              if (response && (response.Status === 'Successful' || response.status === 0)) {
                resolve(response);
              } else {
                reject(new Error(response?.Message || `Failed to delete question ${questionId}.`));
              }
            },
            (error) => {
              console.error(`Error deleting question ${questionId}:`, error);
              reject(error);
            }
          );
        });
      });

      await Promise.all(deletePromises);
      this.questionsToDelete = [];
    },

    async saveSuggestionFeatures(configId) {
      // Collect only enabled features for parallel processing
      const featuresToSave = [];
      this.suggestionConfig.features.forEach((feature, index) => {
        if (feature) {
          feature.segment = feature.segment.filter((segment) => this.segmentOptions.some((option) => option.valueString === segment));
          feature.wealthMembership = feature.wealthMembership.filter((membership) => this.wealthMembershipOptions.some((option) => option.valueString === membership));
          const featureData = {
            ID: feature.featureId || null,
            FeatureNumber: index + 1,
            MessageThai: feature.messages.thai || '',
            MessageEnglish: feature.messages.english || '',
            MessageChinese: feature.messages.chinese || '',
            ModelName: feature.modelName || '',
            TargetGroup: feature.targetGroup || 'all',
            Priority: feature.priority ? parseInt(feature.priority) : null,
            Segment: feature.segment ? feature.segment.toString() : null,
            WealthMembership: feature.wealthMembership ? feature.wealthMembership.toString() : null,
            EffectiveStartDate: this.formatDateForAPI(feature.effectiveStartDate),
            EffectiveEndDate: this.formatDateForAPI(feature.effectiveEndDate),
            FeatureEnabled: feature.featureEnabled,
            TaxPlanningEnabled: feature.taxPlanningEnabled || false,
            Action: feature.action || null,
            IconPath: feature.imageUrl || null,
            isNew: feature.isNew || false,
            cifFiles: feature.cifFiles || [],
          };

          featuresToSave.push({ featureNumber: index + 1, data: featureData });
        }
      });

      if (featuresToSave.length === 0) {
        console.log('No enabled features to save');
        return;
      }
      // Save all features in parallel using Promise.all
      const savePromises = featuresToSave.map(({ featureNumber, data }) => this.saveOrUpdateSingleFeature(configId, featureNumber, data));

      try {
        await Promise.all(savePromises);
      } catch (error) {
        console.error('Error saving suggestion features:', error);
        throw error;
      }
    },

    async saveOrUpdateSingleFeature(configId, featureNumber, featureData) {
      // Try update first, then create if it fails
      try {
        if (featureData.isNew) {
          await new Promise((resolve, reject) => {
            this.$call.CreateSuggestionFeature(
              configId,
              featureData,
              (response) => {
                if (response && (response.Status === 'Successful' || response.status === 0)) {
                  resolve(response);
                } else {
                  reject(new Error(`Failed to create feature ${featureNumber}: ${response?.Message || 'Unknown error'}`));
                }
              },
              (error) => {
                console.error(`Error creating feature ${featureNumber}:`, error);
                reject(error);
              }
            );
          });
        } else {
          await new Promise((resolve, reject) => {
            this.$call.UpdateSuggestionFeature(
              configId,
              featureData,
              (response) => {
                if (response && (response.Status === 'Successful' || response.status === 0)) {
                  resolve(response);
                } else {
                  reject(new Error('Update failed, will try create'));
                }
              },
              (error) => {
                console.log(`Update error for feature ${featureNumber}, trying create:`, error);
                reject(error);
              }
            );
          });
        }
      } catch (updateError) {
        console.error(`Failed to save feature ${featureNumber}:`, updateError);
        throw updateError;
      }
    },

    async saveSuggestionQuestions(configId) {
      // Collect only enabled questions for parallel processing
      const questionsToSave = [];
      this.suggestionQuestionConfig.questions.forEach((question, index) => {
        if (question) {
          question.segment = question.segment.filter((segment) => this.segmentOptions.some((option) => option.valueString === segment));
          question.wealthMembership = question.wealthMembership.filter((membership) => this.wealthMembershipOptions.some((option) => option.valueString === membership));
          const questionData = {
            ID: question.questionId || null,
            QuestionNumber: index + 1,
            MessageThai: question.messages.thai || '',
            MessageEnglish: question.messages.english || '',
            MessageChinese: question.messages.chinese || '',
            TargetGroup: question.targetGroup || 'all',
            Priority: question.priority ? parseInt(question.priority) : null,
            Segment: question.segment ? question.segment.toString() : null,
            WealthMembership: question.wealthMembership ? question.wealthMembership.toString() : null,
            EffectiveStartDate: this.formatDateForAPI(question.effectiveStartDate),
            EffectiveEndDate: this.formatDateForAPI(question.effectiveEndDate),
            QuestionEnabled: question.questionEnabled,
            TaxPlanningEnabled: question.taxPlanningEnabled || false,
            isNew: question.isNew || false,
            cifFiles: question.cifFiles || [],
          };

          questionsToSave.push({ questionNumber: index + 1, data: questionData });
        }
      });

      if (questionsToSave.length === 0) {
        console.log('No enabled questions to save');
        return;
      }
      // Save all questions in parallel using Promise.all
      const savePromises = questionsToSave.map(({ questionNumber, data }) => this.saveOrUpdateSingleQuestion(configId, questionNumber, data));

      try {
        await Promise.all(savePromises);
      } catch (error) {
        console.error('Error saving suggestion questions:', error);
        throw error;
      }
    },

    async saveOrUpdateSingleQuestion(configId, questionNumber, questionData) {
      // Try update first, then create if it fails
      try {
        if (questionData.isNew) {
          await new Promise((resolve, reject) => {
            this.$call.CreateSuggestionQuestion(
              configId,
              questionData,
              (response) => {
                if (response && (response.Status === 'Successful' || response.status === 0)) {
                  resolve(response);
                } else {
                  reject(new Error(`Failed to create question ${questionNumber}: ${response?.Message || 'Unknown error'}`));
                }
              },
              (error) => {
                console.error(`Error creating question ${questionNumber}:`, error);
                reject(error);
              }
            );
          });
        } else {
          await new Promise((resolve, reject) => {
            this.$call.UpdateSuggestionQuestion(
              configId,
              questionData,
              (response) => {
                if (response && (response.Status === 'Successful' || response.status === 0)) {
                  resolve(response);
                } else {
                  reject(new Error('Update failed, will try create'));
                }
              },
              (error) => {
                console.log(`Update error for question ${questionNumber}, trying create:`, error);
                reject(error);
              }
            );
          });
        }
      } catch (updateError) {
        console.error(`Failed to save question ${questionNumber}:`, updateError);
        throw updateError;
      }
    },

    // Image upload methods
    openImageUpload(featureIndex) {
      this.selectedFeatureIndex = featureIndex;
      this.$refs.imageInput.click();
    },

    handleImageUpload(event) {
      const file = event.target.files[0];
      if (file && file.type.startsWith('image/')) {
        // Create object URL for the cropper
        this.selectedImageFile = URL.createObjectURL(file);
        this.imageCropDialog = true;
      } else {
        this.$swal.fire({
          title: this.$t('error'),
          text: 'Please select a valid image file.',
          icon: 'error',
          confirmButtonText: this.$t('ok'),
        });
      }
    },

    cropImage() {
      const { canvas } = this.$refs.cropper.getResult();
      if (canvas) {
        // Create a new canvas with the desired output size (200x200)
        const outputCanvas = document.createElement('canvas');
        outputCanvas.width = 200;
        outputCanvas.height = 200;
        const ctx = outputCanvas.getContext('2d');

        // Draw the cropped image onto the output canvas
        ctx.drawImage(canvas, 0, 0, 200, 200);

        outputCanvas.toBlob(
          (blob) => {
            this.croppedImageBlob = blob;
            this.uploadCroppedImage();
          },
          'image/png',
          0.9
        );
      }
    },

    async uploadCroppedImage() {
      if (!this.croppedImageBlob || this.selectedFeatureIndex === null) return;

      try {
        // Create FormData with the cropped image blob
        const formData = new FormData();
        formData.append('entity', this.croppedImageBlob, `feature_${this.selectedFeatureIndex + 1}.png`);

        // Use existing GPTStream upload API
        const uploadPromise = new Promise((resolve, reject) => {
          this.$call.UploadImage_Stream(
            {
              entity: formData,
              USER_CHANNEL: this.$root.User_Id || 'mobile_config',
            },
            (response) => {
              console.log('Image upload response:', response);
              if (response && response.status === 0 && response.data) {
                resolve(response.data);
              } else {
                reject(new Error(response?.message || 'Upload failed'));
              }
            },
            (error) => {
              console.error('Image upload error:', error);
              reject(error);
            }
          );
        });

        // Show loading state
        this.$swal.fire({
          title: 'Uploading...',
          text: 'Please wait while the image is being uploaded.',
          allowOutsideClick: false,
          showConfirmButton: false,
          willOpen: () => {
            this.$swal.showLoading();
          },
        });

        const imageUrl = await uploadPromise;

        // Update the feature with the new image URL
        if (this.suggestionConfig.features[this.selectedFeatureIndex]) {
          this.suggestionConfig.features[this.selectedFeatureIndex].imageUrl = imageUrl;
        }

        this.$swal.fire({
          title: this.$t('success'),
          text: 'Image uploaded successfully!',
          icon: 'success',
          confirmButtonText: this.$t('ok'),
          timer: 2000,
        });
      } catch (error) {
        console.error('Image upload error:', error);
        this.$swal.fire({
          title: this.$t('error'),
          text: error.message || 'Failed to upload image. Please try again.',
          icon: 'error',
          confirmButtonText: this.$t('ok'),
        });
      } finally {
        this.closeCropDialog();
      }
    },

    // Image error handling
    onImageError(feature, index) {
      console.warn(`Failed to load image for feature ${index + 1}:`, feature.imageUrl);
      // Don't clear imageUrl immediately, let v-img handle fallback to error slot
      // The computed property will provide a fallback image anyway
    },

    closeCropDialog() {
      this.imageCropDialog = false;
      if (this.selectedImageFile) {
        URL.revokeObjectURL(this.selectedImageFile); // Clean up object URL
      }
      this.selectedImageFile = null;
      this.croppedImageBlob = null;
      this.selectedFeatureIndex = null;
      // Clear the file input
      if (this.$refs.imageInput) {
        this.$refs.imageInput.value = '';
      }
    },

    // ============ Genie AI Character Methods ============

    addNewGenieCharacter() {
      this.genieCharacters.push({
        collapsed: false,
        characterName: '',
        effectiveStartDate: '',
        effectiveEndDate: '',
        isActive: true,
        showInProactiveMode: false,
        taxPlanningEnabled: false,
        iconProactiveUrl: '',
        iconChatFirstUrl: '',
        iconChatUrl: '',
        iconVoicePageUrl: '',
        iconValidationTouched: false,
        isNew: true,
        pendingFiles: {},
      });
      this.genieCharactersPage = this.genieCharactersTotalPages;
    },

    removeGenieCharacter(index) {
      if (this.genieCharacters.length <= 1) {
        this.$swal.fire({
          title: this.$t('error'),
          text: 'You must keep at least one character.',
          icon: 'warning',
          confirmButtonText: this.$t('ok'),
        });
        return;
      }

      const character = this.genieCharacters[index];
      if (character && !character.isNew && character.id) {
        if (!this.genieCharactersToDelete.includes(character.id)) {
          this.genieCharactersToDelete.push(character.id);
        }
      }

      // Reset manual preview if previewing the removed character
      if (this.geniePreviewIndex === index) {
        this.geniePreviewIndex = null;
        this.geniePreviewIsManual = false;
      } else if (this.geniePreviewIndex !== null && this.geniePreviewIndex > index) {
        this.geniePreviewIndex--;
      }

      this.genieCharacters.splice(index, 1);
    },

    previewGenieCharacter(index) {
      this.geniePreviewIndex = index;
      this.geniePreviewIsManual = true;
    },

    resetGeniePreview() {
      this.geniePreviewIsManual = false;
      this.geniePreviewIndex = null;
    },

    triggerGenieIconUpload(characterIndex, fieldName) {
      this.genieIconUploadTarget = { index: characterIndex, field: fieldName };
      const input = this.$refs.genieIconInput;
      input.accept = 'image/*';
      input.click();
    },

    async handleGenieIconUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      const target = this.genieIconUploadTarget;
      if (!target) return;

      const validationError = await validateGenieIconFile(file);
      if (validationError) {
        this.$swal.fire({
          title: this.$t('error'),
          text: validationError,
          icon: 'error',
          confirmButtonText: this.$t('ok'),
        });
        this.genieIconUploadTarget = null;
        if (this.$refs.genieIconInput) this.$refs.genieIconInput.value = '';
        return;
      }

      const fieldMap = {
        proactive: 'iconProactiveUrl',
        chatFirst: 'iconChatFirstUrl',
        chat: 'iconChatUrl',
        voicePage: 'iconVoicePageUrl',
      };

      const prop = fieldMap[target.field];
      const character = this.genieCharacters[target.index];
      if (prop && character) {
        // Revoke previous blob URL if any
        const existing = character.pendingFiles?.[target.field];
        if (existing?.blobUrl) URL.revokeObjectURL(existing.blobUrl);

        const blobUrl = URL.createObjectURL(file);
        if (!character.pendingFiles) character.pendingFiles = {};
        character.pendingFiles[target.field] = { file, blobUrl };
        character[prop] = blobUrl;
      }

      this.genieIconUploadTarget = null;
      if (this.$refs.genieIconInput) this.$refs.genieIconInput.value = '';
    },

    // ===== Genie Prefix Pattern Methods (Think Loader) =====

    createGeniePrefixUid() {
      return `gpx_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
    },

    createEmptyGeniePrefixStep() {
      return {
        uid: this.createGeniePrefixUid(),
        id: null,
        durationSec: 3,
        textThai: '',
        textEnglish: '',
        textChinese: '',
        mp3Thai: { file: null, fileName: '', url: '' },
        mp3English: { file: null, fileName: '', url: '' },
        mp3Chinese: { file: null, fileName: '', url: '' },
        geminiMp3Thai: { file: null, fileName: '', url: '' },
        geminiMp3English: { file: null, fileName: '', url: '' },
        geminiMp3Chinese: { file: null, fileName: '', url: '' },
        createdAt: null,
      };
    },

    createEmptyGeniePrefixPattern() {
      return {
        uid: this.createGeniePrefixUid(),
        id: null,
        patternName: '',
        effectiveStartDate: '',
        effectiveEndDate: '',
        isActive: true,
        isNew: true,
        createdAt: null,
        steps: [this.createEmptyGeniePrefixStep()],
      };
    },

    addGeniePrefixPattern() {
      const pattern = this.createEmptyGeniePrefixPattern();
      this.geniePrefixPatterns.push(pattern);
      this.expandedGeniePrefixPatterns.push(pattern.uid);
    },

    removeGeniePrefixPattern(pattern) {
      const index = this.geniePrefixPatterns.indexOf(pattern);
      if (index === -1) return;

      this.stopGeniePrefixVoiceMp3();
      pattern.steps.forEach((step) => this.revokeGeniePrefixStepBlobUrls(step));

      if (!pattern.isNew && pattern.id && !this.geniePrefixPatternsToDelete.includes(pattern.id)) {
        this.geniePrefixPatternsToDelete.push(pattern.id);
      }
      this.geniePrefixPatterns.splice(index, 1);
      this.expandedGeniePrefixPatterns = this.expandedGeniePrefixPatterns.filter((uid) => uid !== pattern.uid);
    },

    addGeniePrefixStep(pattern) {
      pattern.steps.push(this.createEmptyGeniePrefixStep());
    },

    removeGeniePrefixStep(pattern, stepIndex) {
      const step = pattern.steps[stepIndex];
      if (!step) return;
      this.stopGeniePrefixVoiceMp3();
      this.revokeGeniePrefixStepBlobUrls(step);
      pattern.steps.splice(stepIndex, 1);
    },

    moveGeniePrefixStep(pattern, stepIndex, direction) {
      const target = stepIndex + direction;
      if (target < 0 || target >= pattern.steps.length) return;
      this.stopGeniePrefixVoiceMp3();
      const [step] = pattern.steps.splice(stepIndex, 1);
      pattern.steps.splice(target, 0, step);
    },

    revokeGeniePrefixStepBlobUrls(step) {
      ['mp3Thai', 'mp3English', 'mp3Chinese', 'geminiMp3Thai', 'geminiMp3English', 'geminiMp3Chinese'].forEach((prop) => {
        if (step?.[prop]?.url?.startsWith('blob:')) {
          URL.revokeObjectURL(step[prop].url);
        }
      });
    },

    mapGeniePrefixPatterns(apiPatterns = []) {
      return apiPatterns.map((pattern) => ({
        uid: this.createGeniePrefixUid(),
        id: pattern.id,
        patternName: pattern.patternName || '',
        effectiveStartDate: this.formatDateForInput(pattern.effectiveStartDate) || '',
        effectiveEndDate: this.formatDateForInput(pattern.effectiveEndDate) || '',
        isActive: pattern.isActive !== undefined ? pattern.isActive : true,
        isNew: false,
        createdAt: pattern.createdAt || null,
        steps: (pattern.steps || []).map((step) => ({
          uid: this.createGeniePrefixUid(),
          id: step.id,
          durationSec: step.durationSec || 3,
          textThai: step.textThai || '',
          textEnglish: step.textEnglish || '',
          textChinese: step.textChinese || '',
          mp3Thai: { file: null, fileName: step.mp3ThaiFileName || '', url: step.mp3ThaiUrl || '' },
          mp3English: { file: null, fileName: step.mp3EnglishFileName || '', url: step.mp3EnglishUrl || '' },
          mp3Chinese: { file: null, fileName: step.mp3ChineseFileName || '', url: step.mp3ChineseUrl || '' },
          geminiMp3Thai: { file: null, fileName: step.geminiMp3ThaiFileName || '', url: step.geminiMp3ThaiUrl || '' },
          geminiMp3English: { file: null, fileName: step.geminiMp3EnglishFileName || '', url: step.geminiMp3EnglishUrl || '' },
          geminiMp3Chinese: { file: null, fileName: step.geminiMp3ChineseFileName || '', url: step.geminiMp3ChineseUrl || '' },
          createdAt: step.createdAt || null,
        })),
      }));
    },

    validateGeniePrefixPatterns() {
      const errors = [];
      this.geniePrefixPatterns.forEach((pattern, pIdx) => {
        // Fully-untouched new patterns are skipped on save, so don't validate them
        if (!this.hasGeniePrefixPatternContent(pattern)) return;
        pattern.steps.forEach((step, sIdx) => {
          const missing = [];
          if (!step.textThai?.trim()) missing.push('Thai text');
          if (!step.textEnglish?.trim()) missing.push('English text');
          if (!step.textChinese?.trim()) missing.push('Chinese text');
          if (!step.mp3Thai?.fileName) missing.push('Thai MP3');
          if (!step.mp3English?.fileName) missing.push('English MP3');
          if (!step.mp3Chinese?.fileName) missing.push('Chinese MP3');
          if (missing.length > 0) {
            errors.push(`Genie Prefix Pattern ${pIdx + 1}, Step ${sIdx + 1}: ${missing.join(', ')} required`);
          }
        });
      });
      return errors;
    },

    geniePrefixMp3Prop(language, variant = 'default') {
      const langMap = { thai: 'Thai', english: 'English', chinese: 'Chinese' };
      const suffix = langMap[language];
      if (!suffix) return null;
      return variant === 'gemini' ? `geminiMp3${suffix}` : `mp3${suffix}`;
    },

    triggerGeniePrefixStepMp3Upload(pattern, stepIndex, language, variant = 'default') {
      this.geniePrefixStepMp3UploadTarget = { pattern, stepIndex, language, variant };
      const input = this.$refs.geniePrefixStepMp3Input;
      if (input) {
        input.value = '';
        input.click();
      }
    },

    handleGeniePrefixStepMp3Upload(event) {
      const file = event.target.files[0];
      if (!file) return;

      const target = this.geniePrefixStepMp3UploadTarget;
      if (!target) return;

      // Validate file type
      if (!file.name.toLowerCase().endsWith('.mp3') && file.type !== 'audio/mpeg') {
        this.$swal.fire({
          title: this.$t('error'),
          text: 'Please select a valid MP3 file.',
          icon: 'error',
          confirmButtonText: this.$t('ok'),
        });
        this.geniePrefixStepMp3UploadTarget = null;
        if (this.$refs.geniePrefixStepMp3Input) this.$refs.geniePrefixStepMp3Input.value = '';
        return;
      }

      // Validate file size (max 10MB)
      const maxBytes = 10 * 1024 * 1024;
      if (file.size > maxBytes) {
        this.$swal.fire({
          title: this.$t('error'),
          text: 'File size must not exceed 10MB.',
          icon: 'error',
          confirmButtonText: this.$t('ok'),
        });
        this.geniePrefixStepMp3UploadTarget = null;
        if (this.$refs.geniePrefixStepMp3Input) this.$refs.geniePrefixStepMp3Input.value = '';
        return;
      }

      const prop = this.geniePrefixMp3Prop(target.language, target.variant);
      const step = target.pattern?.steps?.[target.stepIndex];
      if (prop && step) {
        // Revoke previous blob URL if any
        if (step[prop]?.url?.startsWith('blob:')) {
          URL.revokeObjectURL(step[prop].url);
        }
        step[prop] = {
          file: file,
          fileName: file.name,
          url: URL.createObjectURL(file),
        };
      }

      this.geniePrefixStepMp3UploadTarget = null;
      if (this.$refs.geniePrefixStepMp3Input) this.$refs.geniePrefixStepMp3Input.value = '';
    },

    removeGeniePrefixStepMp3(pattern, stepIndex, language, variant = 'default') {
      const prop = this.geniePrefixMp3Prop(language, variant);
      const step = pattern?.steps?.[stepIndex];
      if (prop && step && step[prop]) {
        if (step[prop].url && step[prop].url.startsWith('blob:')) {
          URL.revokeObjectURL(step[prop].url);
        }
        step[prop] = { file: null, fileName: '', url: '' };
      }

      // Stop playback if currently playing this file
      if (this.geniePrefixVoicePlaying === `${pattern.uid}_${stepIndex}_${language}_${variant}`) {
        this.stopGeniePrefixVoiceMp3();
      }
    },

    playGeniePrefixStepMp3(pattern, stepIndex, language, variant = 'default') {
      const key = `${pattern.uid}_${stepIndex}_${language}_${variant}`;

      // If already playing this one, stop it
      if (this.geniePrefixVoicePlaying === key) {
        this.stopGeniePrefixVoiceMp3();
        return;
      }

      // Stop any current playback
      this.stopGeniePrefixVoiceMp3();

      const prop = this.geniePrefixMp3Prop(language, variant);
      const step = pattern?.steps?.[stepIndex];
      if (!prop || !step || !step[prop]?.url) return;

      const audio = new Audio(step[prop].url);
      audio.addEventListener('ended', () => {
        this.geniePrefixVoicePlaying = null;
        this.geniePrefixVoiceAudio = null;
      });
      audio.addEventListener('error', () => {
        this.geniePrefixVoicePlaying = null;
        this.geniePrefixVoiceAudio = null;
      });
      audio.play();
      this.geniePrefixVoiceAudio = audio;
      this.geniePrefixVoicePlaying = key;
    },

    stopGeniePrefixVoiceMp3() {
      if (this.geniePrefixVoiceAudio) {
        this.geniePrefixVoiceAudio.pause();
        this.geniePrefixVoiceAudio.currentTime = 0;
        this.geniePrefixVoiceAudio = null;
      }
      this.geniePrefixVoicePlaying = null;
    },

    async uploadGenieCharacterPendingFiles(character) {
      const fieldMap = {
        proactive: 'iconProactiveUrl',
        chatFirst: 'iconChatFirstUrl',
        chat: 'iconChatUrl',
        voicePage: 'iconVoicePageUrl',
      };

      if (!character.pendingFiles) return;

      const uploads = Object.entries(character.pendingFiles).map(([field, { file, blobUrl }]) => {
        const formData = new FormData();
        formData.append('entity', file, file.name);
        return new Promise((resolve, reject) => {
          this.$call.UploadGenieCharacterIcon(
            { entity: formData, USER_CHANNEL: this.$root.User_Id || 'mobile_config', genieField: field },
            (response) => {
              if (response && response.status === 0 && response.data) {
                URL.revokeObjectURL(blobUrl);
                const prop = fieldMap[field];
                if (prop) character[prop] = response.data;
                resolve();
              } else {
                reject(new Error(response?.message || `Upload failed for ${field}`));
              }
            },
            (error) => reject(error)
          );
        });
      });

      await Promise.all(uploads);
      character.pendingFiles = {};
    },

    getMissingGenieIconLabels(character) {
      const iconFields = [
        { field: 'iconProactiveUrl', label: 'Proactive' },
        { field: 'iconChatFirstUrl', label: 'Chat First' },
        { field: 'iconChatUrl', label: 'Chat' },
        { field: 'iconVoicePageUrl', label: 'Voice Page' },
      ];

      return iconFields.filter(({ field }) => !String(character?.[field] || '').trim()).map(({ label }) => label);
    },

    validateGenieCharacters() {
      const errors = [];
      this.genieCharacters.forEach((character, index) => {
        const missingIconLabels = this.getMissingGenieIconLabels(character);
        if (missingIconLabels.length > 0) {
          character.iconValidationTouched = true;
          errors.push(`Character ${index + 1}: Character Icons are required (${missingIconLabels.join(', ')})`);
        }
        if (!character.characterName?.trim()) {
          errors.push(`Character ${index + 1}: Character Name is required`);
        }
        if (!character.effectiveStartDate) {
          errors.push(`Character ${index + 1}: Effective Start Date is required`);
        }
        if (!this.validateDateRange(character.effectiveStartDate, character.effectiveEndDate)) {
          errors.push(`Character ${index + 1}: End Date must be on or after Start Date`);
        }
      });
      return errors;
    },

    async saveGenieCharacters(configId) {
      // Upload any pending icon files before saving
      await Promise.all(this.genieCharacters.map((character) => this.uploadGenieCharacterPendingFiles(character)));

      const charactersToSave = this.genieCharacters.map((character, index) => ({
        ID: character.id || null,
        CharacterName: character.characterName || '',
        EffectiveStartDate: this.formatDateForAPI(character.effectiveStartDate),
        EffectiveEndDate: this.formatDateForAPI(character.effectiveEndDate),
        IsActive: character.isActive,
        ShowInProactiveMode: character.showInProactiveMode || false,
        TaxPlanningEnabled: character.taxPlanningEnabled || false,
        IconProactiveUrl: character.iconProactiveUrl || null,
        IconChatFirstUrl: character.iconChatFirstUrl || null,
        IconChatUrl: character.iconChatUrl || null,
        IconVoicePageUrl: character.iconVoicePageUrl || null,
        isNew: character.isNew || false,
      }));

      const savePromises = charactersToSave.map((data) => {
        const apiMethod = data.isNew ? 'CreateGenieAICharacter' : 'UpdateGenieAICharacter';
        if (!this.$call[apiMethod]) {
          return Promise.reject(new Error(`API method ${apiMethod} not found for genie character save.`));
        }
        return new Promise((resolve, reject) => {
          this.$call[apiMethod](
            configId,
            data,
            (response) => {
              if (response && (response.Status === 'Successful' || response.status === 0)) {
                resolve(response);
              } else {
                reject(new Error(response?.Message || `Failed to save character`));
              }
            },
            (error) => {
              console.error('Error saving genie character:', error);
              reject(error);
            }
          );
        });
      });

      await Promise.all(savePromises);
    },

    async deleteMarkedGenieCharacters() {
      if (!this.$call.DeleteGenieAICharacter) {
        throw new Error('API method DeleteGenieAICharacter not found.');
      }

      const deletePromises = this.genieCharactersToDelete.map((characterId) => {
        return new Promise((resolve, reject) => {
          this.$call.DeleteGenieAICharacter(
            characterId,
            (response) => {
              if (this.isApiSuccess(response)) {
                resolve(response);
              } else {
                reject(new Error(response?.Message || `Failed to delete genie character ${characterId}.`));
              }
            },
            (error) => {
              console.error(`Error deleting genie character ${characterId}:`, error);
              reject(error);
            }
          );
        });
      });

      await Promise.all(deletePromises);
      this.genieCharactersToDelete = [];
    },

    async saveGeniePrefixPatterns(configId) {
      for (let index = 0; index < this.geniePrefixPatterns.length; index++) {
        await this.saveGeniePrefixPattern(configId, this.geniePrefixPatterns[index], index);
      }
    },

    async saveGeniePrefixPattern(configId, pattern, index) {
      if (pattern.isNew && !this.hasGeniePrefixPatternContent(pattern)) return;

      const saveResponse = await new Promise((resolve, reject) => {
        this.$call.SaveGeniePrefixPattern(
          configId,
          this.buildGeniePrefixPatternPayload(pattern, index),
          (response) => resolve(response),
          (error) => {
            console.error('Error saving genie prefix pattern:', error);
            reject(error);
          }
        );
      });

      if (!this.isApiSuccess(saveResponse)) {
        throw new Error(saveResponse?.Message || saveResponse?.message || 'Failed to save genie prefix pattern.');
      }

      this.applySavedGeniePrefixPattern(pattern, saveResponse?.Data || saveResponse?.data);

      if (this.hasPendingGeniePrefixStepMp3(pattern)) {
        await this.uploadGeniePrefixStepPendingFiles(pattern);

        // Re-save so the uploaded blob-storage URLs are persisted on the steps
        const updateResponse = await new Promise((resolve, reject) => {
          this.$call.SaveGeniePrefixPattern(
            configId,
            this.buildGeniePrefixPatternPayload(pattern, index),
            (response) => {
              resolve(response);
            },
            (error) => {
              console.error('Error updating genie prefix step MP3 URLs:', error);
              reject(error);
            }
          );
        });

        if (!this.isApiSuccess(updateResponse)) {
          throw new Error(updateResponse?.Message || updateResponse?.message || 'Failed to update genie prefix step MP3 URLs.');
        }
      }
    },

    applySavedGeniePrefixPattern(pattern, savedPattern) {
      if (!savedPattern) return;
      pattern.id = savedPattern.id || savedPattern.ID || pattern.id;
      pattern.createdAt = savedPattern.createdAt || savedPattern.CreatedAt || pattern.createdAt;
      pattern.isNew = false;

      // Server preserves request order, so match saved steps back by array position
      const savedSteps = savedPattern.steps || savedPattern.Steps || [];
      pattern.steps.forEach((step, index) => {
        const saved = savedSteps[index];
        if (!saved) return;
        step.id = saved.id || saved.ID || step.id;
        step.createdAt = saved.createdAt || saved.CreatedAt || step.createdAt;
      });
    },

    hasGeniePrefixPatternContent(pattern) {
      if (pattern.patternName || pattern.effectiveStartDate || pattern.effectiveEndDate) return true;
      return pattern.steps.some(
        (step) =>
          step.textThai ||
          step.textEnglish ||
          step.textChinese ||
          ['mp3Thai', 'mp3English', 'mp3Chinese', 'geminiMp3Thai', 'geminiMp3English', 'geminiMp3Chinese'].some(
            (prop) => !!step[prop]?.fileName || !!step[prop]?.url || !!step[prop]?.file
          )
      );
    },

    buildGeniePrefixPatternPayload(pattern, index) {
      return {
        ID: pattern.isNew ? null : (pattern.id || null),
        PatternNumber: index + 1,
        PatternName: pattern.patternName || '',
        EffectiveStartDate: this.formatDateForAPI(pattern.effectiveStartDate),
        EffectiveEndDate: this.formatDateForAPI(pattern.effectiveEndDate),
        IsActive: pattern.isActive,
        Steps: pattern.steps.map((step) => ({
          ID: step.id || null,
          DurationSec: step.durationSec || 3,
          TextThai: step.textThai || '',
          TextEnglish: step.textEnglish || '',
          TextChinese: step.textChinese || '',
          Mp3ThaiUrl: step.mp3Thai?.url && !step.mp3Thai.url.startsWith('blob:') ? step.mp3Thai.url : null,
          Mp3ThaiFileName: step.mp3Thai?.fileName || null,
          Mp3EnglishUrl: step.mp3English?.url && !step.mp3English.url.startsWith('blob:') ? step.mp3English.url : null,
          Mp3EnglishFileName: step.mp3English?.fileName || null,
          Mp3ChineseUrl: step.mp3Chinese?.url && !step.mp3Chinese.url.startsWith('blob:') ? step.mp3Chinese.url : null,
          Mp3ChineseFileName: step.mp3Chinese?.fileName || null,
          GeminiMp3ThaiUrl: step.geminiMp3Thai?.url && !step.geminiMp3Thai.url.startsWith('blob:') ? step.geminiMp3Thai.url : null,
          GeminiMp3ThaiFileName: step.geminiMp3Thai?.fileName || null,
          GeminiMp3EnglishUrl: step.geminiMp3English?.url && !step.geminiMp3English.url.startsWith('blob:') ? step.geminiMp3English.url : null,
          GeminiMp3EnglishFileName: step.geminiMp3English?.fileName || null,
          GeminiMp3ChineseUrl: step.geminiMp3Chinese?.url && !step.geminiMp3Chinese.url.startsWith('blob:') ? step.geminiMp3Chinese.url : null,
          GeminiMp3ChineseFileName: step.geminiMp3Chinese?.fileName || null,
        })),
      };
    },

    isApiSuccess(response) {
      return !!response && (response.Status === 'Successful' || response.status === 0);
    },

    hasPendingGeniePrefixStepMp3(pattern) {
      return pattern.steps.some((step) =>
        ['mp3Thai', 'mp3English', 'mp3Chinese', 'geminiMp3Thai', 'geminiMp3English', 'geminiMp3Chinese'].some(
          (prop) => step[prop]?.file && step[prop]?.url?.startsWith('blob:')
        )
      );
    },

    async uploadGeniePrefixStepPendingFiles(pattern) {
      const fields = [
        { prop: 'mp3Thai', field: 'thai' },
        { prop: 'mp3English', field: 'english' },
        { prop: 'mp3Chinese', field: 'chinese' },
        { prop: 'geminiMp3Thai', field: 'gemini_thai' },
        { prop: 'geminiMp3English', field: 'gemini_english' },
        { prop: 'geminiMp3Chinese', field: 'gemini_chinese' },
      ];

      for (const step of pattern.steps) {
        const hasPending = fields.some(({ prop }) => step[prop]?.file && step[prop]?.url?.startsWith('blob:'));
        if (!hasPending) continue;

        if (!step.createdAt) {
          throw new Error('Genie prefix step CreatedAt is required before MP3 upload.');
        }

        for (const item of fields) {
          const mp3 = step[item.prop];
          if (!mp3?.file || !mp3?.url?.startsWith('blob:')) continue;

          const formData = new FormData();
          formData.append('entity', mp3.file, mp3.file.name);

          await new Promise((resolve, reject) => {
            this.$call.UploadGeniePrefixMp3(
              { entity: formData, createdAt: step.createdAt, genieField: item.field },
              (response) => {
                if (this.isApiSuccess(response) && (response.Data || response.data)) {
                  URL.revokeObjectURL(mp3.url);
                  mp3.url = response.Data || response.data;
                  mp3.file = null;
                  resolve();
                } else {
                  reject(new Error(response?.Message || response?.message || `Upload failed for ${item.field}`));
                }
              },
              (error) => reject(error)
            );
          });
        }
      }
    },

    async deleteMarkedGeniePrefixPatterns() {
      const deletePromises = this.geniePrefixPatternsToDelete.map((id) => {
        return new Promise((resolve, reject) => {
          this.$call.DeleteGeniePrefixPattern(
            id,
            (response) => {
              if (this.isApiSuccess(response)) {
                resolve(response);
              } else {
                reject(new Error(response?.Message || `Failed to delete genie prefix pattern ${id}.`));
              }
            },
            (error) => {
              console.error(`Error deleting genie prefix pattern ${id}:`, error);
              reject(error);
            }
          );
        });
      });

      await Promise.all(deletePromises);
      this.geniePrefixPatternsToDelete = [];
    },

    // Add new question
    addNewQuestion() {
      const newQuestion = {
        collapsed: false,
        messages: {
          thai: '',
          english: '',
          chinese: '',
        },
        targetGroup: 'all',
        priority: '',
        segment: [],
        wealthMembership: [],
        cifFiles: [], // Initialize CIF files array
        effectiveStartDate: '',
        effectiveEndDate: '',
        questionEnabled: false,
        taxPlanningEnabled: false,
        isNew: true, // Mark as new (not saved to backend yet)
      };
      this.suggestionQuestionConfig.questions.push(newQuestion);
    },

    // Remove question
    removeQuestion(index) {
      if (this.suggestionQuestionConfig.questions.length <= 1) {
        this.$swal.fire({
          title: this.$t('error'),
          text: 'You must keep at least one question.',
          icon: 'warning',
          confirmButtonText: this.$t('ok'),
        });
        return;
      }

      const questionNumber = index + 1;
      const question = this.suggestionQuestionConfig.questions[index];

      // If this question exists in backend (has been saved before), mark it for deletion
      if (this.configurationId !== null && this.configurationId !== undefined && question && !question.isNew) {
        // Add to delete list if not already there
        if (!this.questionsToDelete.includes(question.questionId)) {
          this.questionsToDelete.push(question.questionId);
        }
      }

      // Remove from UI
      this.suggestionQuestionConfig.questions.splice(index, 1);
    },

    // Add new feature
    addNewFeature() {
      const newFeature = {
        collapsed: false,
        messages: {
          thai: '',
          english: '',
          chinese: '',
        },
        modelName: '',
        action: '',
        targetGroup: 'all',
        priority: '',
        segment: [],
        wealthMembership: [],
        cifFiles: [], // Initialize CIF files array
        effectiveStartDate: '',
        effectiveEndDate: '',
        featureEnabled: false,
        taxPlanningEnabled: false,
        imageUrl: '', // For uploaded image
        isNew: true, // Mark as new (not saved to backend yet)
      };
      this.suggestionConfig.features.push(newFeature);
    },

    // Remove feature
    removeFeature(featureData, index) {
      if (this.suggestionConfig.features.length <= 1) {
        this.$swal.fire({
          title: this.$t('error'),
          text: 'You must keep at least one feature.',
          icon: 'warning',
          confirmButtonText: this.$t('ok'),
        });
        return;
      }
      if (this.configurationId !== null && this.configurationId !== undefined && featureData && !featureData.isNew) {
        // Add to delete list if not already there
        if (!this.featuresToDelete.includes(featureData.featureId)) {
          this.featuresToDelete.push(featureData.featureId);
        }
      }

      // Remove from UI
      this.suggestionConfig.features.splice(index, 1);
    },

    async loadConfiguration() {
      this.loading = true;
      this.featuresLoading = true;
      this.questionsLoading = true;

      try {
        // Use $call API instead of direct axios
        await new Promise((resolve, reject) => {
          this.$call.GetMobileConfigurationByCompanyId(
            {
              companyId: 1,
              cifNo: '123456',
              language: 'TH',
              screen: 'HOME',
              segment: 'sa24',
              wealthMembership: 'WP',
              theme: 'dark',
            },
            (response) => {
              if (response && response.status === 0 && response.data) {
                console.log('Loaded mobile configuration:', response.data);
                const config = response.data;
                // Store the configuration ID for updates (handle both uppercase and lowercase)
                // Use !== undefined to handle ID = 0 case
                this.configurationId = config.ID !== undefined ? config.ID : config.id;

                // Map API response to component data
                this.config.languages.thai = config.languageThaiEnabled || false;
                this.config.languages.english = config.languageEnglishEnabled || false;
                this.config.languages.chinese = config.languageChineseEnabled || false;
                this.config.humanMode = config.humanMode || false;
                this.config.ttsEnabled = config.ttsEnabled || false;
                this.config.voice.enabled = config.voiceEnabled || false;
                this.config.voice.type = config.voiceType || 'tts';
                this.config.voice.systemPrompt = config.voiceSystemPrompt || '';
                this.config.voice.geminiSystemPrompt = config.geminiVoiceSystemPrompt || '';
                this.config.voice.speechToTextType = config.speechToTextType || 'device';
                this.config.voice.voiceConfigurationId = config.voiceConfigurationId ?? null;
                this.config.voice.textToSpeechType = config.textToSpeechType || 'default';
                this.config.voice.endOfSpeechDetection = config.endOfSpeechDetection || null;
                this.config.voice.reformatForTTSPrompt = config.reformatForTTSPrompt || '';
                this.config.voice.formatForTTSEnginePrompt = config.formatForTTSEnginePrompt || '';
                this.config.voice.ttsModel = config.ttsModel || 'gpt-5-chat';
                this.config.voice.ttsApiVersion = config.ttsApiVersion || '2025-01-01-preview';
                this.config.copyMessage.enabled = config.copyMessageEnabled || false;
                this.suggestionConfig.enabled = config.suggestionFeatureEnabled || false;
                this.suggestionQuestionConfig.enabled = config.suggestionQuestionEnabled || false;
                this.config.logging.enabled = config.loggingEnabled || false;
                this.config.postMessage.enabled = config.postMessageEnabled || false;
                this.postMessageText = config.postMessage;
                this.postMessageTextEN = config.postMessageEN;
                this.postMessageTextCN = config.postMessageCN;
                this.postMessageColor = config.postMessageColor || '';

                // Load selected model (single value)
                this.selectedModel = config.selectedModel || null;
                this.taxPlanningSelectedModel = config.taxPlanningSelectedModel || null;

                // Load mobile information
                this.appTitle = config.appTitle || '';
                this.mobileInformationHeader = config.mobileInformationHeader || '';
                this.mobileInformation = config.mobileInformation || '';
                this.mobileInformationEN = config.mobileInformationEN || '';

                // Load timeout configuration
                this.timeoutDuration = config.timeoutDuration || null;
                this.timeoutMessage = config.timeoutMessage || '';
                this.timeoutMessageEN = config.timeoutMessageEN || '';
                this.timeoutMessageCN = config.timeoutMessageCN || '';

                // Load suggest bar configuration
                this.suggestBarText = config.suggestBarText || '';
                this.suggestBarTextEN = config.suggestBarTextEN || '';
                this.suggestBarTextCN = config.suggestBarTextCN || '';

                // Load cache configuration
                this.config.enableCache = config.enableCache || false;
                this.config.cacheTTLMinutes = config.cacheTTLMinutes || 1440;
                this.config.cacheScope = config.cacheScope || 'shared';
                this.config.enableSemanticCache = config.enableSemanticCache || false;
                this.config.similarityThreshold = config.similarityThreshold || 0.95;

                // Load suggestion features if available
                if (config.suggestionFeatures && config.suggestionFeatures.length > 0) {
                  this.suggestionConfig.features = config.suggestionFeatures.map((feature, index) => ({
                    collapsed: false,
                    featureId: feature.id, // Store original feature number
                    messages: {
                      thai: feature.messageThai || '',
                      english: feature.messageEnglish || '',
                      chinese: feature.messageChinese || '',
                    },
                    modelName: feature.modelName || '',
                    action: feature.action || '',
                    targetGroup: feature.targetGroup || 'all',
                    priority: feature.priority || '',
                    segment: feature.segment ? feature.segment.split(',') : [],
                    wealthMembership: feature.wealthMembership ? feature.wealthMembership.split(',') : [],
                    effectiveStartDate: this.formatDateForInput(feature.effectiveStartDate) || '',
                    effectiveEndDate: this.formatDateForInput(feature.effectiveEndDate) || '',
                    featureEnabled: feature.featureEnabled || false,
                    taxPlanningEnabled: feature.taxPlanningEnabled || false,
                    imageUrl: feature.iconPath || '', // Load the image URL from API
                    cifFiles: feature.cifFiles
                      ? feature.cifFiles.map((cifFile) => ({
                          fileName: cifFile.fileName || '',
                          filePath: cifFile.filePath || '',
                          cifList: cifFile.cifList || [],
                          uploadDate: cifFile.uploadDate ? new Date(cifFile.uploadDate) : new Date(),
                          fileSize: cifFile.fileSize || 0,
                        }))
                      : [], // Load CIF files from API
                    isNew: false, // Mark as existing (from backend)
                  }));
                } else {
                  // Initialize with one empty feature if no features from API
                  this.suggestionConfig.features = [
                    {
                      collapsed: false,
                      messages: {
                        thai: '',
                        english: '',
                        chinese: '',
                      },
                      modelName: '',
                      action: '',
                      targetGroup: 'all',
                      priority: '',
                      segment: '',
                      wealthMembership: '',
                      effectiveStartDate: '',
                      effectiveEndDate: '',
                      featureEnabled: false,
                      taxPlanningEnabled: false,
                      imageUrl: '',
                      isNew: true, // Mark as new
                    },
                  ];
                }

                // Load suggestion questions if available
                if (config.suggestionQuestions && config.suggestionQuestions.length > 0) {
                  this.suggestionQuestionConfig.questions = config.suggestionQuestions.map((question, index) => ({
                    collapsed: false,
                    messages: {
                      thai: question.messageThai || '',
                      english: question.messageEnglish || '',
                      chinese: question.messageChinese || '',
                    },
                    targetGroup: question.targetGroup || 'all',
                    priority: question.priority || '',
                    segment: question.segment ? question.segment.split(',') : [],
                    wealthMembership: question.wealthMembership ? question.wealthMembership.split(',') : [],
                    effectiveStartDate: this.formatDateForInput(question.effectiveStartDate) || '',
                    effectiveEndDate: this.formatDateForInput(question.effectiveEndDate) || '',
                    questionEnabled: question.questionEnabled || false,
                    taxPlanningEnabled: question.taxPlanningEnabled || false,
                    cifFiles: question.cifFiles
                      ? question.cifFiles.map((cifFile) => ({
                          fileName: cifFile.fileName || '',
                          filePath: cifFile.filePath || '',
                          cifList: cifFile.cifList || [],
                          uploadDate: cifFile.uploadDate ? new Date(cifFile.uploadDate) : new Date(),
                          fileSize: cifFile.fileSize || 0,
                        }))
                      : [], // Load CIF files from API
                    questionId: question.id, // Store original question ID
                    isNew: false, // Mark as existing (from backend)
                  }));
                } else {
                  // Initialize with one empty question if no questions from API
                  this.suggestionQuestionConfig.questions = [
                    {
                      collapsed: false,
                      messages: {
                        thai: '',
                        english: '',
                        chinese: '',
                      },
                      targetGroup: 'all',
                      priority: '',
                      segment: '',
                      wealthMembership: '',
                      effectiveStartDate: '',
                      effectiveEndDate: '',
                      questionEnabled: false,
                      taxPlanningEnabled: false,
                      isNew: true, // Mark as new
                    },
                  ];
                }

                // Load genie AI characters if available
                if (config.genieAICharacters && config.genieAICharacters.length > 0) {
                  this.genieCharacters = config.genieAICharacters.map((character) => ({
                    collapsed: false,
                    id: character.id,
                    characterName: character.characterName || '',
                    effectiveStartDate: this.formatDateForInput(character.effectiveStartDate) || '',
                    effectiveEndDate: this.formatDateForInput(character.effectiveEndDate) || '',
                    isActive: character.isActive !== undefined ? character.isActive : true,
                    showInProactiveMode: character.showInProactiveMode || false,
                    taxPlanningEnabled: character.taxPlanningEnabled || false,
                    iconProactiveUrl: character.iconProactiveUrl || '',
                    iconChatFirstUrl: character.iconChatFirstUrl || '',
                    iconChatUrl: character.iconChatUrl || '',
                    iconVoicePageUrl: character.iconVoicePageUrl || '',
                    iconValidationTouched: false,
                    isNew: false,
                    pendingFiles: {},
                  }));
                } else {
                  this.genieCharacters = [
                    {
                      collapsed: false,
                      characterName: '',
                      effectiveStartDate: '',
                      effectiveEndDate: '',
                      isActive: true,
                      showInProactiveMode: false,
                      taxPlanningEnabled: false,
                      iconProactiveUrl: '',
                      iconChatFirstUrl: '',
                      iconChatUrl: '',
                      iconVoicePageUrl: '',
                      iconValidationTouched: false,
                      isNew: true,
                      pendingFiles: {},
                    },
                  ];
                }

                // Load genie prefix patterns if available
                this.geniePrefixPatterns = this.mapGeniePrefixPatterns(config.geniePrefixPatterns || []);
                this.expandedGeniePrefixPatterns = [];
                this.geniePrefixPatternsToDelete = [];

                // Wake words (#786)
                this.wakeWords = [...(config.wakeWords ?? config.WakeWords ?? [])];
                this.wakeWordsLoadError = false;

                resolve(response);
              } else if (response && response.Status === 'Error') {
                console.warn('No mobile configuration found for this company');
                // Keep default values
                this.wakeWordsLoadError = false;
                resolve(response);
              } else {
                reject(new Error('Invalid response format'));
              }
            },
            (error) => {
              console.error('Failed to load configuration:', error);
              reject(error);
            }
          );
        });

        this.captureHistoryBaseline();

        // Simulate realistic loading delays for better UX
        await new Promise((resolve) => setTimeout(resolve, 500)); // Features loading
        this.featuresLoading = false;

        await new Promise((resolve) => setTimeout(resolve, 300)); // Questions loading
        this.questionsLoading = false;
      } catch (error) {
        console.error('Failed to load configuration:', error);

        if (error.response?.status === 401) {
          console.error('401 Unauthorized - Authentication required');
          this.$swal
            .fire({
              title: this.$t('error'),
              text: 'Authentication required. Please login again.',
              icon: 'error',
              confirmButtonText: this.$t('ok'),
            })
            .then(() => {
              // Redirect to home or refresh page
              window.location.href = '/';
            });
          return;
        }

        // Set default values if loading fails
        this.config = {
          languages: { thai: true, english: true, chinese: false },
          voice: { enabled: true, type: 'tts' },
          copyMessage: { enabled: true },
        };

        this.featuresLoading = false;
        this.questionsLoading = false;
        // Block wake word editing: saving [] here would wipe the real list (#786)
        this.wakeWordsLoadError = true;
        this.captureHistoryBaseline();
      } finally {
        this.loading = false;
        this.wakeWordsLoading = false;
      }
    },

    // Get options for dropdowns (similar to ProactiveMessage)
    async GetOptions() {
      return new Promise((resolve, reject) => {
        this.$call.GetProactiveMessageOptions(
          (dataResponse) => {
            if (dataResponse.status === 0) {
              this.segmentOptions = dataResponse.data.segmentOptions || [];
              this.wealthMembershipOptions = dataResponse.data.wealthMembershipOptions || [];
              resolve(dataResponse);
            } else {
              reject(new Error('Failed to load options'));
            }
          },
          (errorResource) => {
            console.error('Error getting options:', errorResource);
            // Set default options if API fails
            this.segmentOptions = ['Retail', 'Premium', 'VIP'];
            this.wealthMembershipOptions = ['Standard', 'Wealth', 'Wealth Plus', 'Elite'];
            resolve({ status: 0, data: { segmentOptions: this.segmentOptions, wealthMembershipOptions: this.wealthMembershipOptions } });
          }
        );
      });
    },

    // Handle selection in the Action dropdown, including the appended "Add Action" entry
    handleActionSelect(feature, value) {
      if (value === this.ADD_ACTION_VALUE) {
        this.showSuggestionActionManager = true;
        return;
      }
      feature.action = value;
    },

    // Load suggestion action options (IsTaxPlanningMode = false)
    async GetSuggestionActions() {
      return new Promise((resolve) => {
        this.$call.GetSuggestionActions(
          (dataResponse) => {
            this.actionOptions = (dataResponse && dataResponse.data) || [];
            resolve(dataResponse);
          },
          (errorResource) => {
            console.error('Error getting suggestion actions:', errorResource);
            this.actionOptions = [];
            resolve({ status: 0, data: [] });
          }
        );
      });
    },

    // Date formatting methods (similar to ProactiveMessage)
    formatDate(dateString) {
      if (!dateString) return '';
      return moment(dateString).format('DD/MM/YYYY');
    },

    formatDateForAPI(dateString) {
      if (!dateString) return null;
      return moment(dateString).format('YYYY-MM-DDTHH:mm:ss');
    },

    formatDateForInput(dateString) {
      if (!dateString) return '';
      return moment(dateString).format('YYYY-MM-DDTHH:mm');
    },

    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }

      this.today = dd + '/' + mm + '/' + yyyy;

      // Initialize date picker with current date
      this.endDate = yyyy + '-' + (mm < 10 ? '0' + mm : mm) + '-' + (dd < 10 ? '0' + dd : dd);

      // Set start date to beginning of current month
      this.startDate = yyyy + '-' + (mm < 10 ? '0' + mm : mm) + '-01';

      // Initialize selected dates array
      this.selectedDates = [this.startDate, this.endDate];
    },
    updateDateRange(dates) {
      if (dates && dates.length > 0) {
        // Sort dates to ensure proper start and end
        const sortedDates = dates.sort((a, b) => new Date(a) - new Date(b));
        this.startDate = sortedDates[0];
        this.endDate = sortedDates[sortedDates.length - 1];

        // If only one date selected, use it as both start and end
        if (sortedDates.length === 1) {
          this.endDate = this.startDate;
        }

        // Close menu after selection of 2 dates
        if (sortedDates.length >= 2) {
          this.datePickerMenu = false;
        }
      }
    },
    formatDisplayDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-GB'); // DD/MM/YYYY format
    },
    validatePriority(event, item) {
      // Only allow digits 0-9
      const value = event.target ? event.target.value : event;
      const numericValue = value.replace(/[^0-9]/g, '');
      item.priority = numericValue;
    },

    // ============ CIF File Management Methods ============

    // Download CIF Template
    downloadCifTemplate() {
      const csvContent = 'cif\n12345678901\n23456789012\n34567890123';
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');

      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', 'cif_template.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        this.$swal.fire({
          icon: 'success',
          title: 'Template Downloaded',
          text: 'CIF template file has been downloaded successfully!',
          timer: 1500,
          showConfirmButton: false,
        });
      }
    },

    // Feature CIF Upload Methods
    triggerFeatureCifUpload(index) {
      this.currentFeatureIndexForCif = index;
      this.$refs.featureCifInput.click();
    },

    handleFeatureCifUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      const featureIndex = this.currentFeatureIndexForCif;
      if (featureIndex === null || featureIndex === undefined) return;

      const feature = this.suggestionConfig.features[featureIndex];
      if (!feature) return;

      // Validate file type
      const allowedTypes = ['text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];
      if (!allowedTypes.includes(file.type)) {
        this.$swal.fire({
          icon: 'warning',
          title: 'Invalid File Type',
          text: 'Please upload only CSV or Excel files',
        });
        return;
      }

      // Validate file size (5MB)
      const maxSize = 5 * 1024 * 1024;
      if (file.size > maxSize) {
        this.$swal.fire({
          icon: 'warning',
          title: 'File Too Large',
          text: 'File size should not exceed 5MB',
        });
        return;
      }

      // Initialize cifFiles array if needed
      if (!feature.cifFiles) {
        feature.cifFiles = [];
      }

      // Check for duplicate file name
      const existingFile = feature.cifFiles.find((f) => f.fileName === file.name);
      if (existingFile) {
        this.$swal.fire({
          icon: 'warning',
          title: 'Duplicate File',
          text: 'A file with this name has already been uploaded. Please rename the file or remove the existing one.',
        });
        return;
      }

      // Upload file to server
      const formData = new FormData();
      formData.append('file', file);

      this.$call.UploadCifFile(
        formData,
        (dataResponse) => {
          if (dataResponse.status === 0) {
            const newCifFile = {
              fileName: dataResponse.data.fileName || file.name,
              filePath: dataResponse.data.fileUrl,
              cifList: dataResponse.data.cifList || [],
              uploadDate: new Date(),
              fileSize: file.size,
            };

            feature.cifFiles.push(newCifFile);

            this.$swal.fire({
              icon: 'success',
              title: 'Success',
              text: `File uploaded successfully. Found ${dataResponse.data.cifCount || 0} CIF codes.`,
              timer: 2000,
              showConfirmButton: false,
            });

            // Reset file input
            this.$refs.featureCifInput.value = '';
            this.currentFeatureIndexForCif = null;
          } else {
            this.$swal.fire({
              icon: 'error',
              title: 'Error',
              text: dataResponse.message || 'Failed to upload file',
            });
          }
        },
        (errorResource) => {
          console.error('Error uploading file:', errorResource);
          this.$swal.fire({
            icon: 'error',
            title: 'Error',
            text: errorResource.response?.data?.error || 'Failed to upload file',
          });
        }
      );
    },

    removeFeatureCifFile(featureIndex, fileIndex) {
      const fileName = this.suggestionConfig.features[featureIndex].cifFiles[fileIndex].fileName;
      this.suggestionConfig.features[featureIndex].cifFiles.splice(fileIndex, 1);

      this.$swal.fire({
        icon: 'info',
        title: 'File Removed',
        html: `"<strong>${fileName}</strong>" removed.<br><small style="color: #ff9800;">⚠️ Remember to click Save to confirm changes.</small>`,
        timer: 3500,
        showConfirmButton: false,
        toast: true,
        position: 'top-end',
        timerProgressBar: true,
      });
    },

    clearAllFeatureCifFiles(featureIndex) {
      const feature = this.suggestionConfig.features[featureIndex];
      const fileCount = feature.cifFiles.length;
      feature.cifFiles = [];

      this.$swal.fire({
        icon: 'info',
        title: 'All Files Removed',
        html: `<strong>${fileCount} files</strong> removed.<br><small style="color: #ff9800;">⚠️ Remember to click Save to confirm changes.</small>`,
        timer: 3500,
        showConfirmButton: false,
        toast: true,
        position: 'top-end',
        timerProgressBar: true,
      });
    },

    downloadFeatureCifFile(file) {
      if (!file || !file.filePath) {
        this.$swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No file available for download',
        });
        return;
      }

      this.$call.DownloadCifFile(
        file.filePath,
        file.fileName,
        (blobData) => {
          const url = URL.createObjectURL(new Blob([blobData]));
          const link = document.createElement('a');
          link.href = url;
          link.download = file.fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);

          this.$swal.fire({
            icon: 'success',
            title: 'Downloading',
            text: 'File download started successfully!',
            timer: 1500,
            showConfirmButton: false,
          });
        },
        (errorResource) => {
          console.error('Error downloading file:', errorResource);
          this.$swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Failed to download file',
          });
        }
      );
    },

    getTotalFeatureCifCodes(feature) {
      if (!feature.cifFiles || feature.cifFiles.length === 0) return 0;
      return feature.cifFiles.reduce((total, file) => {
        return total + (file.cifList ? file.cifList.length : 0);
      }, 0);
    },

    // Question CIF Upload Methods
    triggerQuestionCifUpload(index) {
      this.currentQuestionIndexForCif = index;
      this.$refs.questionCifInput.click();
    },

    handleQuestionCifUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      const questionIndex = this.currentQuestionIndexForCif;
      if (questionIndex === null || questionIndex === undefined) return;

      const question = this.suggestionQuestionConfig.questions[questionIndex];
      if (!question) return;

      // Validate file type
      const allowedTypes = ['text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];
      if (!allowedTypes.includes(file.type)) {
        this.$swal.fire({
          icon: 'warning',
          title: 'Invalid File Type',
          text: 'Please upload only CSV or Excel files',
        });
        return;
      }

      // Validate file size (5MB)
      const maxSize = 5 * 1024 * 1024;
      if (file.size > maxSize) {
        this.$swal.fire({
          icon: 'warning',
          title: 'File Too Large',
          text: 'File size should not exceed 5MB',
        });
        return;
      }

      // Initialize cifFiles array if needed
      if (!question.cifFiles) {
        question.cifFiles = [];
      }

      // Check for duplicate file name
      const existingFile = question.cifFiles.find((f) => f.fileName === file.name);
      if (existingFile) {
        this.$swal.fire({
          icon: 'warning',
          title: 'Duplicate File',
          text: 'A file with this name has already been uploaded. Please rename the file or remove the existing one.',
        });
        return;
      }

      // Upload file to server
      const formData = new FormData();
      formData.append('file', file);

      this.$call.UploadCifFile(
        formData,
        (dataResponse) => {
          if (dataResponse.status === 0) {
            const newCifFile = {
              fileName: dataResponse.data.fileName || file.name,
              filePath: dataResponse.data.fileUrl,
              cifList: dataResponse.data.cifList || [],
              uploadDate: new Date(),
              fileSize: file.size,
            };

            question.cifFiles.push(newCifFile);

            this.$swal.fire({
              icon: 'success',
              title: 'Success',
              text: `File uploaded successfully. Found ${dataResponse.data.cifCount || 0} CIF codes.`,
              timer: 2000,
              showConfirmButton: false,
            });

            // Reset file input
            this.$refs.questionCifInput.value = '';
            this.currentQuestionIndexForCif = null;
          } else {
            this.$swal.fire({
              icon: 'error',
              title: 'Error',
              text: dataResponse.message || 'Failed to upload file',
            });
          }
        },
        (errorResource) => {
          console.error('Error uploading file:', errorResource);
          this.$swal.fire({
            icon: 'error',
            title: 'Error',
            text: errorResource.response?.data?.error || 'Failed to upload file',
          });
        }
      );
    },

    removeQuestionCifFile(questionIndex, fileIndex) {
      const fileName = this.suggestionQuestionConfig.questions[questionIndex].cifFiles[fileIndex].fileName;
      this.suggestionQuestionConfig.questions[questionIndex].cifFiles.splice(fileIndex, 1);

      this.$swal.fire({
        icon: 'info',
        title: 'File Removed',
        html: `"<strong>${fileName}</strong>" removed.<br><small style="color: #ff9800;">⚠️ Remember to click Save to confirm changes.</small>`,
        timer: 3500,
        showConfirmButton: false,
        toast: true,
        position: 'top-end',
        timerProgressBar: true,
      });
    },

    clearAllQuestionCifFiles(questionIndex) {
      const question = this.suggestionQuestionConfig.questions[questionIndex];
      const fileCount = question.cifFiles.length;
      question.cifFiles = [];

      this.$swal.fire({
        icon: 'info',
        title: 'All Files Removed',
        html: `<strong>${fileCount} files</strong> removed.<br><small style="color: #ff9800;">⚠️ Remember to click Save to confirm changes.</small>`,
        timer: 3500,
        showConfirmButton: false,
        toast: true,
        position: 'top-end',
        timerProgressBar: true,
      });
    },

    downloadQuestionCifFile(file) {
      if (file && file.filePath) {
        const link = document.createElement('a');
        link.href = file.filePath;
        link.download = file.fileName;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.$swal.fire({
          icon: 'success',
          title: 'Downloading',
          text: 'File download started successfully!',
          timer: 1500,
          showConfirmButton: false,
        });
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No file available for download',
        });
      }
    },

    getTotalQuestionCifCodes(question) {
      if (!question.cifFiles || question.cifFiles.length === 0) return 0;
      return question.cifFiles.reduce((total, file) => {
        return total + (file.cifList ? file.cifList.length : 0);
      }, 0);
    },

    // Helper methods for file display
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },

    formatUploadDate(date) {
      if (!date) return '';
      const d = new Date(date);
      return d.toLocaleDateString() + ' ' + d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    },

    // Load GPT Models for dropdown
    loadGPTModels() {
      return new Promise((resolve, reject) => {
        this.$call.DDGPTModel(
          (dataResponse) => {
            if (dataResponse.status === 0) {
              this.aiModelOptions = dataResponse.data.map((m) => ({
                name: m.name,
                value: m.modelDisplayID,
                modelId: m.id,
                icon: 'mdi-robot',
                color: '#10a37f',
                searchableText: `${m.modelDisplayID}: ${m.name}`,
              }));
              this.uniqueAiModelOptions = this.aiModelOptions.filter((option, index, self) => index === self.findIndex((t) => t.value === option.value));
            } else {
              this.aiModelOptions = [];
            }
            resolve();
          },
          (err) => {
            this.aiModelOptions = [];
            reject(err);
          }
        );
      });
    },

    // Title shown for a voice configuration option, e.g. "#1 — LHB Production"
    voiceConfigItemTitle(item) {
      if (!item) return '';
      return `#${item.displayId} — ${item.name}`;
    },

    // Load the voice settings bundles managed in LH Bank Configuration › Voice Configs
    loadVoiceConfigurations() {
      return new Promise((resolve) => {
        this.$call.GetDDVoiceConfiguration(
          (dataResponse) => {
            if (dataResponse && dataResponse.status === 0) {
              this.voiceConfigOptions = dataResponse.data || [];
            } else {
              console.error('Failed to load voice configurations:', dataResponse);
              this.voiceConfigOptions = [];
            }
            resolve();
          },
          (errorResource) => {
            console.error('Error getting voice configurations:', errorResource);
            this.voiceConfigOptions = [];
            resolve();
          }
        );
      });
    },
  },

  async mounted() {
    // Check if call API is available
    if (!this.$call) {
      console.error('Call API is not available. Please ensure it is properly configured.');
      this.$swal.fire({
        title: this.$t('error'),
        text: 'Application not properly configured. Please refresh the page.',
        icon: 'error',
        confirmButtonText: this.$t('ok'),
      });
      return;
    }

    // Load dropdown options first
    await this.GetOptions();
    await this.GetSuggestionActions();
    await this.loadGPTModels();
    await this.loadVoiceConfigurations();

    await this.loadConfiguration();
    this.GetDate();
  },
};
</script>

<style scoped>
.configuration-tabs-bar {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.configuration-tabs {
  flex: 1 1 auto;
  min-width: 0;
}

.history-log-button {
  flex: 0 0 auto;
  min-height: 40px;
}

.history-filter-row {
  align-items: center;
  margin-bottom: 12px;
}

.history-note-cell {
  white-space: normal;
  line-height: 1.4;
  min-width: 260px;
  max-width: 560px;
  padding: 8px 0;
}

.history-log-table :deep(.v-data-table__td) {
  vertical-align: top;
}

.history-changes-table {
  border: 1px solid #e1e1e1;
  border-radius: 8px;
}

.history-changes-table :deep(.v-table__wrapper) {
  overflow-x: auto;
}

.history-field-cell {
  min-width: 220px;
  font-weight: 600;
  vertical-align: top;
}

.history-value-button {
  align-items: flex-start;
  justify-content: flex-start;
  max-width: 330px;
  min-height: 36px;
  padding: 6px 8px;
  text-align: left;
  text-transform: none;
  white-space: normal;
}

.history-full-value {
  max-height: 60vh;
  margin: 0;
  overflow: auto;
  padding: 16px;
  border: 1px solid #e1e1e1;
  border-radius: 8px;
  background: #fafafa;
  color: #222;
  font-family: inherit;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

@media (max-width: 1100px) {
  .configuration-tabs-bar {
    align-items: stretch;
    flex-direction: column;
  }

  .history-log-button {
    align-self: flex-end;
  }

  .history-value-button {
    max-width: 220px;
  }
}

.gradient-bar {
  height: 1px;
  width: auto;
  background: linear-gradient(90deg, #d56796 0%, #345296 100%);
}

.language-option {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.language-config-title {
  font-size: 24px;
  font-weight: 600;
  color: #333;
}

.language-config-subtitle {
  font-size: 18px;
  color: #666;
  margin-bottom: 20px;
}

.language-switches {
  padding-left: 0;
}

.voice-sub-options {
  margin-left: 32px;
  margin-top: 12px;
  padding-left: 16px;
  border-left: 2px solid #f0f0f0;
}

.voice-system-prompt-section {
  background: linear-gradient(135deg, rgba(78, 57, 130, 0.05) 0%, rgba(52, 82, 150, 0.05) 100%);
  border-radius: 8px;
  padding: 16px;
  border-left: 4px solid #4e3982;
}

.voice-prompt-label {
  display: block;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
  letter-spacing: 0.3px;
}

.voice-prompt-textarea {
  border: 1px solid #e0e0e0;
  padding: 0px 5px 5px 15px;
  background-color: #ffffff;
  border-radius: 8px;
}

.voice-prompt-textarea :deep(.v-field) {
  border: none !important;
  box-shadow: none !important;
}

/* App Header Section in Mobile Preview */
.app-header-section {
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  margin-bottom: 0;
}

.app-header-section .v-icon {
  transition: opacity 0.2s ease;
}

.app-header-section .v-icon:hover {
  opacity: 1 !important;
}

.mobile-preview-container {
  position: sticky;
  top: 20px;
}

.mobile-mockup {
  width: 280px;
  height: 580px;
  background: linear-gradient(135deg, #5a9fd7 0%, #4a8bc2 100%);
  border-radius: 30px;
  padding: 6px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25), 0 4px 16px rgba(90, 159, 215, 0.3);
}

.mobile-screen {
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 24px;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
}

.mobile-header {
  background: linear-gradient(135deg, #5a9fd7 0%, #4a8bc2 100%);
  color: white;
}

.status-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px 4px;
  font-size: 14px;
  font-weight: 600;
}

.status-icons {
  display: flex;
  gap: 4px;
}

.time {
  font-weight: 600;
  font-size: 14px;
}

.app-header {
  display: flex;
  align-items: center;
  padding: 8px 16px 12px;
}

.header-title-mobile {
  font-size: 16px;
  font-weight: 600;
  margin-left: 8px;
  color: white;
}

.chat-content {
  flex: 1;
  background: linear-gradient(180deg, #2d3748 0%, #1a202c 100%);
  position: relative;
}

.language-flags {
  display: flex;
  justify-content: center;
  gap: 12px;
  padding: 12px;
  background: white;
  border-top: 1px solid #e0e0e0;
}

.flag-option {
  cursor: pointer;
  transition: transform 0.2s;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.flag-option:hover {
  transform: scale(1.1);
}

.input-area {
  background: white;
  padding: 12px 16px 16px;
  border-top: 1px solid #e0e0e0;
}

.input-container {
  display: flex;
  align-items: center;
  background: #f8f9fa;
  border-radius: 25px;
  padding: 10px 16px;
  gap: 8px;
  border: 1px solid #e9ecef;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.message-input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
  color: #666;
}

.message-input::placeholder {
  color: #adb5bd;
  font-size: 14px;
}

.voice-icon,
.send-icon {
  cursor: pointer;
  transition: color 0.2s;
}

.voice-icon:hover,
.send-icon:hover {
  color: #4a8bc2 !important;
}

.bs {
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.header-title {
  color: white;
}

.mobile-preview-simulator {
  width: 268px;
  height: 582px;
  border-radius: 40px;
  overflow: hidden;
  position: relative;
  background-image: url('/lhb/LHB_BG.png');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.sug-simulator {
  width: 268px;
  height: 582px;
  border-radius: 40px;
  overflow: hidden;
  position: relative;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.sug-simulator-bg {
  background-image: url('/lhb/preview-bg1.png');
}

.sug-simulator-bg-without-mic {
  background-image: url('/lhb/preview-bg1.png');
}

.feature-card {
  width: 48px;
  transition: transform 0.2s, box-shadow 0.2s;
}

.feature-card:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.question-card:hover {
  transform: scale(1.02);
  background: rgba(70, 57, 130, 0.9) !important;
}

.sug-quest-simulator {
  width: 268px;
  height: 582px;
  border-radius: 40px;
  overflow: hidden;
  position: relative;
  background-image: url('/lhb/sug_feat.png');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.feature-card-static {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.grow {
  flex-grow: 1;
}

.grow-0 {
  flex-grow: 0;
}

.form-label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
  display: block;
}

.feature-section {
  background-color: #f3f3f3;
  border-radius: 16px !important;
  border: none !important;
}

.suggestion-form .v-input--radio-group--row .v-radio {
  margin-right: 16px;
}

.suggestion-form .v-input--radio-group--row .v-input--radio-group__input {
  margin-bottom: 0;
}

/* Skeleton Loader Styles */
.mobile-skeleton {
  border-radius: 40px !important;
  overflow: hidden;
}

.mobile-skeleton .v-skeleton-loader__image {
  border-radius: 40px;
}

/* Loading States */
.skeleton-container {
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

/* Smooth transitions when content loads */
.configuration-content {
  transition: opacity 0.3s ease-in-out;
}

.configuration-content.loading {
  opacity: 0;
}

.configuration-content.loaded {
  opacity: 1;
}

/* Vue Advanced Cropper CSS - Custom styling for 1:1 aspect ratio cropping */
.crop-container {
  position: relative;
  max-width: 100%;
  max-height: 400px;
  overflow: hidden;
  background: #f8f9fa;
  border-radius: 8px;
}

.cropper {
  height: 400px;
  width: 100%;
}

/* Custom theme colors to match app */
.vue-advanced-cropper__stencil {
  border: 2px solid #4e3982 !important;
}

.vue-advanced-cropper__handler {
  background: #4e3982 !important;
  border: 2px solid #4e3982 !important;
}

.vue-advanced-cropper__line {
  background: #4e3982 !important;
}

.vue-advanced-cropper__background {
  background: rgba(0, 0, 0, 0.5) !important;
}

/* Field label styling */
.field-label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: #4a5568;
  margin-bottom: 8px;
}

/* Custom input styling */
.custom-input {
  width: 100%;
  height: 45px;
  padding: 8px 16px;
  border: 1px solid #bec2ca;
  border-radius: 16px;
  background-color: white;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s ease;
}

.custom-input:focus {
  border-color: #643990;
  outline: none;
}

.custom-input::placeholder {
  color: #9e9e9e;
}

/* Error styling for inputs */
.custom-input.input-error {
  border-color: #f44336;
  background-color: #ffebee;
}

.error-message {
  color: #f44336;
  font-size: 12px;
  margin-top: 4px;
}

/* Custom select styling */
.custom-select :deep(.v-field) {
  border-radius: 16px !important;
  background-color: white;
  height: 45px;
  border: 1px solid #bec2ca;
  box-shadow: none !important;
}

.custom-select :deep(.v-field--focused) {
  border-color: #643990;
}

.custom-select :deep(.v-field__input) {
  padding: 8px 16px;
  font-size: 14px;
  min-height: auto;
  padding-left: 16px !important;
  height: 100% !important;
}

.custom-select :deep(.v-select__selection-text) {
  font-size: 14px;
}

.custom-select :deep(.v-field__append-inner) {
  padding-right: 0px;
}

.custom-select :deep(.v-field__overlay) {
  display: none;
}

/* Custom select dropdown menu styling */
.custom-select :deep(.v-overlay__content) {
  border-radius: 16px !important;
  overflow: hidden;
}

.custom-select :deep(.v-list) {
  border-radius: 16px !important;
  padding: 8px 0;
}

.custom-select :deep(.v-list-item) {
  padding: 8px 16px;
  min-height: 40px;
}

.custom-select :deep(.v-list-item:hover) {
  background-color: #f5f5f5;
}

.custom-select :deep(.v-list-item--active) {
  background-color: #f0e6f6 !important;
  color: #643990 !important;
}

.custom-select :deep(.v-list-item__overlay) {
  display: none !important;
}

.custom-select :deep(.v-list-item .v-list-item__overlay) {
  opacity: 0 !important;
}

.SuggestFeatureIcon {
  background: linear-gradient(135deg, #4c4f98 30%, #191a32 100%) !important;
  border-radius: 12px;
  border: solid 2px #bcbec0;
  padding: 6px;
  height: 90px;
  width: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Allow sticky to work: v-card, v-window and v-window-item have overflow:hidden
   by default which blocks sticky. Safe to remove since we disabled the slide transition
   and border-radius clipping is not needed here. */
.bs {
  overflow: visible !important;
}

:deep(.v-window),
:deep(.v-window__container),
:deep(.v-window-item) {
  overflow: visible !important;
}

/* Preview column must STRETCH (not flex-start) so the containing block is as tall
   as the form column — sticky needs a tall parent to have scroll range to work with */
.split-preview-col {
  align-self: stretch;
}

.mobile-preview-sticky {
  position: sticky;
  top: 20px;
  max-height: calc(100vh - 40px);
  overflow-y: auto;
  scrollbar-width: none;
}

.mobile-preview-sticky::-webkit-scrollbar {
  display: none;
}
.postMsg {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

/* Model Selector Styles */
.model-option {
  padding: 8px 0;
}

.model-icon-small {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Modern Input Styles for Model Dropdown */
.modern-input :deep(.v-field) {
  border-radius: 14px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
}

.modern-input :deep(.v-field--focused) {
  transform: translateY(-1px);
}

.modern-input :deep(.v-field__outline) {
  --v-field-border-opacity: 0.15;
}

.modern-input :deep(.v-field--focused .v-field__outline) {
  --v-field-border-opacity: 1;
  color: rgb(102, 126, 234) !important;
  --v-field-border-width: 2px;
}

.modern-input :deep(.v-label) {
  font-weight: 500;
}

/* Cache Config Section Styles */
.cache-config-section {
  padding: 16px;
  background: #fafafa;
  border-radius: 12px;
  margin-bottom: 16px;
}

.cache-section-label {
  font-size: 13px;
  font-weight: 600;
  color: #1976d2;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding-left: 12px;
  border-left: 3px solid #1976d2;
}

.switch-option-compact {
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.2s ease;
}

.switch-option-compact:hover {
  border-color: #bdbdbd;
}

.switch-active-bg {
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.08) 0%, rgba(25, 118, 210, 0.04) 100%);
}

.switch-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.switch-description {
  font-size: 11.5px;
  color: #757575;
}

.cache-config-input :deep(.v-field) {
  border-radius: 12px !important;
}

.slider-label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
}

.modern-table :deep(.v-table__wrapper) {
  max-height: 600px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(25, 118, 210, 0.3) rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper thead th) {
  position: sticky;
  top: 0;
  z-index: 2;
  background: rgb(var(--v-theme-surface, 255, 255, 255));
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar) {
  width: 6px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-track) {
  background: rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb) {
  background: rgba(25, 118, 210, 0.3);
  border-radius: 3px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb:hover) {
  background: rgba(25, 118, 210, 0.5);
}

/* Genie AI Character Styles */
.genie-icon-upload-box {
  width: 100%;
  aspect-ratio: 1;
  border: 2px dashed #ccc;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  transition: border-color 0.2s ease, background-color 0.2s ease;
  background-color: #fafafa;
}

.genie-icon-upload-box:hover {
  border-color: #4E3982;
  background-color: #f0ecf6;
}

.genie-icon-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.genie-preview-container {
  width: 300px;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.genie-preview-card {
  width: 100%;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

.genie-preview-empty {
  width: 100%;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

.genie-preview-label {
  font-size: 12px;
  font-weight: 500;
  color: #666;
  margin-bottom: 8px;
}

.genie-preview-icon-frame {
  width: 100%;
  aspect-ratio: 1;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: #fafafa;
}

/* Genie Prefix Pattern (Think Loader) Styles */
.genie-prefix-file-name-col {
  font-size: 10px;
  color: #333;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  text-align: center;
}

.genie-step-upload-box {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  border: 2px dashed #e57373;
  background-color: #fff8f8;
  border-radius: 8px;
  padding: 10px 8px;
  font-size: 11px;
  font-weight: 600;
  color: #c62828;
  cursor: pointer;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.genie-step-upload-box:hover {
  border-color: #c62828;
  background-color: #ffefef;
}
</style>
